<template>
    <div class="post-tip-container">
        <div v-if="loading" style="height: 10px;">
            <b-progress :value="current_counter" :max="100" animated></b-progress>
        </div>
        <CCard bodyWrapper class="card_background">
            <CRow>
                <CCol sm="4">
                    <CInput
                        :label="$t('Autotip routine name')"
                        :value="main_model.routine_name"
                        :value.sync="main_model.routine_name"
                    />
                </CCol>
                <CCol sm="4">
                    <CSelect
                        :label="$t('Repeat')"
                        :options="repeatOptions"
                        :value.sync="main_model.repeat"
                        
                    />
                </CCol>

                <CCol sm="4">
                    <label>{{ $t("Repeat Days") }}</label>
                    <multiselect 
                        v-model="repeatDays" 
                        :options="daysOptions" 
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        group-values="days" 
                        group-label="all" 
                        :group-select="true" 
                        placeholder="Type to search" 
                        track-by="label" 
                        label="label">
                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} days selected</span></template>
                        <template slot="tag">{{ '' }}</template>
                    </multiselect>
                </CCol>

                 <CCol sm="12">
                    <CTextarea
                        :label="$t('Description')"
                        :value.sync="main_model.desc"
                        rows="7"
                    />
                </CCol>
                <CCol sm="4">
                    <CSelect
                        :label="$t('User')"
                        :options="userOptions"
                        :value.sync="main_model.user"
                        @update:value="update_strategy"
                        
                    />
                </CCol>
            </CRow>
            <div style="text-align: center; color: red;border-bottom: 1px solid red;  line-height: 0.1em; margin: 10px 0 20px; ">
                <span style="padding:0 10px; background: #f5f5f5;">entry part</span>
            </div>
            <CTabs variant="tabs" :active-tab="0">
                <CTab title="Entry 1">
                    <div title="post a tip page">
                        <div style="margin-bottom: 5px;margin-top: 15px;">
                            <span style="color: blue;">{{ $t("Post a tip page") }}</span>
                        </div>

                        <label style="text-decoration: underline;">{{ $t("Tip") }}</label>
                        
                        <CRow>
                            <CCol sm="4">
                                 <CSelect
                                    :label="$t('Process date')"
                                    :options="dateOptions"
                                    :value.sync="model.date"
                                />
                            </CCol>
                            <CCol sm="4">
                                <label>{{ $t("Countries") }}</label>
                                <multiselect 
                                    v-model="model.country" 
                                    :options="countryOptions" 
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"                        
                                    group-values="countries" 
                                    group-label="all" 
                                    :group-select="true" 
                                    placeholder="Type to search" 
                                    track-by="country_name" 
                                    label="country_name">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} countries selected</span></template>
                                    <template slot="tag">{{ '' }}</template>
                                </multiselect>
                            </CCol>
                            <CCol sm="4">
                                <label>{{ $t("Leagues") }}</label>
                                 <multiselect 
                                    v-model="model.league" 
                                    :options="leagueOptions" 
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    group-values="leagues" 
                                    group-label="all" 
                                    :group-select="true" 
                                    placeholder="Type to search" 
                                    track-by="league_name" 
                                    label="league_name">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} leagues selected</span></template>
                                    <template slot="tag">{{ '' }}</template>
                                </multiselect>
                                
                            </CCol>
                            <CCol sm="4">
                                 <CTextarea
                                    :label="$t('Teams')"
                                    :value.sync="model.teams"
                                    rows="7"
                                />
                            </CCol>

                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Team Side')"
                                    placeholder="select..."
                                    :options="teamSideOptions"
                                    :value.sync="model.team_side"
                                />
                            </CCol>
                            <CCol sm="4">
                                 <CTextarea
                                    :label="$t('Exclude Teams')"
                                    :value.sync="model.exclude_teams"
                                    rows="7"
                                />
                            </CCol>

                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Exclude Team Side')"
                                    placeholder="select..."
                                    :options="teamSideOptions"
                                    :value.sync="model.exclude_team_side"
                                />
                            </CCol>
                            
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model.stake"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Visibility')"
                                    placeholder="select..."
                                    :options="visibilityOptions"
                                    :value.sync="model.visibility"
                                />
                            </CCol>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Add to Strategy')"
                                    placeholder="select.."
                                    :options="strategyOptions"
                                    :value.sync="model.strategy"
                                />
                            </CCol> -->
                            <CCol sm="4">
                                <label>{{ $t("Add to Strategy") }}</label>
                                <multiselect 
                                    v-model="model.strategy" 
                                    :options="strategyOptions" 
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    group-values="items" 
                                    group-label="all" 
                                    :group-select="true" 
                                    placeholder="Type to search" 
                                    track-by="label" 
                                    label="label">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} strategies selected</span></template>
                                    <template slot="tag">{{ '' }}</template>
                                </multiselect>
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model.predictionType"                       
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions1"
                                    :value.sync="model.overUnder"
                                />
                            </CCol>
                        </CRow>

                        <label style="text-decoration: underline;">Cover(optional)</label>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model.cover_predictionType"                        
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions2"
                                    :value.sync="model.cover_overUnder"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model.cover_stake"
                                />
                            </CCol> 
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTextarea
                                    :label="$t('Note(optional)')"
                                    :value.sync="model.note"
                                    rows="7"
                                />
                            </CCol>
                        </CRow>
                    </div>

                    <CRow>
                        <CCol sm="2">
                            <CInput
                                type="number"
                                :label="$t('time until event starts')"
                                :value.sync="timeBeforeEvent"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                type="number"
                                :label="$t('time before event starts')"
                                :value.sync="timeAfterEvent"
                            />
                        </CCol>
                    </CRow>
                    <div title="cold stats page">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t('Cold stat page') }}</span>
                        </div>
                        
                        <CRow>
                            <CTabs variant="tabs" :active-tab="0">                                
                                <CTab :title="coldStat_model.home.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.home.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.home2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.home2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.home3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.home3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.home4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.home4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>
                            
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model.away.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.away.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.away2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.away2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.away3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.away3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.away4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.away4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">FH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.fh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.fh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">SH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.away.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.sh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.home.sh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <label>matches percentage</label>
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">>=</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.matches_percentage.min"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;"><=</p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model.matches_percentage.max"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>

                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model.league.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.league.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.league2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.league2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league2.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league2.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.league3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.league3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league3.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league3.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.league4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.league4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.league4.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.league4.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model.timeBands.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.timeBands.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.timeBands2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.timeBands2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands2.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands2.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.timeBands3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.timeBands3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands3.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands3.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model.timeBands4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model.timeBands4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model.timeBands4.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model.timeBands4.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>
                            
                            
                                
                        </CRow>
                    </div>

                    <div title="historical live stat">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Historical live stat") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="12">
                                    
                                    <table style="width:  100%; font-size: 13.5px;">
                                        <tr style="background: #b7eafc;">
                                            <th class="dualHeader1" colspan="1"></th>
                                            <th class="dualHeader1" colspan="1">{{ $t("Goals") }}</th>
                                            <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                            <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                            <th class="dualHeader1" colspan="1">in</th>
                                            <th class="dualHeader1" colspan="1">out</th>
                                            <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                            <th class="dualHeader1" colspan="1">DA</th>
                                            <th class="dualHeader1" colspan="1">Poss</th>                                
                                            <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th> 
                                            <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                        </tr>
                                        
                                        <tr > 
                                            <td class="table_pre_row">comparison</th>
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.goals.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.on.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.off.option"
                                                />
                                            </td>
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.in.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.out.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.cnr.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.da.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.pos.option"
                                                />
                                            </td> 
                                            
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.sbst.option"
                                                />
                                            </td>                                
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="historicallivestats_model.rtg.option"
                                                />
                                            </td> 
                                        </tr>
                                        <tr > 
                                            <td class="table_pre_row">offset</th>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.goals.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.on.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.off.value"></CInput>
                                            </td> 
                                             <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.in.value"></CInput>
                                            </td> 
                                             <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.out.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.cnr.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.da.value"></CInput>
                                            </td> 
                                           <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.pos.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.sbst.value"></CInput>
                                            </td>                                 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model.rtg.value"></CInput>
                                            </td> 
                                        </tr>
                                       
                                    </table>
                                </CCol>
                        </CRow>
                    </div>
                    <div title="value stat page">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Value stat page</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions1"
                                            :value.sync="valueStat_model.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions2"
                                            :value.sync="valueStat_model.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect
                                                placeholder="select..."
                                                :options="valueStatsOptions1"
                                                :value.sync="valueStat_model.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="valueStatsOptions2"
                                                :value.sync="valueStat_model.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;"></p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">From Home</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">From Away</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Win</p>
                                        <p class="value">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.lastmatches.home.win"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.lastmatches.away.win"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Draw</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.lastmatches.home.draw"> </CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.lastmatches.away.draw"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Lose</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.lastmatches.home.lose"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model.lastmatches.away.lose"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Option</p>
                                        <p class="value">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model.lastmatches.home.option"
                                            />
                                        </p>
                                        <p class="percent">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model.lastmatches.away.option"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    label="Years"
                                    placeholder="select..."
                                    :options="valueStatsYearsOptions"
                                    :value.sync="valueStat_model.years"
                                />
                            </CCol>
                            <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Stat %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.stat_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.stat_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>


                                   
                                </table>
                            </CCol>

                             <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Value %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model.value_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model.value_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="league stat">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">League stat (or Scheduled games)</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions1"
                                            :value.sync="leagueStat_model.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions2"
                                            :value.sync="leagueStat_model.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions1"
                                                :value.sync="leagueStat_model.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions2"
                                                :value.sync="leagueStat_model.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (>=)" :value.sync="leagueStat_model.minMatches"></CInput>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (<)" :value.sync="leagueStat_model.maxMatches"></CInput>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="team analysis">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Team analysis") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <label>{{ $t("Home") }}</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model.home.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model.home.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model.home.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model.home.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model.home.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model.home.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model.home.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model.home.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model.away.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model.away.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model.away.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model.away.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model.away.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model.away.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model.away.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model.away.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="12">
                                <label>Home VS Away teams by unit</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>
                                        <th style="height: 30px" colspan="1"></th>     
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Pre</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Live</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Diff</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">DEF vs FWD</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.pre.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.pre.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.pre.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.live.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.live.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.live.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.diff.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.diff.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.diff.df.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">MID vs MID</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.pre.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.pre.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.pre.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.live.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.live.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.live.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.diff.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.diff.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.diff.mm.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">FWD vs DEF</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.pre.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.pre.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.pre.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.live.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.live.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.live.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model.diff.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.diff.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.diff.fd.maxValue"></CInput></td>
                                    </tr> 
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Next match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.home_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model.home_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model.home_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model.home_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.home_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model.home_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Next match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.away_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model.away_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model.away_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model.away_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.away_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model.away_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Latest match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.home_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model.home_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model.home_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model.home_latest.leg"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model.home_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.home_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model.home_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Latest match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.away_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model.away_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model.away_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model.away_latest.leg"
                                            />
                                        </td> 
                                         <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model.away_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.away_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model.away_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model.keyPlayers[0].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model.keyPlayers[0].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model.keyPlayers[0].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model.keyPlayers[0].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model.keyPlayers[0].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].keyPlayers.min"></CInput></td>  
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[0].keyPlayers.max"></CInput></td> 
                                    </tr>
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model.keyPlayers[1].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model.keyPlayers[1].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model.keyPlayers[1].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model.keyPlayers[1].away.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model.keyPlayers[1].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].keyPlayers.min"></CInput></td>
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model.keyPlayers[1].keyPlayers.max"></CInput></td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="live stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Live stats") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="3">
                                <CSelect
                                    placeholder="select..."
                                    label="Status"
                                    :options="eventStatusOptions"
                                    :value.sync="livestats_model.status"
                                    
                                />
                            </CCol>                            
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (>=)" :value.sync="livestats_model.minMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (<)" :value.sync="livestats_model.maxMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <label>Random</label>
                                <CInputCheckbox class="check-box"
                                    :checked.sync = "livestats_model.min_random"
                                >
                                </CInputCheckbox>
                            </CCol>
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model.oddpre" :title="livestats_model.oddpre[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                    
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model.oddpre[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                    
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">
                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd pre</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1"
                                                        :value.sync="livestats_model.oddpre[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model.oddpre[index].minValue"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2"
                                                        :value.sync="livestats_model.oddpre[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model.oddpre[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>                                    
                                    </CTab>
                                </CTabs>
                            </CCol>
                            
                            
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">                                    
                                    <CTab v-for="(item, index) in livestats_model.oddlive" :title="livestats_model.oddlive[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model.oddlive[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd live</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1_"
                                                        :value.sync="livestats_model.oddlive[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model.oddlive[index].minValue"  ></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2_"
                                                        :value.sync="livestats_model.oddlive[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model.oddlive[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                            
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    
                                     <CTab v-for="(item, index) in livestats_model.minStats" :title="livestats_model.minStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model.minStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score => X,Y</th>
                                                <th class="dualHeader1" colspan="1">On => X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off => X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner => X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank => X,Y</th>
                                                <th class="dualHeader1" colspan="1">red => X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel => X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst => X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI => X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM => X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG => X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                     <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.minStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model.maxStats" :title="livestats_model.maxStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                    
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model.maxStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score < X,Y</th>
                                                <th class="dualHeader1" colspan="1">On < X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off < X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner < X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank < X,Y</th>
                                                <th class="dualHeader1" colspan="1">red < X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel < X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst < X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI < X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM < X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG < X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.maxStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model.comparison" :title="livestats_model.comparison[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                    
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model.comparison[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("rank") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("red") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("yel") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("INI") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("PFM") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">comparison</th>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].score.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].on.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].off.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].corner.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].rank.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].red.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].yel.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].sbst.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].ini.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].pfm.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model.comparison[index].rtg.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">offset</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].score.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].on.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].off.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].corner.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].rank.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].red.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].yel.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].sbst.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].ini.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].pfm.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.comparison[index].rtg.value"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="9">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model.time_from_to" :title="livestats_model.time_from_to[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                    
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model.time_from_to[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Over 0.5</th>
                                                <th class="dualHeader1" colspan="1">Over 1.5</th>
                                                <th class="dualHeader1" colspan="1">Over 2.5</th>
                                                <th class="dualHeader1" colspan="1">Over 3.5</th>
                                                <th class="dualHeader1" colspan="1">Under 0.5</th>
                                                <th class="dualHeader1" colspan="1">Under 1.5</th>
                                                <th class="dualHeader1" colspan="1">Under 2.5</th>
                                                <th class="dualHeader1" colspan="1">Under 3.5</th>
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over35.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under35.from"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over35.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under35.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">BTS Yes</th>
                                                <th class="dualHeader1" colspan="1">BTS No</th>
                                                <th class="dualHeader1" colspan="1">Ov 0.5 HT</th>
                                                <th class="dualHeader1" colspan="1">Un 0.5 HT</th>                            
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].home.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].draw.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].away.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].btsyes.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].btsno.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over05ht.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under05ht.from"></CInput>
                                                </td> 
                                            </tr>
                                           <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].home.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].draw.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].away.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].btsyes.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].btsno.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].over05ht.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model.time_from_to[index].under05ht.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="Strategy statistics">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy statistics</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyStats_model[0].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyStats_model[0].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[0].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].total_matches.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].all[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(item, index_) in 4" :title="strategyStats_model[0].special_strategyOptions_all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                            
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[0].special_strategyOptions_all[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[0].special_strategyOptions_all[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[0].special_strategyOptions_all[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[0].special_strategyOptions_all[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>

                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyStats_model[0].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[0].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].total_matches.min"></CInput>
                                                </td>
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[0].league[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(item, index_) in 4" :title="strategyStats_model[0].special_strategyOptions_league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[0].special_strategyOptions_league[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[0].special_strategyOptions_league[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[0].special_strategyOptions_league[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[0].special_strategyOptions_league[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>
                        
                    </div>
                    <div title="Strategy financial">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy financial</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyFinancial_model[0].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[0].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[0].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1.min"></CInput>
                                                </td>  
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[0].all[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].recent_max_loss_repeat.max"></CInput>
                                                </td>
                                                
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend2.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">All stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">All stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].all[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[0].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[0].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>               
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."                                                        
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[0].league[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend2.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].recent_max_loss_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_avg.max"></CInput>
                                                </td>
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend1.max"></CInput>
                                                </td>
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend2.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">League stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">League stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[0].league[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                    </div>
                    <div title="Sospeso predictions">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Sospeso predictions") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction type')"
                                    :options="sospesoPredictionOptions"
                                    :value.sync="sospesoPrediction_model[0].predictionType"
                                    
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction filters')"
                                    :options="sospesoPredictionFilters"
                                    :value.sync="sospesoPrediction_model[0].predictionFilter"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Filtri quote Betfair</th>
                                        <th class="dualHeader1" colspan="1">Filtri abbinate</th>
                                        
                                    </tr>
                                    
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[0].odds_min"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[0].matches_min"></CInput>
                                        </td> 
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[0].odds_max"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[0].matches_max"></CInput>
                                        </td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>

                </CTab>
                <CTab title="Entry 2">
                    <div title="post a tip page">
                        <div style="margin-bottom: 5px;margin-top: 15px;">
                            <span style="color: blue;">{{ $t("Post a tip page") }}</span>
                        </div>

                        <label style="text-decoration: underline;">{{ $t("Tip") }}</label>
                        
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model2.stake"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Visibility')"
                                    placeholder="select..."
                                    :options="visibilityOptions"
                                    :value.sync="model2.visibility"
                                />
                            </CCol>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Add to Strategy')"
                                    placeholder="select.."
                                    :options="strategyOptions"
                                    :value.sync="model2.strategy"
                                />
                            </CCol> -->
                            <CCol sm="4">
                                <label>{{ $t("Add to Strategy") }}</label>
                                <multiselect 
                                    v-model="model2.strategy" 
                                    :options="strategyOptions" 
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    group-values="items" 
                                    group-label="all" 
                                    :group-select="true" 
                                    placeholder="Type to search" 
                                    track-by="label" 
                                    label="label">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} strategies selected</span></template>
                                    <template slot="tag">{{ '' }}</template>
                                </multiselect>
                            </CCol>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model2.predictionType"                       
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions1_2"
                                    :value.sync="model2.overUnder"
                                />
                            </CCol> -->
                        </CRow>

                        <label style="text-decoration: underline;">Cover(optional)</label>
                        <CRow>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model2.cover_predictionType"                        
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions2_2"
                                    :value.sync="model2.cover_overUnder"
                                />
                            </CCol> -->
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model2.cover_stake"
                                />
                            </CCol> 
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTextarea
                                    :label="$t('Note(optional)')"
                                    :value.sync="model2.note"
                                    rows="7"
                                />
                            </CCol>
                        </CRow>
                    </div>
                    <CRow>
                        <CCol sm="2">
                            <CInput
                                type="number"
                                :label="$t('time until event starts')"
                                :value.sync="timeBeforeEvent2"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                type="number"
                                :label="$t('time before event starts')"
                                :value.sync="timeAfterEvent2"
                            />
                        </CCol>
                    </CRow>
                    <div title="cold stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t('Cold stat page') }}</span>
                        </div>
                        <CRow>                
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model2.home.check ? 'table 1 *' : 'table 1'">
                                
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.home.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.home2.check ? 'table 2 *' : 'table 2'" >
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.home2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.home3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.home3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.home4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.home4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model2.away.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.away.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.away2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.away2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.away3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.away3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.away4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.away4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">FH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.fh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.fh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">SH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.away.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.sh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.home.sh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <label>matches percentage</label>
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">>=</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.matches_percentage.min"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;"><=</p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model2.matches_percentage.max"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>

                            
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model2.league.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.league.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.league2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.league2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league2.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league2.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.league3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.league3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league3.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league3.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.league4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.league4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.league4.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.league4.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model2.timeBands.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.timeBands.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.timeBands2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.timeBands2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands2.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands2.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.timeBands3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.timeBands3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands3.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands3.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model2.timeBands4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model2.timeBands4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model2.timeBands4.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model2.timeBands4.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>
                                
                        </CRow>
                    </div>
                    <div title="historical live stat">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Historical live stat") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="12">                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Goals") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                        <th class="dualHeader1" colspan="1">in</th>
                                        <th class="dualHeader1" colspan="1">out</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                        <th class="dualHeader1" colspan="1">DA</th>
                                        <th class="dualHeader1" colspan="1">Poss</th>                                
                                        <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th> 
                                        <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">comparison</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.goals.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.on.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.off.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.in.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.out.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.cnr.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.da.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.pos.option"
                                            />
                                        </td> 
                                        
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.sbst.option"
                                            />
                                        </td>                                
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model2.rtg.option"
                                            />
                                        </td> 
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.goals.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.on.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.off.value"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.in.value"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.out.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.cnr.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.da.value"></CInput>
                                        </td> 
                                       <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.pos.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.sbst.value"></CInput>
                                        </td>                                 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model2.rtg.value"></CInput>
                                        </td> 
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="value stat page">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Value stat page</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions1"
                                            :value.sync="valueStat_model2.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions2"
                                            :value.sync="valueStat_model2.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect
                                                placeholder="select..."
                                                :options="valueStatsOptions1"
                                                :value.sync="valueStat_model2.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="valueStatsOptions2"
                                                :value.sync="valueStat_model2.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;"></p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">From Home</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">From Away</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Win</p>
                                        <p class="value">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.lastmatches.home.win"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.lastmatches.away.win"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Draw</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.lastmatches.home.draw"> </CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.lastmatches.away.draw"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Lose</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.lastmatches.home.lose"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model2.lastmatches.away.lose"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Option</p>
                                        <p class="value">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model2.lastmatches.home.option"
                                            />
                                        </p>
                                        <p class="percent">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model2.lastmatches.away.option"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    label="Years"
                                    placeholder="select..."
                                    :options="valueStatsYearsOptions"
                                    :value.sync="valueStat_model2.years"
                                />
                            </CCol>
                            <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Stat %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.stat_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.stat_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>


                                   
                                </table>
                            </CCol>

                             <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Value %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model2.value_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model2.value_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="league stat">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">League stat (or Scheduled games)</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions1"
                                            :value.sync="leagueStat_model2.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model2.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions2"
                                            :value.sync="leagueStat_model2.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model2.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions1"
                                                :value.sync="leagueStat_model2.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model2.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions2"
                                                :value.sync="leagueStat_model2.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model2.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (>=)" :value.sync="leagueStat_model2.minMatches"></CInput>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (<)" :value.sync="leagueStat_model2.maxMatches"></CInput>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="team analysis">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Team analysis") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <label>{{ $t("Home") }}</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model2.home.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model2.home.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model2.home.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model2.home.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model2.home.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model2.home.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model2.home.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model2.home.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model2.away.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model2.away.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model2.away.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model2.away.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model2.away.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model2.away.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model2.away.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model2.away.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="12">
                                <label>Home VS Away teams by unit</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>
                                        <th style="height: 30px" colspan="1"></th>     
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Pre</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Live</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Diff</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">DEF vs FWD</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.pre.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.pre.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.pre.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.live.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.live.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.live.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.diff.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.diff.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.diff.df.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">MID vs MID</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.pre.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.pre.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.pre.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.live.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.live.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.live.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.diff.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.diff.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.diff.mm.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">FWD vs DEF</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.pre.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.pre.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.pre.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.live.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.live.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.live.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model2.diff.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.diff.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.diff.fd.maxValue"></CInput></td>
                                    </tr> 
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Next match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.home_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model2.home_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model2.home_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model2.home_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.home_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model2.home_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Next match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.away_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model2.away_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model2.away_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model2.away_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.away_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model2.away_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Latest match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.home_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model2.home_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model2.home_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model2.home_latest.leg"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model2.home_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.home_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model2.home_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Latest match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.away_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model2.away_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model2.away_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model2.away_latest.leg"
                                            />
                                        </td> 
                                         <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model2.away_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.away_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model2.away_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model2.keyPlayers[0].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model2.keyPlayers[0].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model2.keyPlayers[0].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model2.keyPlayers[0].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model2.keyPlayers[0].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].keyPlayers.min"></CInput></td> 
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[0].keyPlayers.max"></CInput></td>
                                    </tr>
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model2.keyPlayers[1].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model2.keyPlayers[1].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model2.keyPlayers[1].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model2.keyPlayers[1].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model2.keyPlayers[1].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].keyPlayers.min"></CInput></td> 
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model2.keyPlayers[1].keyPlayers.max"></CInput></td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="live stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Live stats") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="3">
                                <CSelect
                                    placeholder="select..."
                                    label="Status"
                                    :options="eventStatusOptions"
                                    :value.sync="livestats_model2.status"
                                    
                                />
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (>=)" :value.sync="livestats_model2.minMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (<)" :value.sync="livestats_model2.maxMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <label>Random</label>
                                <CInputCheckbox class="check-box"
                                    :checked.sync = "livestats_model2.min_random"
                                >
                                </CInputCheckbox>
                            </CCol>
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model2.oddpre" :title="livestats_model2.oddpre[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model2.oddpre[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                    
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">
                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd pre</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1"
                                                        :value.sync="livestats_model2.oddpre[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model2.oddpre[index].minValue"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2"
                                                        :value.sync="livestats_model2.oddpre[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model2.oddpre[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>                                    
                                    </CTab>
                                </CTabs>
                            </CCol>
                            
                            
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model2.oddlive" :title="livestats_model2.oddlive[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                    
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model2.oddlive[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd live</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1_"
                                                        :value.sync="livestats_model2.oddlive[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model2.oddlive[index].minValue"  ></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2_"
                                                        :value.sync="livestats_model2.oddlive[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model2.oddlive[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                            
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model2.minStats" :title="livestats_model2.minStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model2.minStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score => X,Y</th>
                                                <th class="dualHeader1" colspan="1">On => X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off => X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner => X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank => X,Y</th>
                                                <th class="dualHeader1" colspan="1">red => X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel => X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst => X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI => X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM => X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG => X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                     <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.minStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model2.maxStats" :title="livestats_model2.maxStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model2.maxStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score < X,Y</th>
                                                <th class="dualHeader1" colspan="1">On < X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off < X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner < X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank < X,Y</th>
                                                <th class="dualHeader1" colspan="1">red < X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel < X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst < X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI < X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM < X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG < X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.maxStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model2.comparison" :title="livestats_model2.comparison[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model2.comparison[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("rank") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("red") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("yel") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("INI") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("PFM") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">comparison</th>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].score.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].on.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].off.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].corner.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].rank.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].red.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].yel.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].sbst.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].ini.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].pfm.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model2.comparison[index].rtg.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">offset</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].score.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].on.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].off.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].corner.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].rank.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].red.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].yel.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].sbst.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].ini.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].pfm.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.comparison[index].rtg.value"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="9">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model2.time_from_to" :title="livestats_model2.time_from_to[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model2.time_from_to[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Over 0.5</th>
                                                <th class="dualHeader1" colspan="1">Over 1.5</th>
                                                <th class="dualHeader1" colspan="1">Over 2.5</th>
                                                <th class="dualHeader1" colspan="1">Over 3.5</th>
                                                <th class="dualHeader1" colspan="1">Under 0.5</th>
                                                <th class="dualHeader1" colspan="1">Under 1.5</th>
                                                <th class="dualHeader1" colspan="1">Under 2.5</th>
                                                <th class="dualHeader1" colspan="1">Under 3.5</th>
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over35.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under35.from"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over35.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under35.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">BTS Yes</th>
                                                <th class="dualHeader1" colspan="1">BTS No</th>
                                                <th class="dualHeader1" colspan="1">Ov 0.5 HT</th>
                                                <th class="dualHeader1" colspan="1">Un 0.5 HT</th>                            
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].home.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].draw.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].away.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].btsyes.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].btsno.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over05ht.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under05ht.from"></CInput>
                                                </td> 
                                            </tr>
                                           <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].home.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].draw.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].away.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].btsyes.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].btsno.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].over05ht.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model2.time_from_to[index].under05ht.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                        </CRow>
                    </div>
                    <div title="Strategy statistics">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy statistics</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyStats_model[1].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="strategyStats_model[1].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[1].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].total_matches.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].all[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="strategyStats_model[1].special_strategyOptions_all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[1].special_strategyOptions_all[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[1].special_strategyOptions_all[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[1].special_strategyOptions_all[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[1].special_strategyOptions_all[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>

                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="strategyStats_model[1].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[1].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].total_matches.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[1].league[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="strategyStats_model[1].special_strategyOptions_league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[1].special_strategyOptions_league[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[1].special_strategyOptions_league[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[1].special_strategyOptions_league[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[1].special_strategyOptions_league[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>
                        
                    </div>
                    <div title="Strategy financial">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy financial</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyFinancial_model[1].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[1].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[1].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[1].all[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].recent_max_loss_repeat.max"></CInput>
                                                </td>
                                                
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend2.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">All stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">All stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].all[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[1].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[1].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>               
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."                                                        
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[1].league[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend2.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].recent_max_loss_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend2.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">League stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">League stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[1].league[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                    </div>
                    <div title="Sospeso predictions">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Sospeso predictions") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction type')"
                                    :options="sospesoPredictionOptions"
                                    :value.sync="sospesoPrediction_model[1].predictionType"
                                    
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction filters')"
                                    :options="sospesoPredictionFilters"
                                    :value.sync="sospesoPrediction_model[1].predictionFilter"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Filtri quote Betfair</th>
                                        <th class="dualHeader1" colspan="1">Filtri abbinate</th>
                                        
                                    </tr>
                                    
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[1].odds_min"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[1].matches_min"></CInput>
                                        </td> 
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[1].odds_max"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[1].matches_max"></CInput>
                                        </td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                </CTab>
                <CTab title="Entry 3">
                    <div title="post a tip page">
                        <div style="margin-bottom: 5px;margin-top: 15px;">
                            <span style="color: blue;">{{ $t("Post a tip page") }}</span>
                        </div>

                        <label style="text-decoration: underline;">{{ $t("Tip") }}</label>
                        
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model3.stake"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Visibility')"
                                    placeholder="select..."
                                    :options="visibilityOptions"
                                    :value.sync="model3.visibility"
                                />
                            </CCol>
                            <CCol sm="4">
                                <label>{{ $t("Add to Strategy") }}</label>
                                <multiselect 
                                    v-model="model3.strategy" 
                                    :options="strategyOptions" 
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    group-values="items" 
                                    group-label="all" 
                                    :group-select="true" 
                                    placeholder="Type to search" 
                                    track-by="label" 
                                    label="label">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} strategies selected</span></template>
                                    <template slot="tag">{{ '' }}</template>
                                </multiselect>
                            </CCol>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model3.predictionType"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions1_3"
                                    :value.sync="model3.overUnder"
                                />
                            </CCol> -->
                        </CRow>

                        <label style="text-decoration: underline;">Cover(optional)</label>
                        <CRow>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model3.cover_predictionType"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions2_3"
                                    :value.sync="model3.cover_overUnder"
                                />
                            </CCol> -->
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model3.cover_stake"
                                />
                            </CCol> 
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTextarea
                                    :label="$t('Note(optional)')"
                                    :value.sync="model3.note"
                                    rows="7"
                                />
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol sm="2">
                                <CInput
                                    type="number"
                                    :label="$t('time until event starts')"
                                    :value.sync="timeBeforeEvent3"
                                />
                            </CCol>
                            <CCol sm="2">
                                <CInput
                                    type="number"
                                    :label="$t('time before event starts')"
                                    :value.sync="timeAfterEvent3"
                                />
                            </CCol>
                        </CRow>
                    </div>
                    <div title="cold stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t('Cold stat page') }}</span>
                        </div>
                        <CRow>                
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model3.home.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.home.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.home2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.home2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.home3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.home3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.home4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.home4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model3.away.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.away.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.away2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.away2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.away3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.away3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.away4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.away4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">FH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.fh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.fh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">SH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.away.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.sh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.home.sh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <label>matches percentage</label>
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">>=</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.matches_percentage.min"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;"><=</p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model3.matches_percentage.max"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>

                            
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model3.league.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.league.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.league2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.league2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league2.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league2.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.league3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.league3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league3.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league3.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.league4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.league4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.league4.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.league4.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model3.timeBands.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.timeBands.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.timeBands2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.timeBands2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands2.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands2.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.timeBands3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.timeBands3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands3.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands3.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model3.timeBands4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model3.timeBands4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model3.timeBands4.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model3.timeBands4.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>
                                
                        </CRow>
                    </div>
                    <div title="historical live stat">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Historical live stat") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="12">                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Goals") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                        <th class="dualHeader1" colspan="1">in</th>
                                        <th class="dualHeader1" colspan="1">out</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                        <th class="dualHeader1" colspan="1">DA</th>
                                        <th class="dualHeader1" colspan="1">Poss</th>                                
                                        <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th> 
                                        <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">comparison</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.goals.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.on.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.off.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.in.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.out.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.cnr.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.da.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.pos.option"
                                            />
                                        </td> 
                                        
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.sbst.option"
                                            />
                                        </td>                                
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model3.rtg.option"
                                            />
                                        </td> 
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.goals.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.on.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.off.value"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.in.value"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.out.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.cnr.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.da.value"></CInput>
                                        </td> 
                                       <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.pos.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.sbst.value"></CInput>
                                        </td>                                 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model3.rtg.value"></CInput>
                                        </td> 
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="value stat page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Value stat page</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions1"
                                            :value.sync="valueStat_model3.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions2"
                                            :value.sync="valueStat_model3.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect
                                                placeholder="select..."
                                                :options="valueStatsOptions1"
                                                :value.sync="valueStat_model3.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="valueStatsOptions2"
                                                :value.sync="valueStat_model3.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;"></p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">From Home</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">From Away</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Win</p>
                                        <p class="value">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.lastmatches.home.win"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.lastmatches.away.win"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Draw</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.lastmatches.home.draw"> </CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.lastmatches.away.draw"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Lose</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.lastmatches.home.lose"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model3.lastmatches.away.lose"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Option</p>
                                        <p class="value">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model3.lastmatches.home.option"
                                            />
                                        </p>
                                        <p class="percent">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model3.lastmatches.away.option"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    label="Years"
                                    placeholder="select..."
                                    :options="valueStatsYearsOptions"
                                    :value.sync="valueStat_model3.years"
                                />
                            </CCol>
                            <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Stat %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.stat_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.stat_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>


                                   
                                </table>
                            </CCol>

                             <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Value %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model3.value_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model3.value_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="league stat">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">League stat (or Scheduled games)</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions1"
                                            :value.sync="leagueStat_model3.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model3.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions2"
                                            :value.sync="leagueStat_model3.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model3.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions1"
                                                :value.sync="leagueStat_model3.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model3.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions2"
                                                :value.sync="leagueStat_model3.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model3.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (>=)" :value.sync="leagueStat_model3.minMatches"></CInput>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (<)" :value.sync="leagueStat_model3.maxMatches"></CInput>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="team analysis">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Team analysis") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <label>{{ $t("Home") }}</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model3.home.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model3.home.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model3.home.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model3.home.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model3.home.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model3.home.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model3.home.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model3.home.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model3.away.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model3.away.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model3.away.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model3.away.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model3.away.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model3.away.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model3.away.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model3.away.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="12">
                                <label>Home VS Away teams by unit</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>
                                        <th style="height: 30px" colspan="1"></th>     
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Pre</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Live</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Diff</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">DEF vs FWD</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.pre.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.pre.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.pre.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.live.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.live.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.live.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.diff.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.diff.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.diff.df.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">MID vs MID</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.pre.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.pre.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.pre.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.live.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.live.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.live.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.diff.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.diff.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.diff.mm.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">FWD vs DEF</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.pre.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.pre.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.pre.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.live.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.live.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.live.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model3.diff.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.diff.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.diff.fd.maxValue"></CInput></td>
                                    </tr> 
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Next match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.home_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model3.home_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model3.home_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model3.home_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.home_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model3.home_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Next match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.away_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model3.away_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model3.away_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model3.away_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.away_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model3.away_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Latest match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.home_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model3.home_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model3.home_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model3.home_latest.leg"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model3.home_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.home_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model3.home_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Latest match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.away_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model3.away_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model3.away_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model3.away_latest.leg"
                                            />
                                        </td> 
                                         <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model3.away_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.away_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model3.away_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model3.keyPlayers[0].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model3.keyPlayers[0].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model3.keyPlayers[0].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model3.keyPlayers[0].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model3.keyPlayers[0].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].keyPlayers.min"></CInput></td>
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[0].keyPlayers.max"></CInput></td> 
                                    </tr>
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model3.keyPlayers[1].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model3.keyPlayers[1].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model3.keyPlayers[1].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model3.keyPlayers[1].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model3.keyPlayers[1].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].keyPlayers.min"></CInput></td>
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model3.keyPlayers[1].keyPlayers.max"></CInput></td>
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="live stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Live stats") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="3">
                                <CSelect
                                    placeholder="select..."
                                    label="Status"
                                    :options="eventStatusOptions"
                                    :value.sync="livestats_model3.status"
                                    
                                />
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (>=)" :value.sync="livestats_model3.minMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (<)" :value.sync="livestats_model3.maxMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <label>Random</label>
                                <CInputCheckbox class="check-box"
                                    :checked.sync = "livestats_model3.min_random"
                                >
                                </CInputCheckbox>
                            </CCol>
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model3.oddpre" :title="livestats_model3.oddpre[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model3.oddpre[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                    
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">
                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd pre</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1"
                                                        :value.sync="livestats_model3.oddpre[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model3.oddpre[index].minValue"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2"
                                                        :value.sync="livestats_model3.oddpre[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model3.oddpre[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>                                    
                                    </CTab>
                                </CTabs>
                            </CCol>
                            
                            
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model3.oddlive" :title="livestats_model3.oddlive[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">

                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model3.oddlive[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd live</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1_"
                                                        :value.sync="livestats_model3.oddlive[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model3.oddlive[index].minValue"  ></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2_"
                                                        :value.sync="livestats_model3.oddlive[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model3.oddlive[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                            
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model3.minStats" :title="livestats_model3.minStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model3.minStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score => X,Y</th>
                                                <th class="dualHeader1" colspan="1">On => X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off => X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner => X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank => X,Y</th>
                                                <th class="dualHeader1" colspan="1">red => X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel => X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst => X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI => X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM => X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG => X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                     <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.minStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model3.maxStats" :title="livestats_model3.maxStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model3.maxStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score < X,Y</th>
                                                <th class="dualHeader1" colspan="1">On < X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off < X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner < X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank < X,Y</th>
                                                <th class="dualHeader1" colspan="1">red < X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel < X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst < X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI < X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM < X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG < X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.maxStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model3.comparison" :title="livestats_model3.comparison[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model3.comparison[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("rank") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("red") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("yel") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("INI") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("PFM") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">comparison</th>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].score.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].on.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].off.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].corner.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].rank.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].red.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].yel.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].sbst.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].ini.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].pfm.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model3.comparison[index].rtg.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">offset</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].score.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].on.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].off.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].corner.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].rank.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].red.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].yel.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].sbst.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].ini.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].pfm.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.comparison[index].rtg.value"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="9">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model3.time_from_to" :title="livestats_model3.time_from_to[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model3.time_from_to[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Over 0.5</th>
                                                <th class="dualHeader1" colspan="1">Over 1.5</th>
                                                <th class="dualHeader1" colspan="1">Over 2.5</th>
                                                <th class="dualHeader1" colspan="1">Over 3.5</th>
                                                <th class="dualHeader1" colspan="1">Under 0.5</th>
                                                <th class="dualHeader1" colspan="1">Under 1.5</th>
                                                <th class="dualHeader1" colspan="1">Under 2.5</th>
                                                <th class="dualHeader1" colspan="1">Under 3.5</th>
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over35.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under35.from"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over35.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under35.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">BTS Yes</th>
                                                <th class="dualHeader1" colspan="1">BTS No</th>
                                                <th class="dualHeader1" colspan="1">Ov 0.5 HT</th>
                                                <th class="dualHeader1" colspan="1">Un 0.5 HT</th>                            
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].home.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].draw.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].away.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].btsyes.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].btsno.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over05ht.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under05ht.from"></CInput>
                                                </td> 
                                            </tr>
                                           <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].home.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].draw.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].away.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].btsyes.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].btsno.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].over05ht.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model3.time_from_to[index].under05ht.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                        </CRow>
                    </div>
                    <div title="Strategy statistics">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy statistics</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyStats_model[2].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="strategyStats_model[2].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[2].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].total_matches.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].all[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="strategyStats_model[2].special_strategyOptions_all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">

                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[2].special_strategyOptions_all[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[2].special_strategyOptions_all[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[2].special_strategyOptions_all[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[2].special_strategyOptions_all[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>

                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                   <CTab v-for="(num, index_) in 4" :title="strategyStats_model[2].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <span>{{ $t("League stats") }}</span> 
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[2].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].total_matches.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[2].league[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="strategyStats_model[2].special_strategyOptions_league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[2].special_strategyOptions_league[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[2].special_strategyOptions_league[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[2].special_strategyOptions_league[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[2].special_strategyOptions_league[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>
                        
                    </div>
                    <div title="Strategy financial">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy financial</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyFinancial_model[2].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[2].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[2].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[2].all[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].recent_max_loss_repeat.max"></CInput>
                                                </td>
                                                
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend2.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">All stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">All stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].all[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[2].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[2].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>               
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_avg.min"></CInput>
                                                </td>
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend1.min"></CInput>
                                                </td>
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."                                                        
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[2].league[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend2.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].recent_max_loss_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend2.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">League stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">League stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[2].league[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                    </div>
                    <div title="Sospeso predictions">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Sospeso predictions") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction type')"
                                    :options="sospesoPredictionOptions"
                                    :value.sync="sospesoPrediction_model[2].predictionType"
                                    
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction filters')"
                                    :options="sospesoPredictionFilters"
                                    :value.sync="sospesoPrediction_model[2].predictionFilter"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Filtri quote Betfair</th>
                                        <th class="dualHeader1" colspan="1">Filtri abbinate</th>
                                        
                                    </tr>
                                    
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[2].odds_min"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[2].matches_min"></CInput>
                                        </td> 
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[2].odds_max"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[2].matches_max"></CInput>
                                        </td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                </CTab>
                <CTab title="Entry 4">
                    <div title="post a tip page">
                        <div style="margin-bottom: 5px;margin-top: 15px;">
                            <span style="color: blue;">{{ $t("Post a tip page") }}</span>
                        </div>

                        <label style="text-decoration: underline;">{{ $t("Tip") }}</label>
                        
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model4.stake"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Visibility')"
                                    placeholder="select..."
                                    :options="visibilityOptions"
                                    :value.sync="model4.visibility"
                                />
                            </CCol>
                            <CCol sm="4">
                                <label>{{ $t("Add to Strategy") }}</label>
                                <multiselect 
                                    v-model="model4.strategy" 
                                    :options="strategyOptions" 
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    group-values="items" 
                                    group-label="all" 
                                    :group-select="true" 
                                    placeholder="Type to search" 
                                    track-by="label" 
                                    label="label">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} strategies selected</span></template>
                                    <template slot="tag">{{ '' }}</template>
                                </multiselect>
                            </CCol>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model3.predictionType"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions1_3"
                                    :value.sync="model3.overUnder"
                                />
                            </CCol> -->
                        </CRow>

                        <label style="text-decoration: underline;">Cover(optional)</label>
                        <CRow>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model3.cover_predictionType"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions2_3"
                                    :value.sync="model3.cover_overUnder"
                                />
                            </CCol> -->
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model4.cover_stake"
                                />
                            </CCol> 
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTextarea
                                    :label="$t('Note(optional)')"
                                    :value.sync="model4.note"
                                    rows="7"
                                />
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol sm="2">
                                <CInput
                                    type="number"
                                    :label="$t('time until event starts')"
                                    :value.sync="timeBeforeEvent4"
                                />
                            </CCol>
                            <CCol sm="2">
                                <CInput
                                    type="number"
                                    :label="$t('time before event starts')"
                                    :value.sync="timeAfterEvent4"
                                />
                            </CCol>
                        </CRow>
                    </div>
                    <div title="cold stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t('Cold stat page') }}</span>
                        </div>
                        <CRow>                
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model4.home.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.home.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.home2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.home2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.home3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.home3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.home4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.home4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model4.away.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.away.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.away2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.away2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.away3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.away3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                               <CTab :title="coldStat_model4.away4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.away4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">FH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.fh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.fh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">SH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.away.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.sh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.home.sh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <label>matches percentage</label>
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">>=</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.matches_percentage.min"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;"><=</p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model4.matches_percentage.max"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>

                            
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model4.league.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.league.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.league2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.league2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league2.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league2.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.league3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.league3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league3.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league3.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.league4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.league4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.league4.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.league4.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model4.timeBands.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.timeBands.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.timeBands2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.timeBands2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands2.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands2.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.timeBands3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.timeBands3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands3.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands3.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model4.timeBands4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model4.timeBands4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model4.timeBands4.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model4.timeBands4.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>
                                
                        </CRow>
                    </div>
                    <div title="historical live stat">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Historical live stat") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="12">                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Goals") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                        <th class="dualHeader1" colspan="1">in</th>
                                        <th class="dualHeader1" colspan="1">out</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                        <th class="dualHeader1" colspan="1">DA</th>
                                        <th class="dualHeader1" colspan="1">Poss</th>                                
                                        <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th> 
                                        <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">comparison</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.goals.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.on.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.off.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.in.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.out.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.cnr.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.da.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.pos.option"
                                            />
                                        </td> 
                                        
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.sbst.option"
                                            />
                                        </td>                                
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model4.rtg.option"
                                            />
                                        </td> 
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.goals.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.on.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.off.value"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.in.value"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.out.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.cnr.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.da.value"></CInput>
                                        </td> 
                                       <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.pos.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.sbst.value"></CInput>
                                        </td>                                 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model4.rtg.value"></CInput>
                                        </td> 
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="value stat page">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Value stat page</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions1"
                                            :value.sync="valueStat_model4.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions2"
                                            :value.sync="valueStat_model4.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect
                                                placeholder="select..."
                                                :options="valueStatsOptions1"
                                                :value.sync="valueStat_model4.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="valueStatsOptions2"
                                                :value.sync="valueStat_model4.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;"></p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">From Home</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">From Away</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Win</p>
                                        <p class="value">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.lastmatches.home.win"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.lastmatches.away.win"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Draw</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.lastmatches.home.draw"> </CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.lastmatches.away.draw"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Lose</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.lastmatches.home.lose"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model4.lastmatches.away.lose"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Option</p>
                                        <p class="value">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model4.lastmatches.home.option"
                                            />
                                        </p>
                                        <p class="percent">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model4.lastmatches.away.option"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    label="Years"
                                    placeholder="select..."
                                    :options="valueStatsYearsOptions"
                                    :value.sync="valueStat_model4.years"
                                />
                            </CCol>
                            <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Stat %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.stat_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.stat_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>


                                   
                                </table>
                            </CCol>

                             <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Value %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model4.value_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model4.value_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="league stat">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">League stat (or Scheduled games)</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions1"
                                            :value.sync="leagueStat_model4.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model4.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions2"
                                            :value.sync="leagueStat_model4.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model4.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions1"
                                                :value.sync="leagueStat_model4.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model4.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions2"
                                                :value.sync="leagueStat_model4.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model4.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (>=)" :value.sync="leagueStat_model4.minMatches"></CInput>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (<)" :value.sync="leagueStat_model4.maxMatches"></CInput>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="team analysis">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Team analysis") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <label>{{ $t("Home") }}</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model4.home.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model4.home.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model4.home.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model4.home.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model4.home.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model4.home.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model4.home.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model4.home.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model4.away.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model4.away.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model4.away.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model4.away.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model4.away.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model4.away.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model4.away.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model4.away.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="12">
                                <label>Home VS Away teams by unit</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>
                                        <th style="height: 30px" colspan="1"></th>     
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Pre</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Live</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Diff</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">DEF vs FWD</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.pre.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.pre.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.pre.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.live.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.live.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.live.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.diff.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.diff.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.diff.df.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">MID vs MID</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.pre.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.pre.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.pre.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.live.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.live.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.live.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.diff.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.diff.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.diff.mm.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">FWD vs DEF</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.pre.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.pre.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.pre.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.live.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.live.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.live.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model4.diff.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.diff.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.diff.fd.maxValue"></CInput></td>
                                    </tr> 
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Next match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.home_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model4.home_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model4.home_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model4.home_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.home_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model4.home_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Next match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.away_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model4.away_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model4.away_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model4.away_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.away_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model4.away_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Latest match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.home_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model4.home_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model4.home_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model4.home_latest.leg"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model4.home_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.home_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model4.home_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Latest match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.away_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model4.away_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model4.away_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model4.away_latest.leg"
                                            />
                                        </td> 
                                         <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model4.away_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.away_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model4.away_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model4.keyPlayers[0].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model4.keyPlayers[0].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model4.keyPlayers[0].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model4.keyPlayers[0].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model4.keyPlayers[0].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].keyPlayers.min"></CInput></td> 
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[0].keyPlayers.max"></CInput></td>
                                    </tr>
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model4.keyPlayers[1].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model4.keyPlayers[1].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model4.keyPlayers[1].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model4.keyPlayers[1].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model4.keyPlayers[1].keyPlayers.option"
                                            />
                                        </td>  
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].keyPlayers.min"></CInput></td>
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model4.keyPlayers[1].keyPlayers.max"></CInput></td>
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="live stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Live stats") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="3">
                                <CSelect
                                    placeholder="select..."
                                    label="Status"
                                    :options="eventStatusOptions"
                                    :value.sync="livestats_model4.status"
                                    
                                />
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (>=)" :value.sync="livestats_model4.minMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (<)" :value.sync="livestats_model4.maxMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <label>Random</label>
                                <CInputCheckbox class="check-box"
                                    :checked.sync = "livestats_model4.min_random"
                                >
                                </CInputCheckbox>
                            </CCol>
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model4.oddpre" :title="livestats_model4.oddpre[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                    
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model4.oddpre[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                    
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">
                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd pre</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1"
                                                        :value.sync="livestats_model4.oddpre[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model4.oddpre[index].minValue"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2"
                                                        :value.sync="livestats_model4.oddpre[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model4.oddpre[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>                                    
                                    </CTab>
                                </CTabs>
                            </CCol>
                            
                            
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model4.oddlive" :title="livestats_model4.oddlive[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model4.oddlive[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd live</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1_"
                                                        :value.sync="livestats_model4.oddlive[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model4.oddlive[index].minValue"  ></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2_"
                                                        :value.sync="livestats_model4.oddlive[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model4.oddlive[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                            
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model4.minStats" :title="livestats_model4.minStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model4.minStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score => X,Y</th>
                                                <th class="dualHeader1" colspan="1">On => X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off => X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner => X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank => X,Y</th>
                                                <th class="dualHeader1" colspan="1">red => X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel => X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst => X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI => X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM => X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG => X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                     <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.minStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model4.maxStats" :title="livestats_model4.maxStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model4.maxStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score < X,Y</th>
                                                <th class="dualHeader1" colspan="1">On < X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off < X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner < X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank < X,Y</th>
                                                <th class="dualHeader1" colspan="1">red < X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel < X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst < X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI < X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM < X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG < X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.maxStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model4.comparison" :title="livestats_model4.comparison[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model4.comparison[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("rank") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("red") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("yel") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("INI") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("PFM") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">comparison</th>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].score.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].on.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].off.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].corner.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].rank.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].red.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].yel.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].sbst.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].ini.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].pfm.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model4.comparison[index].rtg.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">offset</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].score.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].on.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].off.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].corner.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].rank.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].red.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].yel.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].sbst.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].ini.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].pfm.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.comparison[index].rtg.value"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="9">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model4.time_from_to" :title="livestats_model4.time_from_to[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model4.time_from_to[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Over 0.5</th>
                                                <th class="dualHeader1" colspan="1">Over 1.5</th>
                                                <th class="dualHeader1" colspan="1">Over 2.5</th>
                                                <th class="dualHeader1" colspan="1">Over 3.5</th>
                                                <th class="dualHeader1" colspan="1">Under 0.5</th>
                                                <th class="dualHeader1" colspan="1">Under 1.5</th>
                                                <th class="dualHeader1" colspan="1">Under 2.5</th>
                                                <th class="dualHeader1" colspan="1">Under 3.5</th>
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over35.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under35.from"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over35.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under35.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">BTS Yes</th>
                                                <th class="dualHeader1" colspan="1">BTS No</th>
                                                <th class="dualHeader1" colspan="1">Ov 0.5 HT</th>
                                                <th class="dualHeader1" colspan="1">Un 0.5 HT</th>                            
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].home.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].draw.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].away.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].btsyes.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].btsno.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over05ht.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under05ht.from"></CInput>
                                                </td> 
                                            </tr>
                                           <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].home.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].draw.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].away.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].btsyes.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].btsno.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].over05ht.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model4.time_from_to[index].under05ht.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                        </CRow>
                    </div>
                    <div title="Strategy statistics">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy statistics</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyStats_model[3].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="strategyStats_model[3].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span> 
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[3].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].total_matches.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].all[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="strategyStats_model[3].special_strategyOptions_all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[3].special_strategyOptions_all[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[3].special_strategyOptions_all[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[3].special_strategyOptions_all[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[3].special_strategyOptions_all[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>

                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="strategyStats_model[3].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[3].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].total_matches.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[3].league[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="strategyStats_model[3].special_strategyOptions_league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[3].special_strategyOptions_league[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[3].special_strategyOptions_league[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[3].special_strategyOptions_league[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[3].special_strategyOptions_league[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>
                        
                    </div>
                    <div title="Strategy financial">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy financial</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyFinancial_model[3].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[3].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[3].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[3].all[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].recent_max_loss_repeat.max"></CInput>
                                                </td>
                                                
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend2.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">All stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">All stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].all[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[3].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[3].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>               
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."                                                        
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[3].league[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend2.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].recent_max_loss_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend2.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">League stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">League stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[3].league[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                    </div>
                    <div title="Sospeso predictions">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Sospeso predictions") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction type')"
                                    :options="sospesoPredictionOptions"
                                    :value.sync="sospesoPrediction_model[3].predictionType"
                                    
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction filters')"
                                    :options="sospesoPredictionFilters"
                                    :value.sync="sospesoPrediction_model[3].predictionFilter"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Filtri quote Betfair</th>
                                        <th class="dualHeader1" colspan="1">Filtri abbinate</th>
                                        
                                    </tr>
                                    
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[3].odds_min"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[3].matches_min"></CInput>
                                        </td> 
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[3].odds_max"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[3].matches_max"></CInput>
                                        </td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                </CTab>
                <CTab title="Entry 5">
                    <div title="post a tip page">
                        <div style="margin-bottom: 5px;margin-top: 15px;">
                            <span style="color: blue;">{{ $t("Post a tip page") }}</span>
                        </div>

                        <label style="text-decoration: underline;">{{ $t("Tip") }}</label>
                        
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model5.stake"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Visibility')"
                                    placeholder="select..."
                                    :options="visibilityOptions"
                                    :value.sync="model5.visibility"
                                />
                            </CCol>
                            <CCol sm="4">
                                <label>{{ $t("Add to Strategy") }}</label>
                                <multiselect 
                                    v-model="model5.strategy" 
                                    :options="strategyOptions" 
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    group-values="items" 
                                    group-label="all" 
                                    :group-select="true" 
                                    placeholder="Type to search" 
                                    track-by="label" 
                                    label="label">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} strategies selected</span></template>
                                    <template slot="tag">{{ '' }}</template>
                                </multiselect>
                            </CCol>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model3.predictionType"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions1_3"
                                    :value.sync="model3.overUnder"
                                />
                            </CCol> -->
                        </CRow>

                        <label style="text-decoration: underline;">Cover(optional)</label>
                        <CRow>
                            <!-- <CCol sm="4">
                                <CSelect
                                    :label="$t('Market type')"
                                    placeholder="select..."
                                    :options="predictionTypeOptions1"
                                    :value.sync="model3.cover_predictionType"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('+Over/under(scores)')"
                                    placeholder="select..." 
                                    :options="overUnderOptions2_3"
                                    :value.sync="model3.cover_overUnder"
                                />
                            </CCol> -->
                            <CCol sm="4">
                                <CSelect
                                    :label="$t('Stake')"
                                    placeholder="select..."
                                    :options="stakeOptions"
                                    :value.sync="model5.cover_stake"
                                />
                            </CCol> 
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTextarea
                                    :label="$t('Note(optional)')"
                                    :value.sync="model5.note"
                                    rows="7"
                                />
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol sm="2">
                                <CInput
                                    type="number"
                                    :label="$t('time until event starts')"
                                    :value.sync="timeBeforeEvent5"
                                />
                            </CCol>
                            <CCol sm="2">
                                <CInput
                                    type="number"
                                    :label="$t('time before event starts')"
                                    :value.sync="timeAfterEvent5"
                                />
                            </CCol>
                        </CRow>
                    </div>
                    <div title="cold stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t('Cold stat page') }}</span>
                        </div>
                        <CRow>                
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model5.home.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.home.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.home2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.home2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.home3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.home3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.home4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.home4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">{{ $t("Home") }}</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model5.away.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.away.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.away2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.away2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.p.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away2.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.away3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.away3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away3.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.away4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.away4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                <p style="padding: 3px; height: 38px;">Away</p>                            
                                                <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">p</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.p.min"></CInput>                                                    
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.p.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">0-0</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.z_z.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.z_z.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 1.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.over15.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.over15.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 2.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.over25.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.over25.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">Ov 3.5</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.over35.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.over35.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Scored") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.scored.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.scored.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("Conceded") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.conc.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.conc.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">{{ $t("BTS") }}</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.bts.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.bts.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.first1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.first1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 1st</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.first2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.first2.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">1+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.second1.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.second1.max"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                <p class="value" style="padding: 3px; height: 38px;">2+ 2nd</p>
                                                <p class="value">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.second2.min"></CInput>
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away4.second2.max"></CInput>
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">FH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.fh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.fh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.fh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.fh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>

                            <CCol sm="4">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;">SH</p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">min %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">max %</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Home</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Away</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.sh_percentage.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.away.sh_percentage.max"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Probability</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.sh_probability.min"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.home.sh_probability.max"></CInput>
                                        </p>
                                    </div>
                                   
                                   
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <label>matches percentage</label>
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">>=</p>
                                        <p class="value">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.matches_percentage.min"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;"><=</p>
                                        <p class="percent">
                                            <CInput type="number" class="minOdd1" :value.sync="coldStat_model5.matches_percentage.max"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>

                            
                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model5.league.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.league.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.league2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.league2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league2.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league2.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.league3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.league3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league3.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league3.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.league4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.league4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <label>League table filter</label>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">                                        
                                                </th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Pos') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('FH') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t('SH') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Swing') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Attack') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Defense') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('Form') }}</th>
                                                <th class="dualHeader1"  colspan="1">{{ $t('H/A Form') }}</th>
                                            </tr>                                
                                            <tr> 
                                                <td class="table_pre_row"></td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.pos.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.h_a.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.swing1.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.FH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.swing2.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.SH.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.swing3.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.attack.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.defense.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.form.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.league4.form_H_A.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.pos.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.h_a.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.swing1.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.FH.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.swing2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.SH.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.swing3.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.attack.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.defense.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.form.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.form_H_A.min"></CInput>
                                                </td>                                     
                                            </tr>
                                            <tr> 
                                                <td class="table_pre_row">{{ $t("max") }}</th>

                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.pos.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.h_a.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.swing1.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.FH.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.swing2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.SH.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.swing3.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.attack.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.defense.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.form.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.league4.form_H_A.max"></CInput>
                                                </td>                                     
                                            </tr>                               
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>

                            <CTabs variant="tabs" :active-tab="0">
                                <CTab :title="coldStat_model5.timeBands.check ? 'table 1 *' : 'table 1'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.timeBands.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.timeBands2.check ? 'table 2 *' : 'table 2'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.timeBands2.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands2.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands2.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.timeBands3.check ? 'table 3 *' : 'table 3'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.timeBands3.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands3.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands3.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                                <CTab :title="coldStat_model5.timeBands4.check ? 'table 4 *' : 'table 4'">
                                    <CCol sm="12">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "coldStat_model5.timeBands4.check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table class="search-table">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1">
                                                </th>
                                                <th class="dualHeader1" colspan="1">G+</th>
                                                <th class="dualHeader1" colspan="1">G-</th>
                                                <th class="dualHeader1" colspan="2">0 - 15</th>
                                                <th class="dualHeader1" colspan="2">16 - 30</th>
                                                <th class="dualHeader1" colspan="2">31 - 45</th>
                                                <th class="dualHeader1" colspan="2">46 - 60</th>
                                                <th class="dualHeader1" colspan="2">61 - 75</th>
                                                <th class="dualHeader1" colspan="2">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">GS1</th>
                                                <th class="dualHeader1" colspan="1">GS2</th>
                                                <th class="dualHeader1" colspan="1">GC1</th>
                                                <th class="dualHeader1" colspan="1">GC2</th>
                                                <th class="dualHeader1" colspan="1">40+</th>                                
                                                <th class="dualHeader1" v-b-tooltip.hover :title = "$t(' 85+ ')" colspan="1">85+</th>
                                            </tr>                                
                                            <tr>
                                                <td class="table_pre_row"></th>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.special_gPlus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.special_gMinus.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time15_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time15_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time30_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time30_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time45_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time45_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time60_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time60_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time75_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time75_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time90_S.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.time90_C.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.special_gs1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.special_gc1.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.over40.option"
                                                    />
                                                </td>
                                                <td style="padding: 0px;" class="search-table-cell">
                                                    <CSelect
                                                        style="margin-bottom:  0px;" 
                                                        :options="coldStat_options"
                                                        :value.sync="coldStat_model5.timeBands4.over85.option"
                                                    />
                                                </td>
                                            </tr> 
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.special_gPlus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.special_gMinus.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time15_S.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time15_C.min"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time30_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time30_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time45_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time45_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time60_S.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time60_C.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time75_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time75_C.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time90_S.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time90_C.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.gs1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.special_gs1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.special_gc1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.over40.min"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.over85.min"></CInput>
                                                </td> 
                                            </tr>
                                             <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.special_gPlus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.special_gMinus.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time15_S.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time15_C.max"></CInput>
                                                </td> 
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time30_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time30_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time45_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time45_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time60_S.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time60_C.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time75_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time75_C.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time90_S.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.time90_C.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.gs1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.special_gs1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.special_gc1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.over40.max"></CInput>
                                                </td>                                 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="coldStat_model5.timeBands4.over85.max"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CCol>
                                </CTab>
                            </CTabs>
                                
                        </CRow>
                    </div>
                    <div title="historical live stat">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Historical live stat") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="12">                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Goals") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                        <th class="dualHeader1" colspan="1">in</th>
                                        <th class="dualHeader1" colspan="1">out</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                        <th class="dualHeader1" colspan="1">DA</th>
                                        <th class="dualHeader1" colspan="1">Poss</th>                                
                                        <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th> 
                                        <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">comparison</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.goals.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.on.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.off.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.in.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.out.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.cnr.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.da.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.pos.option"
                                            />
                                        </td> 
                                        
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.sbst.option"
                                            />
                                        </td>                                
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="historical_livestatsOptions"
                                                :value.sync="historicallivestats_model5.rtg.option"
                                            />
                                        </td> 
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.goals.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.on.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.off.value"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.in.value"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.out.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.cnr.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.da.value"></CInput>
                                        </td> 
                                       <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.pos.value"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.sbst.value"></CInput>
                                        </td>                                 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="historicallivestats_model5.rtg.value"></CInput>
                                        </td> 
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="value stat page">

                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Value stat page</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions1"
                                            :value.sync="valueStat_model5.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="valueStatsOptions2"
                                            :value.sync="valueStat_model5.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect
                                                placeholder="select..."
                                                :options="valueStatsOptions1"
                                                :value.sync="valueStat_model5.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="valueStatsOptions2"
                                                :value.sync="valueStat_model5.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        <p style="padding: 3px; height: 38px;"></p>                            
                                        <p class="value" style="padding: 3px; height: 38px;">From Home</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">From Away</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Win</p>
                                        <p class="value">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.lastmatches.home.win"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.lastmatches.away.win"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Draw</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.lastmatches.home.draw"> </CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.lastmatches.away.draw"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Lose</p>
                                        <p class="value">
                                           <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.lastmatches.home.lose"></CInput>
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="valueStat_model5.lastmatches.away.lose"></CInput>
                                        </p>
                                    </div>
                                     <div style="flex: 1.5; text-align: center;">
                                        <p class="value" style="padding: 3px; height: 38px;">Option</p>
                                        <p class="value">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model5.lastmatches.home.option"
                                            />
                                        </p>
                                        <p class="percent">
                                           <CSelect                                
                                                placeholder="select..."
                                                :options="lastMatchesOptions"
                                                :value.sync="valueStat_model5.lastmatches.away.option"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    label="Years"
                                    placeholder="select..."
                                    :options="valueStatsYearsOptions"
                                    :value.sync="valueStat_model5.years"
                                />
                            </CCol>
                            <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Stat %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.stat_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.stat_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>


                                   
                                </table>
                            </CCol>

                             <CCol sm="12">
                                    
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">Value %</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">BTS</th>
                                        <th class="dualHeader1" colspan="1">Over 1.5</th>
                                        <th class="dualHeader1" colspan="1">Over 2.5</th>
                                        <th class="dualHeader1" colspan="1">Over 3.5</th>                            
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">1y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">1y, 10y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_10.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_10.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_10.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_10.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_10.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_10.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_1_10.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_10.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_10.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_10.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_10.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_10.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_10.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_1_10.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>

                                    <tr > 
                                        <td class="table_pre_row">10y, 3y(x, y)</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_10_3.home.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_10_3.draw.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_10_3.away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_10_3.bts.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_10_3.O_15.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_10_3.O_25.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom:  0px;"
                                                placeholder="select..."
                                                :options="valueStat_comparisonOptions"
                                                :value.sync="valueStat_model5.value_10_3.O_35.option"
                                            />
                                        </td> 
                                       
                                    </tr>
                                   <tr > 
                                        <td class="table_pre_row">offset</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_10_3.home.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_10_3.draw.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_10_3.away.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_10_3.bts.offset"></CInput>
                                        </td> 
                                         <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_10_3.O_15.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_10_3.O_25.offset"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="valueStat_model5.value_10_3.O_35.offset"></CInput>
                                        </td> 
                                       
                                    </tr>
                                   
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="league stat">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">League stat (or Scheduled games)</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">stat %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions1"
                                            :value.sync="leagueStat_model5.stat.minOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model5.stat.minValue"></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                            placeholder="select..."
                                            :options="oddsOptions2"
                                            :value.sync="leagueStat_model5.stat.maxOption"
                                        />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model5.stat.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="totalMatches" style="display: flex; font-weight: 600;">

                                    <div style="flex: 1; text-align: center;">
                                        
                                        <p class="value" style="padding: 3px; height: 38px;">value %</p>
                                        <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions1"
                                                :value.sync="leagueStat_model5.value.minOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model5.value.minValue"  ></CInput>
                                        </p>
                                    </div>
                                    <div style="flex: 1.5; text-align: center;">
                                        
                                        <p class="value">
                                            <CSelect                                
                                                placeholder="select..."
                                                :options="oddsOptions2"
                                                :value.sync="leagueStat_model5.value.maxOption"
                                            />
                                        </p>
                                        <p class="percent">
                                            <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="leagueStat_model5.value.maxValue"></CInput>
                                        </p>
                                    </div>
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (>=)" :value.sync="leagueStat_model5.minMatches"></CInput>
                            </CCol>
                            <CCol sm="4">
                                <CInput type="number" min="0" max="90" label="Matches sample (<)" :value.sync="leagueStat_model5.maxMatches"></CInput>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="team analysis">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Team analysis") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <label>{{ $t("Home") }}</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model5.home.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model5.home.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model5.home.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model5.home.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model5.home.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model5.home.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model5.home.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model5.home.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model5.away.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="teamAnalysis_model5.away.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model5.away.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="teamAnalysis_model5.away.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model5.away.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="teamAnalysis_model5.away.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model5.away.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="teamAnalysis_model5.away.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="12">
                                <label>Home VS Away teams by unit</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>
                                        <th style="height: 30px" colspan="1"></th>     
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Pre</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Live</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Diff</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">DEF vs FWD</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.pre.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.pre.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.pre.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.live.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.live.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.live.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.diff.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.diff.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.diff.df.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">MID vs MID</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.pre.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.pre.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.pre.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.live.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.live.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.live.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.diff.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.diff.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.diff.mm.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">FWD vs DEF</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.pre.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.pre.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.pre.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.live.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.live.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.live.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="teamAnalysis_model5.diff.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.diff.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.diff.fd.maxValue"></CInput></td>
                                    </tr> 
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Next match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.home_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model5.home_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model5.home_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model5.home_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.home_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model5.home_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Next match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days left</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.away_upcoming.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model5.away_upcoming.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model5.away_upcoming.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model5.away_upcoming.leg"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.away_upcoming.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model5.away_upcoming.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <label>Home team Latest match</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.home_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model5.home_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model5.home_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model5.home_latest.leg"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model5.home_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.home_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model5.home_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away team Latest match</label>
                               <table style="width:  100%; font-size: 13.5px;">                  
                                    
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Opp.rank</th>
                                        <th class="dualHeader1" colspan="1">Days ago</th>
                                        <th class="dualHeader1" colspan="1">League type</th>
                                        <th class="dualHeader1" colspan="1">Leg</th>
                                        <th class="dualHeader1" colspan="1">Outcome</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.away_latest.rank.min"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model5.away_latest.day_left.min"></CInput></td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="leagueTypeOptions"
                                                :value.sync="teamAnalysis_model5.away_latest.league_type"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="legOptions"
                                                :value.sync="teamAnalysis_model5.away_latest.leg"
                                            />
                                        </td> 
                                         <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="outcomeOptions"
                                                :value.sync="teamAnalysis_model5.away_latest.outcome"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.away_latest.rank.max"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  :value.sync="teamAnalysis_model5.away_latest.day_left.max"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>

                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th> 
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model5.keyPlayers[0].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model5.keyPlayers[0].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model5.keyPlayers[0].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model5.keyPlayers[0].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model5.keyPlayers[0].keyPlayers.option"
                                            />
                                        </td>  
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].keyPlayers.min"></CInput></td> 
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[0].keyPlayers.max"></CInput></td> 
                                    </tr>
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model5.keyPlayers[1].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model5.keyPlayers[1].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model5.keyPlayers[1].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="teamAnalysis_model5.keyPlayers[1].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="teamAnalysis_model5.keyPlayers[1].keyPlayers.option"
                                            />
                                        </td>  
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].keyPlayers.min"></CInput></td> 
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].away.max"></CInput></td>
                                         <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="teamAnalysis_model5.keyPlayers[1].keyPlayers.max"></CInput></td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="live stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Live stats") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="3">
                                <CSelect
                                    placeholder="select..."
                                    label="Status"
                                    :options="eventStatusOptions"
                                    :value.sync="livestats_model5.status"
                                    
                                />
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (>=)" :value.sync="livestats_model5.minMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (<)" :value.sync="livestats_model5.maxMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <label>Random</label>
                                <CInputCheckbox class="check-box"
                                    :checked.sync = "livestats_model5.min_random"
                                >
                                </CInputCheckbox>
                            </CCol>
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model5.oddpre" :title="livestats_model5.oddpre[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model5.oddpre[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                    
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">
                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd pre</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1"
                                                        :value.sync="livestats_model5.oddpre[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model5.oddpre[index].minValue"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2"
                                                        :value.sync="livestats_model5.oddpre[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model5.oddpre[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>                                    
                                    </CTab>
                                </CTabs>
                            </CCol>
                            
                            
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model5.oddlive" :title="livestats_model5.oddlive[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model5.oddlive[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd live</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1_"
                                                        :value.sync="livestats_model5.oddlive[index].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model5.oddlive[index].minValue"  ></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2_"
                                                        :value.sync="livestats_model5.oddlive[index].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="livestats_model5.oddlive[index].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                            
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model5.minStats" :title="livestats_model5.minStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model5.minStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score => X,Y</th>
                                                <th class="dualHeader1" colspan="1">On => X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off => X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner => X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank => X,Y</th>
                                                <th class="dualHeader1" colspan="1">red => X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel => X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst => X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI => X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM => X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG => X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                     <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.minStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model5.maxStats" :title="livestats_model5.maxStats[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model5.maxStats[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score < X,Y</th>
                                                <th class="dualHeader1" colspan="1">On < X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off < X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner < X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank < X,Y</th>
                                                <th class="dualHeader1" colspan="1">red < X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel < X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst < X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI < X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM < X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG < X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.maxStats[index].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model5.comparison" :title="livestats_model5.comparison[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model5.comparison[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("rank") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("red") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("yel") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("INI") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("PFM") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">comparison</th>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].score.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].on.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].off.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].corner.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].rank.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].red.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].yel.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].sbst.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].ini.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].pfm.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="livestats_model5.comparison[index].rtg.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">offset</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].score.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].on.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].off.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].corner.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].rank.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].red.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].yel.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].sbst.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].ini.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].pfm.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.comparison[index].rtg.value"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="9">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index) in livestats_model5.time_from_to" :title="livestats_model5.time_from_to[index].check ? 'table ' + (index+1) + ' *' : 'table ' + (index+1)" :key="index">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "livestats_model5.time_from_to[index].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Over 0.5</th>
                                                <th class="dualHeader1" colspan="1">Over 1.5</th>
                                                <th class="dualHeader1" colspan="1">Over 2.5</th>
                                                <th class="dualHeader1" colspan="1">Over 3.5</th>
                                                <th class="dualHeader1" colspan="1">Under 0.5</th>
                                                <th class="dualHeader1" colspan="1">Under 1.5</th>
                                                <th class="dualHeader1" colspan="1">Under 2.5</th>
                                                <th class="dualHeader1" colspan="1">Under 3.5</th>
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over35.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under35.from"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over35.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under35.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">BTS Yes</th>
                                                <th class="dualHeader1" colspan="1">BTS No</th>
                                                <th class="dualHeader1" colspan="1">Ov 0.5 HT</th>
                                                <th class="dualHeader1" colspan="1">Un 0.5 HT</th>                            
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].home.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].draw.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].away.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].btsyes.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].btsno.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over05ht.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under05ht.from"></CInput>
                                                </td> 
                                            </tr>
                                           <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].home.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].draw.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].away.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].btsyes.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].btsno.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].over05ht.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="livestats_model5.time_from_to[index].under05ht.to"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>                            
                        </CRow>
                    </div>
                    <div title="Strategy statistics">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy statistics</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyStats_model[4].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="strategyStats_model[4].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[4].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].total_matches.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].all[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                           <CTab v-for="(num, index_) in 4" :title="strategyStats_model[4].special_strategyOptions_all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[4].special_strategyOptions_all[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[4].special_strategyOptions_all[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[4].special_strategyOptions_all[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[4].special_strategyOptions_all[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>

                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="strategyStats_model[4].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyStats_model[4].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].total_matches.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyStats_model[4].league[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="strategyStats_model[4].special_strategyOptions_league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "strategyStats_model[4].special_strategyOptions_league[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="strategyStats_model[4].special_strategyOptions_league[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="strategyStats_model[4].special_strategyOptions_league[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="strategyStats_model[4].special_strategyOptions_league[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>
                        
                    </div>
                    <div title="Strategy financial">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy financial</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="strategyFinancial_model[4].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[4].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[4].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[4].all[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].recent_max_loss_repeat.max"></CInput>
                                                </td>
                                                
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend2.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">All stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">All stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].all[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="strategyFinancial_model[4].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "strategyFinancial_model[4].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>               
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."                                                        
                                                        :options="tipSettledOptions"
                                                        :value.sync="strategyFinancial_model[4].league[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend2.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].recent_max_loss_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend2.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">League stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">League stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="strategyFinancial_model[4].league[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                    </div>
                    <div title="Sospeso predictions">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Sospeso predictions") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction type')"
                                    :options="sospesoPredictionOptions"
                                    :value.sync="sospesoPrediction_model[4].predictionType"
                                    
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    :label="$t('prediction filters')"
                                    :options="sospesoPredictionFilters"
                                    :value.sync="sospesoPrediction_model[4].predictionFilter"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;">
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Filtri quote Betfair</th>
                                        <th class="dualHeader1" colspan="1">Filtri abbinate</th>
                                        
                                    </tr>
                                    
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[4].odds_min"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[4].matches_min"></CInput>
                                        </td> 
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[4].odds_max"></CInput>
                                        </td> 
                                        <td style="padding: 0px">
                                            <CInput style="margin-bottom:  0px;" type="number" :value.sync="sospesoPrediction_model[4].matches_max"></CInput>
                                        </td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                </CTab>
            </CTabs>

            <div style="padding-top:  50px; text-align: center; color: red;border-bottom: 1px solid red;  line-height: 0.1em; margin: 10px 0 20px; ">
                <span style="padding:0 10px; background: #f5f5f5;">Cash out point:</span>
            </div>
            <CTabs variant="tabs" :active-tab="0">
                <CTab v-for="(n, index) in 5" :key="index" :title="'Entry ' + (index + 1)">
                    <CRow title="tip-option">
                        <CCol sm="2">
                            <CSelect
                                label="cashout"
                                :options="yesnoOptions"
                                :value.sync="cashout_model[index].tip.status"
                                
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                label="profit pts"
                                :value.sync="cashout_model[index].tip.profitPts"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                label="profit %"
                                :value.sync="cashout_model[index].tip.profitPercent"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                label="stop loss pts"
                                :value.sync="cashout_model[index].tip.stopLossPts"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                type="number"
                                label="stop loss %"
                                :value.sync="cashout_model[index].tip.stopLossPercent"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                type="number"
                                label="time from post"
                                :value.sync="cashout_model[index].tip.timeFromPost"
                            />
                        </CCol>

                        <CCol sm="2">
                            <CInput
                                type="number"
                                label="time before event start"
                                :value.sync="cashout_model[index].tip.timeBeforeEvent"
                            />
                        </CCol>
                        
                    </CRow>
                    <div title="team analysis">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Team analysis") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="6">
                                <label>{{ $t("Home") }}</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="cashout_teamAnalysis_model[index].home.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="cashout_teamAnalysis_model[index].home.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="cashout_teamAnalysis_model[index].home.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="cashout_teamAnalysis_model[index].home.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="cashout_teamAnalysis_model[index].home.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="cashout_teamAnalysis_model[index].home.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="cashout_teamAnalysis_model[index].home.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="cashout_teamAnalysis_model[index].home.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <label>Away</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>        
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="4">Diff rate pre/live %</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1">{{ $t("GK") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("DEF") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("MID") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("FWD") }}</th>
                                    </tr>
                                    
                                    <tr > 
                                        
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="cashout_teamAnalysis_model[index].away.minGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="min" :value.sync="cashout_teamAnalysis_model[index].away.minDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="cashout_teamAnalysis_model[index].away.minMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="min" :value.sync="cashout_teamAnalysis_model[index].away.minFWD"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="cashout_teamAnalysis_model[index].away.maxGK"></CInput></td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number"  placeholder="max" :value.sync="cashout_teamAnalysis_model[index].away.maxDEF"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="cashout_teamAnalysis_model[index].away.maxMID"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" placeholder="max" :value.sync="cashout_teamAnalysis_model[index].away.maxFWD"></CInput></td>
                                    </tr>
                                    
                                </table>
                            </CCol>
                            <CCol sm="12">
                                <label>Home VS Away teams by unit</label>
                                <table style="width:  100%; font-size: 13.5px;">
                                
                                    <tr>
                                        <th style="height: 30px" colspan="1"></th>     
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Pre</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Live</th>
                                        <th style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white; height: 30px" colspan="3">Diff</th>
                                    </tr>
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                        <th class="dualHeader1" colspan="1">H+ / A+</th>
                                        <th class="dualHeader1" colspan="1">Value % >=</th>
                                        <th class="dualHeader1" colspan="1">Value % <</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row">DEF vs FWD</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].pre.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].pre.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].pre.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].live.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].live.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].live.df.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].diff.df.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].diff.df.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].diff.df.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">MID vs MID</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].pre.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].pre.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].pre.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].live.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].live.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].live.mm.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].diff.mm.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].diff.mm.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].diff.mm.maxValue"></CInput></td>
                                        
                                    </tr>
                                    <tr > 
                                        <td class="table_pre_row">FWD vs DEF</th>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].pre.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].pre.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].pre.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].live.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].live.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].live.fd.maxValue"></CInput></td>
                                       <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="teamAnalysisOptions"
                                                :value.sync="cashout_teamAnalysis_model[index].diff.fd.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].diff.fd.minValue"></CInput></td>
                                       <td style="padding: 0px"> <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].diff.fd.maxValue"></CInput></td>
                                    </tr> 
                                </table>
                            </CCol>
                            
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].keyPlayers.min"></CInput></td>  
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[0].keyPlayers.max"></CInput></td> 
                                    </tr>
                                </table>
                            </CCol>
                            <CCol sm="6">
                                <table style="width:  100%; font-size: 13.5px;"> 
                                    <tr style="background: #b7eafc;">
                                        <th class="dualHeader1" colspan="1"></th>
                                        <th class="dualHeader1" colspan="1">Atk key players pre</th>
                                        <th class="dualHeader1" colspan="1">Atk key players live</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                        <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                        <th class="dualHeader1" colspan="1">Key players</th>
                                    </tr>
                                    
                                    <tr > 
                                        <td class="table_pre_row"></th> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].pre.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].live.option"
                                            />
                                        </td> 
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].home.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption2"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].away.option"
                                            />
                                        </td>
                                        <td style="padding: 0px">
                                            <CSelect
                                                style="margin-bottom: 0px;"
                                                placeholder="select..."
                                                :options="keyPlayersOption1"
                                                :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].keyPlayers.option"
                                            />
                                        </td> 
                                        
                                    </tr>
                                    <tr> 
                                        <td class="table_pre_row">{{ $t("min") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].pre.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].live.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].home.min"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].away.min"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].keyPlayers.min"></CInput></td> 
                                    </tr>
                                   <tr> 
                                        <td class="table_pre_row">{{ $t("max") }}</th>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].pre.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].live.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].home.max"></CInput></td> 
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].away.max"></CInput></td>
                                        <td style="padding: 0px"><CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_teamAnalysis_model[index].keyPlayers[1].keyPlayers.max"></CInput></td> 
                                    </tr>
                                </table>
                            </CCol>
                        </CRow>
                    </div>
                    <div title="historical live stat">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Historical live stat") }}</span>
                        </div>
                        <CRow>

                            <CCol sm="12">
                                    
                                    <table style="width:  100%; font-size: 13.5px;">
                                        <tr style="background: #b7eafc;">
                                            <th class="dualHeader1" colspan="1"></th>
                                            <th class="dualHeader1" colspan="1">{{ $t("Goals") }}</th>
                                            <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                            <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                            <th class="dualHeader1" colspan="1">in</th>
                                            <th class="dualHeader1" colspan="1">out</th>
                                            <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                            <th class="dualHeader1" colspan="1">DA</th>
                                            <th class="dualHeader1" colspan="1">Poss</th>                                
                                            <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th> 
                                            <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                        </tr>
                                        
                                        <tr > 
                                            <td class="table_pre_row">comparison</th>
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].goals.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].on.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].off.option"
                                                />
                                            </td>
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].in.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].out.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].cnr.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].da.option"
                                                />
                                            </td> 
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].pos.option"
                                                />
                                            </td> 
                                            
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].sbst.option"
                                                />
                                            </td>                                
                                            <td style="padding: 0px">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    placeholder="select..."
                                                    :options="historical_livestatsOptions"
                                                    :value.sync="cashout_historicallivestats_model[index].rtg.option"
                                                />
                                            </td> 
                                        </tr>
                                        <tr > 
                                            <td class="table_pre_row">offset</th>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].goals.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].on.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].off.value"></CInput>
                                            </td> 
                                             <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].in.value"></CInput>
                                            </td> 
                                             <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].out.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].cnr.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].da.value"></CInput>
                                            </td> 
                                           <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].pos.value"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].sbst.value"></CInput>
                                            </td>                                 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_historicallivestats_model[index].rtg.value"></CInput>
                                            </td> 
                                        </tr>
                                       
                                    </table>
                                </CCol>
                                <CCol sm="6">
                                
                            </CCol>
                            
                        </CRow>
                    </div>
                    <div title="live stats page">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">{{ $t("Live stats") }}</span>
                        </div>
                        <CRow>
                            <CCol sm="3">
                                <CSelect
                                    placeholder="select..."
                                    label="Status"
                                    :options="eventStatusOptions"
                                    :value.sync="cashout_livestats_model[index].status"
                                    
                                />
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (>=)" :value.sync="cashout_livestats_model[index].minMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <CInput type="number" min="0" max="90" label="current Time (<)" :value.sync="cashout_livestats_model[index].maxMinute"></CInput>
                            </CCol>
                            <CCol sm="3">
                                <label>Random</label>
                                <CInputCheckbox class="check-box"
                                    :checked.sync = "cashout_livestats_model[index].min_random"
                                >
                                </CInputCheckbox>
                            </CCol>
                            
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="cashout_livestats_model[index].oddpre[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_livestats_model[index].oddpre[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd pre</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1"
                                                        :value.sync="cashout_livestats_model[index].oddpre[index_].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="cashout_livestats_model[index].oddpre[index_].minValue"></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2"
                                                        :value.sync="cashout_livestats_model[index].oddpre[index_].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="cashout_livestats_model[index].oddpre[index_].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="6">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="cashout_livestats_model[index].oddlive[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_livestats_model[index].oddlive[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <div class="totalMatches" style="display: flex; font-weight: 600;">

                                            <div style="flex: 1; text-align: center;">
                                                
                                                <p class="value" style="padding: 3px; height: 38px;">Odd live</p>
                                                <p class="percent" style="padding: 3px;height: 38px;">y</p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions1_"
                                                        :value.sync="cashout_livestats_model[index].oddlive[index_].minOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="cashout_livestats_model[index].oddlive[index_].minValue"  ></CInput>
                                                </p>
                                            </div>
                                            <div style="flex: 1.5; text-align: center;">
                                                
                                                <p class="value">
                                                    <CSelect                                
                                                        placeholder="select..."
                                                        :options="live_oddsOptions2_"
                                                        :value.sync="cashout_livestats_model[index].oddlive[index_].maxOption"
                                                    />
                                                </p>
                                                <p class="percent">
                                                    <CInput type="number" min="0" max="90000000"  class="minOdd1" :value.sync="cashout_livestats_model[index].oddlive[index_].maxValue"></CInput>
                                                </p>
                                            </div>
                                        </div>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="cashout_livestats_model[index].minStats[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_livestats_model[index].minStats[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score => X,Y</th>
                                                <th class="dualHeader1" colspan="1">On => X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off => X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner => X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank => X,Y</th>
                                                <th class="dualHeader1" colspan="1">red => X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel => X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst => X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI => X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM => X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG => X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].minStats[index_].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="cashout_livestats_model[index].maxStats[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_livestats_model[index].maxStats[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score < X,Y</th>
                                                <th class="dualHeader1" colspan="1">On < X,Y</th>
                                                <th class="dualHeader1" colspan="1">Off < X,Y</th>
                                                <th class="dualHeader1" colspan="1">corner < X,Y</th>
                                                <th class="dualHeader1" colspan="1">rank < X,Y</th>
                                                <th class="dualHeader1" colspan="1">red < X,Y</th>
                                                <th class="dualHeader1" colspan="1">yel < X,Y</th>
                                                <th class="dualHeader1" colspan="1">sbst < X,Y</th>
                                                <th class="dualHeader1" colspan="1">INI < X,Y</th>
                                                <th class="dualHeader1" colspan="1">PFM < X,Y</th>
                                                <th class="dualHeader1" colspan="1">RTG < X,Y</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">home X</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].home.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">away Y</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.score"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.on"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.off"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.corner"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.rank"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.red"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.yel"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.sbst"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.ini"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.pfm"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].away.rtg"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">From time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].score.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].on.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].off.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].corner.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].red.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].yel.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].sbst.fromtime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].rtg.fromtime"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">To time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].score.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].on.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].off.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].corner.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].red.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].yel.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].sbst.totime"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].maxStats[index_].rtg.totime"></CInput>
                                                </td>
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="cashout_livestats_model[index].comparison[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_livestats_model[index].comparison[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Score</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("On") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Off") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("corner") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("rank") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("red") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("yel") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sbst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("INI") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("PFM") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("RTG") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">comparison</th>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].score.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].on.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].off.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].corner.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].rank.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].red.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].yel.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].sbst.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].ini.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].pfm.option"
                                                    />
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="comparisonOptions"
                                                        :value.sync="cashout_livestats_model[index].comparison[index_].rtg.option"
                                                    />
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">offset</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].score.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].on.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].off.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].corner.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].rank.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].red.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].yel.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].sbst.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].ini.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].pfm.value"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].comparison[index_].rtg.value"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                            <CCol sm="9">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="cashout_livestats_model[index].time_from_to[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_livestats_model[index].time_from_to[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">Over 0.5</th>
                                                <th class="dualHeader1" colspan="1">Over 1.5</th>
                                                <th class="dualHeader1" colspan="1">Over 2.5</th>
                                                <th class="dualHeader1" colspan="1">Over 3.5</th>
                                                <th class="dualHeader1" colspan="1">Under 0.5</th>
                                                <th class="dualHeader1" colspan="1">Under 1.5</th>
                                                <th class="dualHeader1" colspan="1">Under 2.5</th>
                                                <th class="dualHeader1" colspan="1">Under 3.5</th>
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over35.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under05.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under15.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under25.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under35.from"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over35.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under05.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under15.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under25.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under35.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">BTS Yes</th>
                                                <th class="dualHeader1" colspan="1">BTS No</th>
                                                <th class="dualHeader1" colspan="1">Ov 0.5 HT</th>
                                                <th class="dualHeader1" colspan="1">Un 0.5 HT</th>                            
                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">from time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].home.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].draw.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].away.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].btsyes.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].btsno.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over05ht.from"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under05ht.from"></CInput>
                                                </td> 
                                            </tr>
                                           <tr > 
                                                <td class="table_pre_row">to time</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].home.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].draw.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].away.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].btsyes.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].btsno.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].over05ht.to"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_livestats_model[index].time_from_to[index_].under05ht.to"></CInput>
                                                </td> 
                                            </tr>
                                           
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                    </div>                    
                    <div title="Strategy statistics">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy statistics</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="cashout_strategyStats_model[index].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="cashout_strategyStats_model[index].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_strategyStats_model[index].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].total_matches.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].home_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].all[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="cashout_strategyStats_model[index].special_strategyOptions_all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "cashout_strategyStats_model[index].special_strategyOptions_all[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="cashout_strategyStats_model[index].special_strategyOptions_all[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="cashout_strategyStats_model[index].special_strategyOptions_all[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="cashout_strategyStats_model[index].special_strategyOptions_all[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>

                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(num, index_) in 4" :title="cashout_strategyStats_model[index].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_strategyStats_model[index].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("home pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("draw pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("away pt") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2nd Half") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("total") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 PT") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("0.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1.5 SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("2.5 SH") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].total_matches.min"></CInput>
                                                </td>
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].home_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].draw_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].away_win_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].home_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].draw_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].away_pt_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].avg_firsthalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].avg_secondhalf_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].avg_total_goals_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].first_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].first_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].first_25_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].sh_05_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].sh_15_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].sh_25_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].total_matches.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].home_win_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].draw_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].away_win_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].home_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].draw_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].away_pt_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].avg_firsthalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].avg_secondhalf_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].avg_total_goals_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].first_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].first_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].first_25_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].sh_05_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].sh_15_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].sh_25_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">0.5</th>
                                                <th class="dualHeader1" colspan="1">1.5</th>
                                                <th class="dualHeader1" colspan="1">2.5</th>
                                                <th class="dualHeader1" colspan="1">3.5</th>
                                                <th class="dualHeader1" colspan="1">4.5</th>
                                                <th class="dualHeader1" colspan="1">Bts</th>
                                                <th class="dualHeader1" colspan="1">0 - 15</th>
                                                <th class="dualHeader1" colspan="1">16 - 30</th>
                                                <th class="dualHeader1" colspan="1">31 - 45</th>
                                                <th class="dualHeader1" colspan="1">46 - 60</th>
                                                <th class="dualHeader1" colspan="1">61 - 75</th>
                                                <th class="dualHeader1" colspan="1">76 - 90</th>
                                                <th class="dualHeader1" colspan="1">1st Goal avg HT</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("1st Goal avg SH") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Home") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("H Win") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Away") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("A Win") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_05_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_25_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_35_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].bts_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_15_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_30_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_45_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_60_percent.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_75_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_90_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].ht_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].sh_firstGoal_min_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].fts_h_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].fts_hw_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].fts_a_percent.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].fts_aw_percent.min"></CInput>
                                                </td>
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_05_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_25_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_35_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].full_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].bts_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_15_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_30_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_45_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_60_percent.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_75_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].goal_bands_90_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].ht_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].sh_firstGoal_min_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].fts_h_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].fts_hw_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].fts_a_percent.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyStats_model[index].league[index_].fts_aw_percent.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                        <CTabs variant="tabs" :active-tab="0">
                            <CTab v-for="(num, index_) in 4" :title="cashout_strategyStats_model[index].special_strategyOptions_league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                <div style="height: 22px;">
                                    <CInputCheckbox class="check-box"
                                        :checked.sync = "cashout_strategyStats_model[index].special_strategyOptions_league[index_].check"
                                    >
                                    <template #label>
                                        {{ $t('check this table?') }}
                                    </template>
                                    </CInputCheckbox>
                                </div>
                                <CRow>
                                <CCol sm="4">
                                    <CSelect
                                        placeholder="select..."
                                        label="special options"
                                        :options="special_strategyOptions"
                                        :value.sync="cashout_strategyStats_model[index].special_strategyOptions_league[index_].option"
                                        
                                    />
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="min" type="number" :value.sync="cashout_strategyStats_model[index].special_strategyOptions_league[index_].min"></CInput>
                                </CCol>
                                <CCol sm="4">
                                    <CInput style="margin-bottom:  0px;" label="max" type="number" :value.sync="cashout_strategyStats_model[index].special_strategyOptions_league[index_].max"></CInput>
                                </CCol>
                                </CRow>

                            </CTab>
                        </CTabs>
                        
                    </div>
                    <div title="Strategy financial">
                        <div style="margin-bottom: 5px;">
                            <span style="color: blue;">Strategy financial</span>
                        </div>
                        <CRow>
                            <CCol sm="4">
                                <CSelect
                                    placeholder="select..."
                                    label="select strategy"
                                    :options="strategyOptions[0].items"
                                    :value.sync="cashout_strategyFinancial_model[index].strategy"
                                    
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="cashout_strategyFinancial_model[index].all[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>All stats</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_strategyFinancial_model[index].all[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>                                                
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."
                                                        :options="tipSettledOptions"
                                                        :value.sync="cashout_strategyFinancial_model[index].all[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].recent_max_loss_repeat.max"></CInput>
                                                </td>
                                                
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend2.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">All stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">All stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].all[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab v-for="(item, index_) in 4" :title="cashout_strategyFinancial_model[index].league[index_].check ? 'table ' + (index_+1) + ' *' : 'table ' + (index_+1)" :key="index_">
                                    
                                        <span>{{ $t("League stats") }}</span>
                                        <div style="height: 22px;">
                                            <CInputCheckbox class="check-box"
                                                :checked.sync = "cashout_strategyFinancial_model[index].league[index_].check"
                                            >
                                            <template #label>
                                                {{ $t('check this table?') }}
                                            </template>
                                            </CInputCheckbox>
                                        </div>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            <tr style="background: #b7eafc;">
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="1" style="min-width: 100px;"></th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                                                <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Profits in row') }}</th>
                                                <th colspan="5" style="min-width: 150px;">{{ $t('Losses in row') }}</th>
                                                <th colspan="1" style="min-width: 160px;"></th>
                                            </tr>
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("sample") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Win Rate") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Profit factor") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Entry") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Cashout") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Back") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Lay") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("current") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("last_bet") }}</th>               
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].sample.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_rate.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].profit_factor.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].avg_entry_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].avg_cashout_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].avg_entry_back_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].avg_entry_lay_odds.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].recent_max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].max_win_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend1.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend2.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].recent_max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].max_loss_repeat.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_avg.min"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CSelect
                                                        style="margin-bottom:  0px;"
                                                        placeholder="select..."                                                        
                                                        :options="tipSettledOptions"
                                                        :value.sync="cashout_strategyFinancial_model[index].league[index_].last_bet"
                                                        
                                                    />
                                                </td> 
                                               
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].sample.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_rate.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].profit_factor.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].avg_entry_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].avg_cashout_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].avg_entry_back_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].avg_entry_lay_odds.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].recent_max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].max_win_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_avg.max"></CInput>
                                                </td>
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend1.max"></CInput>
                                                </td>
                                                 <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend2.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].recent_max_loss_repeat.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].max_loss_repeat.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_avg.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend1.max"></CInput>
                                                </td>
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend2.max"></CInput>
                                                </td>
                                            </tr>
                                        </table>
                                        <span style="padding-top: 5px;">League stats Win in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Best") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Best") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].current_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend1_best.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend2_best.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].current_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend1_best.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].win_trend2_best.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>

                                        <span style="padding-top: 5px;">League stats Losses in row comparison</span>
                                        <table style="width:  100%; font-size: 13.5px;">
                                            
                                            <tr style="background: #b7eafc;">
                                                <th class="dualHeader1" colspan="1"></th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Avg") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Current >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg <= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend1") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Avg >= Trend2") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend1 <= Worst") }}</th>
                                                <th class="dualHeader1" colspan="1">{{ $t("Trend2 <= Worst") }}</th>
                                            </tr>
                                            
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("min") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].current_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_current_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_current_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_current_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_avg_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend1_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend2_current.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_avg_trend1.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_avg_trend2.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend1_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend2_avg.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend1_worst.min"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend2_worst.min"></CInput>
                                                </td> 
                                            </tr>
                                            <tr > 
                                                <td class="table_pre_row">{{ $t("max") }}</th>
                                                <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].current_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_current_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_current_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_current_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_avg_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend1_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend2_current.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_avg_trend1.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_avg_trend2.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend1_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend2_avg.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend1_worst.max"></CInput>
                                                </td> 
                                                <td style="padding: 0px">
                                                    <CInput style="margin-bottom:  0px;" type="number" :value.sync="cashout_strategyFinancial_model[index].league[index_].loss_trend2_worst.max"></CInput>
                                                </td> 
                                            </tr>
                                        </table>
                                    </CTab>
                                </CTabs>
                            </CCol>
                        </CRow>
                        
                    </div>
                    <label style="text-decoration: underline;">Cover</label>
                    <CRow title="cover-option">
                        <CCol sm="2">
                            <CSelect
                                label="Cover cashout"
                                :options="yesnoOptions"
                                :value.sync="cashout_model[index].cover.status"
                                
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                label="profit pts"
                                :value.sync="cashout_model[index].cover.profitPts"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                label="profit %"
                                :value.sync="cashout_model[index].cover.profitPercent"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                label="stop loss pts"
                                :value.sync="cashout_model[index].cover.stopLossPts"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                label="stop loss %"
                                :value.sync="cashout_model[index].cover.stopLossPercent"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                type="number"
                                label="time from post"
                                :value.sync="cashout_model[index].cover.timeFromPost"
                            />
                        </CCol>
                        <CCol sm="2">
                            <CInput
                                type="number"
                                label="time before event start"
                                :value.sync="cashout_model[index].cover.timeBeforeEvent"
                            />
                        </CCol>
                        <!-- <CCol sm="2">
                            <CInput
                                label="attempt to cashout"
                                :value.sync="cashout_model.cover.attemptToCashout"
                            />
                        </CCol> -->
                        
                    </CRow>
                </CTab>
            </CTabs>
            

            <div style="padding-top:  50px; text-align: center; color: red;border-bottom: 1px solid red;  line-height: 0.1em; margin: 10px 0 20px; ">
                
            </div>


            <div class="d-flex justify-content-end action-btns">
                <CButton
                    color="info"
                    class="m-2"
                    @click="handleReset"
                >
                    Reset
                </CButton>
                <CButton
                    id="save-action"
                    color="info"
                    class="m-2"
                    :disabled="(canPost || cover_canPost) || loading"
                    @click="handlePostTip"
                >
                    Save auto tip
                    <CSpinner v-if="loading" color="danger" size="sm" />
                </CButton>                
            </div>

            <label style="color: red;">Existing auto tips</label>
            <CRow>
                <CCol sm="12">                    
                    <table :key="routineKeys" style="width:  100%; font-size: 13.5px;">
                        <tr style="background: #b7eafc;">
                            <th class="dualHeader1" colspan="1">name</th>
                            <th class="dualHeader1" colspan="1">Repeat</th>
                            <th class="dualHeader1" colspan="1">description</th>
                            <th class="dualHeader1" colspan="1">status</th>
                            <th class="dualHeader1" colspan="1"></th>
                        </tr>
                        
                        <tr  v-for="(item, index) in  routines"> 
                            
                            <td>{{item.name}}</td>
                            <td>{{item.repeat == '10000' ? 'No limit' : item.repeat}}</td> 
                            <td>{{item.desc}}</td> 
                            <td v-if="item.status === 0">stopped</td> 
                            <td v-else>running...</td> 

                            <td>
                                <CButton
                                    color="info"
                                    class="m-2"                                    
                                    @click="routineClone(item._id)"
                                >
                                    clone
                                </CButton>
                                <CButton
                                    color="info"
                                    class="m-2"
                                    :disabled="item.status === 0"
                                    @click="routineStop(item._id)"
                                >
                                    stop
                                    <!-- <CSpinner v-if="stop_loading" color="danger" size="sm" /> -->
                                </CButton>
                                <CButton
                                    color="info"
                                    class="m-2"
                                    :disabled="item.status === 1"
                                    @click="routineStart(item._id)"

                                >
                                    start
                                    <!-- <CSpinner v-if="start_loading" color="danger" size="sm" /> -->
                                </CButton>
                                <CButton
                                    color="info"
                                    class="m-2"
                                    
                                    @click="routineEdit(item._id)"
                                >
                                    edit
                                   <!--  <CSpinner v-if="edit_loading" color="danger" size="sm" /> -->
                                </CButton>
                                <CButton
                                    color="info"
                                    class="m-2"
                                    
                                     @click="routineDelete(item._id)"
                                >
                                    delete
                                    <!-- <CSpinner v-if="delete_loading" color="danger" size="sm" />  -->
                                </CButton>
                            </td> 
                            
                            
                        </tr>
                        
                        
                        
                    </table>
                </CCol>
                
            </CRow>
            
        </CCard>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    import swal from "sweetalert2";


    import {displaySuccess, displayError} from '../helpers/message';
    import {convertUTCToLocal} from '../helpers/time';

    export default {
        name: 'PostTip',
        components: {
            Multiselect 
        },
        data () {
            return {
                repeatDays: [
                    { value: "1", label: "Monday"},
                    { value: "2", label: "Tuesday"},
                    { value: "3", label: "Wednesday"},
                    { value: "4", label: "Thursday"},
                    { value: "5", label: "Friday"},
                    { value: "6", label: "Saturday"},
                    { value: "0", label: "Sunday"}
                ],
                timeBeforeEvent: '',
                timeAfterEvent: '',
                timeBeforeEvent2: '',
                timeAfterEvent2: '',
                timeBeforeEvent3: '',
                timeAfterEvent3: '',
                timeBeforeEvent4: '',
                timeAfterEvent4: '',
                timeBeforeEvent5: '',
                timeAfterEvent5: '',
                routineKeys: 0,
                stop_loading: false,
                start_loading: false,
                edit_loading: false,
                delete_loading: false,
                routineId: null,
                main_model: {
                    routine_name: '',
                    repeat: '10000',
                    desc: '',
                    user: ''
                },
                status: 1,                
                model: {
                    date: 0,
                    country: [],
                    league: [],
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: '',
                    teams: '',
                    team_side: 'Both',
                    exclude_team_side: 'Both',
                    exclude_teams: '',
                },
                model2: {
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: ''
                },
                model3: {
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: ''
                },
                model4: {
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: ''
                },
                model5: {
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: ''
                },
                coldStat_model: {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                },
                coldStat_model2: {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                },
                coldStat_model3: {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                },
                coldStat_model4: {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                },
                coldStat_model5: {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                },
                coldStat_options: [
                    { value: 'Home', label: this.$t('Home')},
                    { value: 'Away', label: this.$t('Away')},
                    { value: 'Home OR Away', label: this.$t('Home OR Away')},
                    { value: 'Home AND Away', label: this.$t('Home AND Away')},
                    { value: 'Home > Away', label: this.$t('Home > Away')},
                    { value: 'Home < Away', label: this.$t('Home < Away')},
                    { value: 'Home OR Away > Home OR Away', label: this.$t('Home OR Away > Home OR Away')},
                    { value: '', label: this.$t('None')}
                ],
                valueStat_model: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                },
                valueStat_model2: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                },
                valueStat_model3: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                },
                valueStat_model4: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                },
                valueStat_model5: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                },
                leagueStat_model: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                },
                leagueStat_model2: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                },
                leagueStat_model3: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                },
                leagueStat_model4: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                },
                leagueStat_model5: {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                },
                teamAnalysis_model: {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                },
                teamAnalysis_model2: {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                },
                teamAnalysis_model3: {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                },
                teamAnalysis_model4: {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                },
                teamAnalysis_model5: {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                },
                cashout_teamAnalysis_model: [
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    },
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    },
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    },
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    },
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    }
                ],
                historicallivestats_model: {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                },
                historicallivestats_model2: {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                },
                historicallivestats_model3: {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                },
                historicallivestats_model4: {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                },
                historicallivestats_model5: {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                },
                cashout_historicallivestats_model: [
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                ],
                livestats_model: {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                },
                livestats_model2: {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                },
                livestats_model3: {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                },
                livestats_model4: {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                },
                livestats_model5: {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                },
                cashout_livestats_model: [
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    },
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    },
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    },
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    },
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    }
                ],
                cashout_model: [
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        }
                    },
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        }
                    },
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        }
                    },
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        }
                    },
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0
                        }
                    }
                ],

                dateOptions: [
                    { value: 0, label: 'Current Day'},
                    { value: 1, label: 'Tomorrow'},
                    { value: 2, label: 'The day after tomorrow'},
                ],

                teamSideOptions: [
                    { value: 'Both', label: 'Both'},
                    { value: 'Home', label: 'Home'},
                    { value: 'Away', label: 'Away'},
                ],

                eventStatusOptions: [
                    { value: 'all', label: 'all'},
                    { value: 'Live', label: 'Live'},
                    { value: 'HT', label: 'HT'},
                    { value: 'NS', label: 'NS'},
                    { value: '', label: 'None'}
                ],
                yesnoOptions: [
                    'no',
                    'yes'                    
                ],
                teamAnalysisOptions: [
                    { value: 'H+', label: 'H+'},
                    { value: 'A+', label: 'A+'},
                    { value: 'Whatever', label: 'Whatever'},
                    { value: '', label: 'None'}
                ],
                leagueTypeOptions: [
                    { value: 'cup_international', label: 'cup_international'},
                    { value: 'domestic_cup', label: 'domestic_cup'},
                    { value: 'domestic', label: 'domestic'},
                    { value: 'international', label: 'international'},
                    { value: '', label: 'None'}
                ],
                legOptions: [
                    { value: '1/1', label: '1/1'},
                    { value: '1/2', label: '1/2'},
                    { value: '2/2', label: '2/2'},
                    { value: '', label: 'None'}
                ],
                outcomeOptions: [
                    { value: '1', label: '1'},
                    { value: 'X', label: 'X'},
                    { value: '2', label: '2'},
                    { value: '1X DC', label: '1X DC'},
                    { value: '12 DC', label: '12 DC'},
                    { value: 'X2 DC', label: 'X2 DC'},
                    { value: 'Over 0.5', label: 'Over 0.5'},
                    { value: 'Over 1.5', label: 'Over 1.5'},
                    { value: 'Over 2.5', label: 'Over 2.5'},
                    { value: 'Over 3.5', label: 'Over 3.5'},
                    { value: 'Over 4.5', label: 'Over 4.5'},
                    { value: 'Under 0.5', label: 'Under 0.5'},
                    { value: 'Under 1.5', label: 'Under 1.5'},
                    { value: 'Under 2.5', label: 'Under 2.5'},
                    { value: 'Under 3.5', label: 'Under 3.5'},
                    { value: 'Under 4.5', label: 'Under 4.5'},
                    { value: 'BTS', label: 'BTS'},
                    { value: 'No BTS', label: 'No BTS'},
                    { value: '1 ht', label: '1 ht'},
                    { value: 'X ht', label: 'X ht'},
                    { value: '2 ht', label: '2 ht'},
                    { value: 'Over 0.5 ht', label: 'Over 0.5 ht'},
                    { value: 'Over 1.5 ht', label: 'Over 1.5 ht'},
                    { value: 'Under 0.5 ht', label: 'Under 0.5 ht'},
                    { value: 'Under 1.5 ht', label: 'Under 1.5 ht'},
                    { value: '', label: 'None'},
                ],
                keyPlayersOption1: [
                    { value: "Home", label: "Home"},
                    { value: "Away", label: "Away"},
                    { value: "Home > Away", label: "Home > Away"},
                    { value: "Home < Away", label: "Home < Away"},
                    { value: "Home AND Away", label: "Home AND Away"},
                    { value: "Home OR Away", label: "Home OR Away"},
                    { value: "Home OR Away > Home OR Away", label: "Home OR Away > Home OR Away"},
                    { value: "", label: "None"},
                ],
                keyPlayersOption2: [
                    { value: "Pre", label: "Pre"},
                    { value: "Live", label: "Live"},
                    { value: "Pre > Live", label: "Pre > Live"},
                    { value: "Pre < Live", label: "Pre < Live"},
                    { value: "Pre AND Live", label: "Pre AND Live"},
                    { value: "Pre OR Live", label: "Pre OR Live"},
                    { value: "Pre OR Live > Pre OR Live", label: "Pre OR Live > Pre OR Live"},
                    { value: "", label: "None"},
                ],
                comparisonOptions: [
                    { value: 'home = away', label: 'home = away'},
                    { value: 'home > away', label: 'home > away'},
                    { value: 'home < away', label: 'home < away'},
                    { value: 'Minor than', label: 'Diff minor than'},
                    { value: 'Greater than', label: 'Diff greater than'},
                    { value: 'Sum greater than', label: 'Sum greater than'},
                    { value: 'Sum minor than', label: 'Sum minor than'},
                    { value: 'any home/away > home/away', label: 'any home/away > home/away'},
                    { value: 'Home OR Away greater than', label: 'Home OR Away greater than'},
                    { value: 'Home AND Away greater than', label: 'Home AND Away greater than'},
                    { value: 'Home OR Away minor than', label: 'Home OR Away minor than'},
                    { value: 'Home AND away minor than', label: 'Home AND away minor than'},
                    { value: 'Favourite greater than', label: 'Favourite greater than'},
                    { value: 'Underdog greater than', label: 'Underdog greater than'},
                    { value: 'Favourite minor than', label: 'Favourite minor than'},
                    { value: 'Underdog minor than', label: 'Underdog minor than'},
                    { value: 'Winning team greater than', label: 'Winning team greater than'},
                    { value: 'Loosing team greater than', label: 'Loosing team greater than'},
                    { value: 'Winning team minor than', label: 'Winning team minor than'},
                    { value: 'Loosing team minor than', label: 'Loosing team minor than'},
                    { value: '', label: 'None'}
                ],
                valueStat_comparisonOptions: [
                    { value: 'x >= y', label: 'x >= y'},
                    { value: 'x <= y', label: 'x <= y'},                    
                     { value: 'diff minor than', label: 'diff minor than'},
                    { value: 'diff greater than', label: 'diff greater than'},
                    { value: 'sum minor than', label: 'sum minor than'},
                    { value: 'sum greater than', label: 'sum greater than'},
                     { value: 'any x/y > x/y', label: 'any x/y > x/y'},
                    { value: '', label: 'None'}
                ],
                historical_livestatsOptions: [
                    { value: 'home minor than', label: 'home minor than'},
                    { value: 'away minor than', label: 'away minor than'},
                    { value: 'home greater than', label: 'home greater than'},
                    { value: 'away greater than', label: 'away greater than'},
                    { value: 'home minor than live', label: 'home minor than live'},
                    { value: 'away minor than live', label: 'away minor than live'},
                    { value: 'home greater than live', label: 'home greater than live'},
                    { value: 'away greater than live', label: 'away greater than live'},
                    { value: 'home = away', label: 'home = away'},
                    { value: 'home >= away', label: 'home >= away'},
                    { value: 'home <= away', label: 'home <= away'},
                    { value: 'diff minor than', label: 'diff minor than'},
                    { value: 'diff greater than', label: 'diff greater than'},
                    { value: 'sum minor than', label: 'sum minor than'},
                    { value: 'sum greater than', label: 'sum greater than'},                    
                    { value: 'any home/away > home/away', label: 'any home/away > home/away'},
                    { value: 'Home OR Away greater than', label: 'Home OR Away greater than'},
                    { value: 'Home AND Away greater than', label: 'Home AND Away greater than'},
                    { value: 'Home OR Away minor than', label: 'Home OR Away minor than'},
                    { value: 'Home AND away minor than', label: 'Home AND away minor than'},
                    { value: 'Home OR Away greater than live', label: 'Home OR Away greater than live'},
                    { value: 'Home AND Away greater than live', label: 'Home AND Away greater than live'},
                    { value: 'Home OR Away minor than live', label: 'Home OR Away minor than live'},
                    { value: 'Home AND away minor than live', label: 'Home AND away minor than live'},
                    { value: 'Favourite greater than', label: 'Favourite greater than'},
                    { value: 'Underdog greater than', label: 'Underdog greater than'},
                    { value: 'Favourite minor than', label: 'Favourite minor than'},
                    { value: 'Underdog minor than', label: 'Underdog minor than'},
                    { value: 'Winning team greater than', label: 'Winning team greater than'},
                    { value: 'Loosing team greater than', label: 'Loosing team greater than'},
                    { value: 'Winning team minor than', label: 'Winning team minor than'},
                    { value: 'Loosing team minor than', label: 'Loosing team minor than'},
                    { value: 'Favourite greater than live', label: 'Favourite greater than live'},
                    { value: 'Underdog greater than live', label: 'Underdog greater than live'},
                    { value: 'Favourite minor than live', label: 'Favourite minor than live'},
                    { value: 'Underdog minor than live', label: 'Underdog minor than live'},
                    { value: 'Winning team greater than live', label: 'Winning team greater than live'},
                    { value: 'Loosing team greater than live', label: 'Loosing team greater than live'},
                    { value: 'Winning team minor than live', label: 'Winning team minor than live'},
                    { value: 'Loosing team minor than live', label: 'Loosing team minor than live'},
                    { value: '', label: 'None'}
                ], 
                predictionTypeOptions1: [
                    { value: '', label: 'None'},
                    { value: '1', label: 'Home - FT'},
                    { value: 'X', label: 'Draw - FT'},
                    { value: '2', label: 'Away - FT'},
                    { value: 'Over 0.5', label: 'Over - 0.5 - FT'},
                    { value: 'Over 1.5', label: 'Over - 1.5 - FT'},
                    { value: 'Over 2.5', label: 'Over - 2.5 - FT'},
                    { value: 'Over 3.5', label: 'Over - 3.5 - FT'},
                    { value: 'Over 4.5', label: 'Over - 4.5 - FT'},
                    { value: 'Under 0.5', label: 'Under - 0.5 - FT'},
                    { value: 'Under 1.5', label: 'Under - 1.5 - FT'},
                    { value: 'Under 2.5', label: 'Under - 2.5 - FT'},
                    { value: 'Under 3.5', label: 'Under - 3.5 - FT'},
                    { value: 'Under 4.5', label: 'Under - 4.5 - FT'},
                    { value: 'BTS', label: 'BTS - FT'},
                    { value: 'No BTS', label: 'No BTS - FT'},
                    { value: '1 ht', label: 'Home - HT'},
                    { value: 'X ht', label: 'Draw - HT'},
                    { value: '2 ht', label: 'Away - HT'},
                    { value: 'Over 0.5 ht', label: 'Over - 0.5 - HT'},
                    { value: 'Over 1.5 ht', label: 'Over - 1.5 - HT'},
                    { value: 'Over 2.5 ht', label: 'Over - 2.5 - HT'},
                    { value: 'Over 3.5 ht', label: 'Over - 3.5 - HT'},
                    { value: 'Over 4.5 ht', label: 'Over - 4.5 - HT'},
                    { value: 'Under 0.5 ht', label: 'Under - 0.5 - HT'},
                    { value: 'Under 1.5 ht', label: 'Under - 1.5 - HT'},
                    { value: 'Under 2.5 ht', label: 'Under - 2.5 - HT'},
                    { value: 'Under 3.5 ht', label: 'Under - 3.5 - HT'},
                    { value: 'Under 4.5 ht', label: 'Under - 4.5 - HT'},
                    { value: 'BTS ht', label: 'BTS - HT'},
                    { value: 'No BTS ht', label: 'No BTS - HT'},
                    // { value: 'Home Next Goal', label: 'Home - Next Goal'},
                    // { value: 'Away Next Goal', label: 'Away - Next Goal'},
                    // { value: 'No Next Goal', label: 'No - Next Goal'},
                    // { value: 'Home Last to score', label: 'Home - Last to score'},
                    // { value: 'Away Last to score', label: 'Away - Last to score'},
                    // { value: 'No Last to score', label: 'No - Last to score'},
                    { value: '1X Double chance', label: '1X - Double chance'},
                    { value: 'X2 Double chance', label: 'X2 - Double chance'},
                    { value: '12 Double chance', label: '12 - Double chance'},
                    { value: 'Home Draw no bet', label: 'Home - Draw no bet'},
                    { value: 'Away Draw no bet', label: 'Away - Draw no bet'},
                    // { value: 'Home Draw no bet', label: 'Home - Draw no bet'},
                    // { value: 'Away Draw no bet', label: 'Away - Draw no bet'},
                    // { value: 'Home Yes Team clean sheet', label: 'Home Yes - Team clean sheet'},
                    // { value: 'Home No Team clean sheet', label: 'Home No - Team clean sheet'},
                    // { value: 'Away Yes Team clean sheet', label: 'Away Yes - Team clean sheet'},
                    // { value: 'Away No Team clean sheet', label: 'Away No - Team clean sheet'},
                    // { value: 'Over 0.5 Home Ov/Un', label: 'Over - 0.5 - Home Ov/Un'},
                    // { value: 'Over 1.5 Home Ov/Un', label: 'Over - 1.5 - Home Ov/Un'},
                    // { value: 'Over 2.5 Home Ov/Un', label: 'Over - 2.5 - Home Ov/Un'},
                    // { value: 'Over 3.5 Home Ov/Un', label: 'Over - 3.5 - Home Ov/Un'},
                    // { value: 'Over 4.5 Home Ov/Un', label: 'Over - 4.5 - Home Ov/Un'},
                    // { value: 'Over 5.5 Home Ov/Un', label: 'Over - 5.5 - Home Ov/Un'},
                    // { value: 'Over 6.5 Home Ov/Un', label: 'Over - 6.5 - Home Ov/Un'},
                    // { value: 'Under 0.5 Home Ov/Un', label: 'Under - 0.5 - Home Ov/Un'},
                    // { value: 'Under 1.5 Home Ov/Un', label: 'Under - 1.5 - Home Ov/Un'},
                    // { value: 'Under 2.5 Home Ov/Un', label: 'Under - 2.5 - Home Ov/Un'},
                    // { value: 'Under 3.5 Home Ov/Un', label: 'Under - 3.5 - Home Ov/Un'},
                    // { value: 'Under 4.5 Home Ov/Un', label: 'Under - 4.5 - Home Ov/Un'},
                    // { value: 'Under 5.5 Home Ov/Un', label: 'Under - 5.5 - Home Ov/Un'},
                    // { value: 'Under 6.5 Home Ov/Un', label: 'Under - 6.5 - Home Ov/Un'},
                    // { value: 'Over 0.5 Away Ov/Un', label: 'Over - 0.5 - Away Ov/Un'},
                    // { value: 'Over 1.5 Away Ov/Un', label: 'Over - 1.5 - Away Ov/Un'},
                    // { value: 'Over 2.5 Away Ov/Un', label: 'Over - 2.5 - Away Ov/Un'},
                    // { value: 'Over 3.5 Away Ov/Un', label: 'Over - 3.5 - Away Ov/Un'},
                    // { value: 'Over 4.5 Away Ov/Un', label: 'Over - 4.5 - Away Ov/Un'},
                    // { value: 'Over 5.5 Away Ov/Un', label: 'Over - 5.5 - Away Ov/Un'},
                    // { value: 'Over 6.5 Away Ov/Un', label: 'Over - 6.5 - Away Ov/Un'},
                    // { value: 'Under 0.5 Away Ov/Un', label: 'Under - - 0.5 - Away Ov/Un'},
                    // { value: 'Under 1.5 Away Ov/Un', label: 'Under - 1.5 - Away Ov/Un'},
                    // { value: 'Under 2.5 Away Ov/Un', label: 'Under - 2.5 - Away Ov/Un'},
                    // { value: 'Under 3.5 Away Ov/Un', label: 'Under - 3.5 - Away Ov/Un'},
                    // { value: 'Under 4.5 Away Ov/Un', label: 'Under - 4.5 - Away Ov/Un'},
                    // { value: 'Under 5.5 Away Ov/Un', label: 'Under - 5.5 - Away Ov/Un'},
                    // { value: 'Under 6.5 Away Ov/Un', label: 'Under - 6.5 - Away Ov/Un'},
                    // { value: 'Home +2 AH', label: 'Home +2 - AH'},
                    // { value: 'Home +1.75 AH', label: 'Home +1.75 - AH'},
                    // { value: 'Home +1.5 AH', label: 'Home +1.5 - AH'},
                    // { value: 'Home +1.25 AH', label: 'Home +1.25 - AH'},
                    // { value: 'Home +1 AH', label: 'Home +1 - AH'},
                    // { value: 'Home +0.75 AH', label: 'Home +0.75 - AH'},
                    // { value: 'Home +0.5 AH', label: 'Home +0.5 - AH'},
                    // { value: 'Home +0.25 AH', label: 'Home +0.25 - AH'},
                    // { value: 'Home 0 AH', label: 'Home 0 - AH'},
                    // { value: 'Home -0.25 AH', label: 'Home -0.25 - AH'},
                    // { value: 'Home -0.5 AH', label: 'Home -0.5 - AH'},
                    // { value: 'Home -0.75 AH', label: 'Home -0.75 - AH'},
                    // { value: 'Home -1 AH', label: 'Home -1 - AH'},
                    // { value: 'Home -1.25 AH', label: 'Home -1.25 - AH'},
                    // { value: 'Home -1.5 AH', label: 'Home -1.5 - AH'},
                    // { value: 'Home -1.75 AH', label: 'Home -1.75 - AH'},
                    // { value: 'Away +2 AH', label: 'Away +2 - AH'},
                    // { value: 'Away +1.75 AH', label: 'Away +1.75 - AH'},
                    // { value: 'Away +1.5 AH', label: 'Away +1.5 - AH'},
                    // { value: 'Away +1.25 AH', label: 'Away +1.25 - AH'},
                    // { value: 'Away +1 AH', label: 'Away +1 - AH'},
                    // { value: 'Away +0.75 AH', label: 'Away +0.75 - AH'},
                    // { value: 'Away +0.5 AH', label: 'Away +0.5 - AH'},
                    // { value: 'Away +0.25 AH', label: 'Away +0.25 - AH'},
                    // { value: 'Away 0 AH', label: 'Away 0 - AH'},
                    // { value: 'Away -0.25 AH', label: 'Away -0.25 - AH'},
                    // { value: 'Away -0.5 AH', label: 'Away -0.5 - AH'},
                    // { value: 'Away -0.75 AH', label: 'Away -0.75 - AH'},
                    // { value: 'Away -1 AH', label: 'Away -1 - AH'},
                    // { value: 'Away -1.25 AH', label: 'Away -1.25 - AH'},
                    // { value: 'Away -1.5 AH', label: 'Away -1.5 - AH'},
                    // { value: 'Away -1.75 AH', label: 'Away -1.75 - AH'},
                    // { value: 'Over 0 Corners', label: 'Over - 0 - Corners'},
                    // { value: 'Over 1 Corners', label: 'Over - 1 - Corners'},
                    // { value: 'Over 2 Corners', label: 'Over - 2 - Corners'},
                    // { value: 'Over 3 Corners', label: 'Over - 3 - Corners'},
                    // { value: 'Over 4 Corners', label: 'Over - 4 - Corners'},
                    // { value: 'Over 5 Corners', label: 'Over - 5 - Corners'},
                    // { value: 'Over 6 Corners', label: 'Over - 6 - Corners'},
                    // { value: 'Over 7 Corners', label: 'Over - 7 - Corners'},
                    // { value: 'Over 8 Corners', label: 'Over - 8 - Corners'},
                    // { value: 'Over 9 Corners', label: 'Over - 9 - Corners'},
                    // { value: 'Over 10 Corners', label: 'Over - 10 - Corners'},
                    // { value: 'Over 11 Corners', label: 'Over - 11 - Corners'},
                    // { value: 'Over 12 Corners', label: 'Over - 12 - Corners'},
                    // { value: 'Over 13 Corners', label: 'Over - 13 - Corners'},
                    // { value: 'Over 14 Corners', label: 'Over - 14 - Corners'},
                    // { value: 'Under 0 Corners', label: 'Under - 0 - Corners'},
                    // { value: 'Under 1 Corners', label: 'Under - 1 - Corners'},
                    // { value: 'Under 2 Corners', label: 'Under - 2 - Corners'},
                    // { value: 'Under 3 Corners', label: 'Under - 3 - Corners'},
                    // { value: 'Under 4 Corners', label: 'Under - 4 - Corners'},
                    // { value: 'Under 5 Corners', label: 'Under - 5 - Corners'},
                    // { value: 'Under 6 Corners', label: 'Under - 6 - Corners'},
                    // { value: 'Under 7 Corners', label: 'Under - 7 - Corners'},
                    // { value: 'Under 8 Corners', label: 'Under - 8 - Corners'},
                    // { value: 'Under 9 Corners', label: 'Under - 9 - Corners'},
                    // { value: 'Under 10 Corners', label: 'Under - 10 - Corners'},
                    // { value: 'Under 11 Corners', label: 'Under - 11 - Corners'},
                    // { value: 'Under 12 Corners', label: 'Under - 12 - Corners'},
                    // { value: 'Under 13 Corners', label: 'Under - 13 - Corners'},
                    // { value: 'Under 14 Corners', label: 'Under - 14 - Corners'},
                    // { value: 'Exactly 0 Corners', label: 'Exactly - 0 - Corners'},
                    // { value: 'Exactly 1 Corners', label: 'Exactly - 1 - Corners'},
                    // { value: 'Exactly 2 Corners', label: 'Exactly - 2 - Corners'},
                    // { value: 'Exactly 3 Corners', label: 'Exactly - 3 - Corners'},
                    // { value: 'Exactly 4 Corners', label: 'Exactly - 4 - Corners'},
                    // { value: 'Exactly 5 Corners', label: 'Exactly - 5 - Corners'},
                    // { value: 'Exactly 6 Corners', label: 'Exactly - 6 - Corners'},
                    // { value: 'Exactly 7 Corners', label: 'Exactly - 7 - Corners'},
                    // { value: 'Exactly 8 Corners', label: 'Exactly - 8 - Corners'},
                    // { value: 'Exactly 9 Corners', label: 'Exactly - 9 - Corners'},
                    // { value: 'Exactly 10 Corners', label: 'Exactly - 10 - Corners'},
                    // { value: 'Exactly 11 Corners', label: 'Exactly - 11 - Corners'},
                    // { value: 'Exactly 12 Corners', label: 'Exactly - 12 - Corners'},
                    // { value: 'Exactly 13 Corners', label: 'Exactly - 13 - Corners'},
                    // { value: 'Exactly 14 Corners', label: 'Exactly - 14 - Corners'},
                    // { value: '0.5 | Over Cards', label: '0.5 | Over - Cards'},
                    // { value: '1.5 | Over Cards', label: '1.5 | Over - Cards'},
                    // { value: '2.5 | Over Cards', label: '2.5 | Over - Cards'},
                    // { value: '3.5 | Over Cards', label: '3.5 | Over - Cards'},
                    // { value: '4.5 | Over Cards', label: '4.5 | Over - Cards'},
                    // { value: '5.5 | Over Cards', label: '5.5 | Over - Cards'},
                    // { value: '6.5 | Over Cards', label: '6.5 | Over - Cards'},
                    // { value: '7.5 | Over Cards', label: '7.5 | Over - Cards'},
                    // { value: '8.5 | Over Cards', label: '8.5 | Over - Cards'},
                    // { value: '9.5 | Over Cards', label: '9.5 | Over - Cards'},
                    // { value: '0.5 | Under Cards', label: '0.5 | Under - Cards'},
                    // { value: '1.5 | Under Cards', label: '1.5 | Under - Cards'},
                    // { value: '2.5 | Under Cards', label: '2.5 | Under - Cards'},
                    // { value: '3.5 | Under Cards', label: '3.5 | Under - Cards'},
                    // { value: '4.5 | Under Cards', label: '4.5 | Under - Cards'},
                    // { value: '5.5 | Under Cards', label: '5.5 | Under - Cards'},
                    // { value: '6.5 | Under Cards', label: '6.5 | Under - Cards'},
                    // { value: '7.5 | Under Cards', label: '7.5 | Under - Cards'},
                    // { value: '8.5 | Under Cards', label: '8.5 | Under - Cards'},
                    // { value: '9.5 | Under Cards', label: '9.5 | Under - Cards'},
                ],
                overUnderOptions: [
                    { value: '0', label: '+0.5 Over'},
                    { value: '1', label: '+1.5 Over'},
                    { value: '2', label: '+2.5 Over'},
                    { value: '3', label: '+3.5 Over'},
                    { value: '', label: 'None'}
                ],
                valueStatsOptions1: [
                    { value: 'home', label: 'Home >= y'},
                    { value: 'draw', label: 'Draw >= y'},
                    { value: 'away', label: 'Away >= y'},
                    { value: 'bts', label: 'BTS yes >= y'},
                    { value: 'O_15', label: 'Ov 1.5 >= y'},
                    { value: 'O_25', label: 'Ov 2.5 >= y'},
                    { value: 'O_35', label: 'Ov 3.5 >= y'},
                    { value: '', label: 'None'}
                ],
                valueStatsOptions2: [
                    { value: 'home', label: 'Home < y'},
                    { value: 'draw', label: 'Draw < y'},
                    { value: 'away', label: 'Away < y'},
                    { value: 'bts', label: 'BTS yes < y'},
                    { value: 'O_15', label: 'Ov 1.5 < y'},
                    { value: 'O_25', label: 'Ov 2.5 < y'},
                    { value: 'O_35', label: 'Ov 3.5 < y'},
                    { value: '', label: 'None'}
                ],
                oddsOptions1: [
                    { value: 'Home', label: 'Home >= y'},
                    { value: 'Draw', label: 'Draw >= y'},
                    { value: 'Away', label: 'Away >= y'},
                    { value: 'Over 0.5 HT', label: 'Ov 0.5 HT >= y'},
                    { value: 'Under 0.5 HT', label: 'Un 0.5 HT >= y'},
                    { value: 'BTS yes', label: 'BTS yes >= y'},
                    { value: 'BTS no', label: 'BTS no >= y'},
                    { value: 'Over 0.5', label: 'Ov 0.5 >= y'},
                    { value: 'Under 0.5', label: 'Un 0.5 >= y'},
                    { value: 'Over 1.5', label: 'Ov 1.5 >= y'},
                    { value: 'Under 1.5', label: 'Un 1.5 >= y'},
                    { value: 'Over 2.5', label: 'Ov 2.5 >= y'},
                    { value: 'Under 2.5', label: 'Un 2.5 >= y'},
                    { value: 'Over 3.5', label: 'Ov 3.5 >= y'},
                    { value: 'Under 3.5', label: 'Un 3.5 >= y'},
                    { value: '', label: 'None'}
                ],
                live_oddsOptions1: [
                    { value: 'Home', label: 'Home >= y'},
                    { value: 'Draw', label: 'Draw >= y'},
                    { value: 'Away', label: 'Away >= y'},
                    { value: 'Over 0.5 HT', label: 'Ov 0.5 HT >= y'},
                    { value: 'Under 0.5 HT', label: 'Un 0.5 HT >= y'},
                    { value: 'BTS yes', label: 'BTS yes >= y'},
                    { value: 'BTS no', label: 'BTS no >= y'},
                    { value: 'Over 0.5', label: 'Ov 0.5 >= y'},
                    { value: 'Under 0.5', label: 'Un 0.5 >= y'},
                    { value: 'Over 1.5', label: 'Ov 1.5 >= y'},
                    { value: 'Under 1.5', label: 'Un 1.5 >= y'},
                    { value: 'Over 2.5', label: 'Ov 2.5 >= y'},
                    { value: 'Under 2.5', label: 'Un 2.5 >= y'},
                    { value: 'Over 3.5', label: 'Ov 3.5 >= y'},
                    { value: 'Under 3.5', label: 'Un 3.5 >= y'},
                    { value: '1X Double chance', label: '1X DC >= y'},
                    { value: 'X2 Double chance', label: 'X2 DC >= y'},
                    { value: '12 Double chance', label: '12 DC >= y'},
                    { value: 'Home Draw no bet', label: 'Home DNB >= y'},
                    { value: 'Away Draw no bet', label: 'Away DNB >= y'},
                    { value: '', label: 'None'}
                ],
                oddsOptions1_: [
                    { value: 'Home', label: 'Home >= y'},
                    { value: 'Draw', label: 'Draw >= y'},
                    { value: 'Away', label: 'Away >= y'},
                    { value: 'Over 0.5 HT', label: 'Ov 0.5 HT >= y'},
                    { value: 'Under 0.5 HT', label: 'Un 0.5 HT >= y'},
                    { value: 'BTS yes', label: 'BTS yes >= y'},
                    { value: 'BTS no', label: 'BTS no >= y'},
                    { value: 'Over 0.5', label: 'Ov 0.5 >= y'},
                    { value: 'Under 0.5', label: 'Un 0.5 >= y'},
                    { value: 'Over 1.5', label: 'Ov 1.5 >= y'},
                    { value: 'Under 1.5', label: 'Un 1.5 >= y'},
                    { value: 'Over 2.5', label: 'Ov 2.5 >= y'},
                    { value: 'Under 2.5', label: 'Un 2.5 >= y'},
                    { value: 'Over 3.5', label: 'Ov 3.5 >= y'},
                    { value: 'Under 3.5', label: 'Un 3.5 >= y'},
                    { value: 'current market type', label: 'current market type >= y'},
                    { value: '', label: 'None'}
                ],
                live_oddsOptions1_: [
                    { value: 'Home', label: 'Home >= y'},
                    { value: 'Draw', label: 'Draw >= y'},
                    { value: 'Away', label: 'Away >= y'},
                    { value: 'Over 0.5 HT', label: 'Ov 0.5 HT >= y'},
                    { value: 'Under 0.5 HT', label: 'Un 0.5 HT >= y'},
                    { value: 'BTS yes', label: 'BTS yes >= y'},
                    { value: 'BTS no', label: 'BTS no >= y'},
                    { value: 'Over 0.5', label: 'Ov 0.5 >= y'},
                    { value: 'Under 0.5', label: 'Un 0.5 >= y'},
                    { value: 'Over 1.5', label: 'Ov 1.5 >= y'},
                    { value: 'Under 1.5', label: 'Un 1.5 >= y'},
                    { value: 'Over 2.5', label: 'Ov 2.5 >= y'},
                    { value: 'Under 2.5', label: 'Un 2.5 >= y'},
                    { value: 'Over 3.5', label: 'Ov 3.5 >= y'},
                    { value: 'Under 3.5', label: 'Un 3.5 >= y'},
                    { value: '1X Double chance', label: '1X DC >= y'},
                    { value: 'X2 Double chance', label: 'X2 DC >= y'},
                    { value: '12 Double chance', label: '12 DC >= y'},
                    { value: 'Home Draw no bet', label: 'Home DNB >= y'},
                    { value: 'Away Draw no bet', label: 'Away DNB >= y'},
                    { value: 'current market type', label: 'current market type >= y'},
                    { value: '', label: 'None'}
                ],
                oddsOptions2: [
                    { value: 'Home', label: 'Home < y'},
                    { value: 'Draw', label: 'Draw < y'},
                    { value: 'Away', label: 'Away < y'},
                    { value: 'Over 0.5 HT', label: 'Ov 0.5 HT < y'},
                    { value: 'Under 0.5 HT', label: 'Un 0.5 HT < y'},
                    { value: 'BTS yes', label: 'BTS yes < y'},
                    { value: 'BTS no', label: 'BTS no < y'},
                    { value: 'Over 0.5', label: 'Ov 0.5 < y'},
                    { value: 'Under 0.5', label: 'Un 0.5 < y'},
                    { value: 'Over 1.5', label: 'Ov 1.5 < y'},
                    { value: 'Under 1.5', label: 'Un 1.5 < y'},
                    { value: 'Over 2.5', label: 'Ov 2.5 < y'},
                    { value: 'Under 2.5', label: 'Un 2.5 < y'},
                    { value: 'Over 3.5', label: 'Ov 3.5 < y'},
                    { value: 'Under 3.5', label: 'Un 3.5 < y'},
                    { value: '', label: 'None'}
                ],
                oddsOptions2_: [
                    { value: 'Home', label: 'Home < y'},
                    { value: 'Draw', label: 'Draw < y'},
                    { value: 'Away', label: 'Away < y'},
                    { value: 'Over 0.5 HT', label: 'Ov 0.5 HT < y'},
                    { value: 'Under 0.5 HT', label: 'Un 0.5 HT < y'},
                    { value: 'BTS yes', label: 'BTS yes < y'},
                    { value: 'BTS no', label: 'BTS no < y'},
                    { value: 'Over 0.5', label: 'Ov 0.5 < y'},
                    { value: 'Under 0.5', label: 'Un 0.5 < y'},
                    { value: 'Over 1.5', label: 'Ov 1.5 < y'},
                    { value: 'Under 1.5', label: 'Un 1.5 < y'},
                    { value: 'Over 2.5', label: 'Ov 2.5 < y'},
                    { value: 'Under 2.5', label: 'Un 2.5 < y'},
                    { value: 'Over 3.5', label: 'Ov 3.5 < y'},
                    { value: 'Under 3.5', label: 'Un 3.5 < y'},
                    { value: 'current market type', label: 'current market type < y'},
                    { value: '', label: 'None'}
                ],
                live_oddsOptions2: [
                    { value: 'Home', label: 'Home < y'},
                    { value: 'Draw', label: 'Draw < y'},
                    { value: 'Away', label: 'Away < y'},
                    { value: 'Over 0.5 HT', label: 'Ov 0.5 HT < y'},
                    { value: 'Under 0.5 HT', label: 'Un 0.5 HT < y'},
                    { value: 'BTS yes', label: 'BTS yes < y'},
                    { value: 'BTS no', label: 'BTS no < y'},
                    { value: 'Over 0.5', label: 'Ov 0.5 < y'},
                    { value: 'Under 0.5', label: 'Un 0.5 < y'},
                    { value: 'Over 1.5', label: 'Ov 1.5 < y'},
                    { value: 'Under 1.5', label: 'Un 1.5 < y'},
                    { value: 'Over 2.5', label: 'Ov 2.5 < y'},
                    { value: 'Under 2.5', label: 'Un 2.5 < y'},
                    { value: 'Over 3.5', label: 'Ov 3.5 < y'},
                    { value: 'Under 3.5', label: 'Un 3.5 < y'},
                    { value: '1X Double chance', label: '1X DC < y'},
                    { value: 'X2 Double chance', label: 'X2 DC < y'},
                    { value: '12 Double chance', label: '12 DC < y'},
                    { value: 'Home Draw no bet', label: 'Home DNB < y'},
                    { value: 'Away Draw no bet', label: 'Away DNB < y'},
                    { value: '', label: 'None'}
                ],
                live_oddsOptions2_: [
                    { value: 'Home', label: 'Home < y'},
                    { value: 'Draw', label: 'Draw < y'},
                    { value: 'Away', label: 'Away < y'},
                    { value: 'Over 0.5 HT', label: 'Ov 0.5 HT < y'},
                    { value: 'Under 0.5 HT', label: 'Un 0.5 HT < y'},
                    { value: 'BTS yes', label: 'BTS yes < y'},
                    { value: 'BTS no', label: 'BTS no < y'},
                    { value: 'Over 0.5', label: 'Ov 0.5 < y'},
                    { value: 'Under 0.5', label: 'Un 0.5 < y'},
                    { value: 'Over 1.5', label: 'Ov 1.5 < y'},
                    { value: 'Under 1.5', label: 'Un 1.5 < y'},
                    { value: 'Over 2.5', label: 'Ov 2.5 < y'},
                    { value: 'Under 2.5', label: 'Un 2.5 < y'},
                    { value: 'Over 3.5', label: 'Ov 3.5 < y'},
                    { value: 'Under 3.5', label: 'Un 3.5 < y'},
                    { value: '1X Double chance', label: '1X DC < y'},
                    { value: 'X2 Double chance', label: 'X2 DC < y'},
                    { value: '12 Double chance', label: '12 DC < y'},
                    { value: 'Home Draw no bet', label: 'Home DNB < y'},
                    { value: 'Away Draw no bet', label: 'Away DNB < y'},
                    { value: 'current market type', label: 'current market type < y'},
                    { value: '', label: 'None'}
                ],
                lastMatchesOptions: [
                    { value: 'in row', label: 'in row'},
                    { value: 'lasts', label: 'lasts'},
                    { value: 'firsts', label: 'firsts'},
                    { value: 'at least', label: 'at least'},
                    { value: 'less than', label: 'less than'},
                    { value: 'equal to', label: 'equal to'},
                    { value: '', label: 'None'},
                ],
                valueStatsYearsOptions: [
                    { value: '1 year', label: '1 year'},
                    { value: '3 years', label: '3 years'},
                    { value: '10 years', label: '10 years'},
                    { value: 'Each one', label: 'Each one'},
                    { value: '', label: 'None'}                   
                ],
                repeatOptions: [
                    { value: '10000', label: 'every day'},
                    { value: '1', label: '1 day'},
                    { value: '2', label: '2 days'},
                    { value: '3', label: '3 days'},
                    { value: '4', label: '4 days'},
                    { value: '5', label: '5 days'},
                    { value: '6', label: '6 days'},
                    { value: '7', label: '7 days'},
                    { value: '8', label: '8 days'},
                    { value: '9', label: '9 days'},
                    { value: '10', label: '10 days'},
                    { value: '11', label: '11 days'},
                    { value: '12', label: '12 days'},
                    { value: '13', label: '13 days'},
                    { value: '14', label: '14 days'},
                    { value: '15', label: '15 days'},
                    { value: '16', label: '16 days'},
                    { value: '17', label: '17 days'},
                    { value: '18', label: '18 days'},
                    { value: '19', label: '19 days'},
                    { value: '20', label: '20 days'},
                    { value: '21', label: '21 days'},
                    { value: '22', label: '22 days'},
                    { value: '23', label: '23 days'},
                    { value: '24', label: '24 days'},
                    { value: '25', label: '25 days'},
                    { value: '26', label: '26 days'},
                    { value: '27', label: '27 days'},
                    { value: '28', label: '28 days'},
                    { value: '29', label: '29 days'},
                    { value: '30', label: '30 days'},                    
                ],

                userOptions: [{label: "None", value: ""}],

                routines: [],

                loading: false,
                loadingTimer: '',
                current_counter: 0,
                allLeagues: [],
                countryOptions: [
                    {
                      all: 'All countries',
                      countries: [
                      ]
                    }
                ],
                daysOptions: [
                    {
                      all: 'all',
                      days: [
                        { value: "1", label: "Monday"},
                        { value: "2", label: "Tuesday"},
                        { value: "3", label: "Wednesday"},
                        { value: "4", label: "Thursday"},
                        { value: "5", label: "Friday"},
                        { value: "6", label: "Saturday"},
                        { value: "0", label: "Sunday"}
                      ]
                    }
                ],
                
                eventOptions: [],
                fixturesByDate: [],
                refreshLiveScore: 0,
                last_updated_time: '',
                tipQueue: [],
                old_model: '',
                strategyOptions: [
                    {
                      all: 'all',
                      items: [                        
                      ]
                    }
                ],
                special_strategyOptions: [
                    { label: "best between Home, Draw, Away", value: "best between Home, Draw, Away"},
                    { label: "lower between Home, draw, away", value: "lower between Home, draw, away"},
                    { label: "best between time bands All", value: "best between time bands All"},
                    { label: "lower between time bands All", value: "lower between time bands All"},
                    { label: "best between time bands 1st half", value: "best between time bands 1st half"},
                    { label: "lower between time bands 1st half", value: "lower between time bands 1st half"},
                    { label: "best between time bands 2nd half", value: "best between time bands 2nd half"},
                    { label: "lower between time bands 2nd half", value: "lower between time bands 2nd half"},
                    { label: "greater than 1st goal minute avg FH", value: "greater than 1st goal minute avg FH"},
                    { label: "minor than 1st goal minute avg FH", value: "minor than 1st goal minute avg FH"},
                    { label: "greater than 1st goal minute avg SH", value: "greater than 1st goal minute avg SH"},
                    { label: "minor than 1st goal minute avg SH", value: "minor than 1st goal minute avg SH"},
                    { label: "home > H Win", value: "home > H Win"},
                    { label: "home = H Win", value: "home = H Win"},
                    { label: "away > A Win", value: "away > A Win"},
                    { label: "away = A Win", value: "away = A Win"},
                    { label: "None", value: ""},
                ],
                strategyStats_model: [
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                ],
                strategyFinancial_model: [
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                ],
                cashout_strategyFinancial_model: [
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                ],
                
                tipSettledOptions: [
                    { label: "None", value: ""},
                    { label: "V", value: "V"},
                    { label: "F", value: "F"}
                ],
                cashout_strategyStats_model: [
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                ],
                sospesoPredictionOptions: [
                    { label: "Over 0.5 Back", value: "Over 0.5 Back" },
                    { label: "Over 1.5 Back", value: "Over 1.5 Back" },
                    { label: "Over 2.5 Back", value: "Over 2.5 Back" },
                    { label: "Under 2.5 Back", value: "Under 2.5 Back" },
                    { label: "Under 3.5 Back", value: "Under 3.5 Back" },
                    { label: "X - Lay", value: "X - Lay" },
                    { label: "X - Back", value: "X - Back" },
                    { label: "1 - Lay", value: "1 - Lay" },
                    { label: "2 - Lay", value: "2 - Lay" },
                    { label: "None", value: "" },

                ],
                sospesoPredictionFilters: [
                    { label: "Cup", value: "Cup" },
                    { label: "Week", value: "Week" },
                    { label: "Double prediction", value: "Double prediction" },
                    { label: "None", value: "" },
                ],
                sospesoPrediction_model: [
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    },
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    },
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    },
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    },
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    }                    
                ],
                strategy: '',
                timer: '',
                country_league: [{
                        "country_id": 2454,
                        "country_name": "Albania",
                        "leagues": [{
                            "league_id": 172,
                            "league_name": "Albania - Superliga"
                        }]
                    }, {
                        "country_id": 44,
                        "country_name": "Argentina",
                        "leagues": [{
                            "league_id": 636,
                            "league_name": "Argentina - Superliga"
                        }]
                    }, {
                        "country_id": 98,
                        "country_name": "Australia",
                        "leagues": [{
                            "league_id": 1356,
                            "league_name": "Australia - A-League"
                        }]
                    }, {
                        "country_id": 143,
                        "country_name": "Austria",
                        "leagues": [{
                            "league_id": 181,
                            "league_name": "Austria - Admiral Bundesliga"
                        }, {
                            "league_id": 184,
                            "league_name": "Austria - Erste Liga"
                        }, {
                            "league_id": 187,
                            "league_name": "Austria - Austrian Cup"
                        }]
                    }, {
                        "country_id": 212,
                        "country_name": "Belarus",
                        "leagues": [{
                            "league_id": 199,
                            "league_name": "Belarus - Vysshaya Liga"
                        }, {
                            "league_id": 202,
                            "league_name": "Belarus - Pershaya Liga"
                        }]
                    }, {
                        "country_id": 556,
                        "country_name": "Belgium",
                        "leagues": [{
                            "league_id": 208,
                            "league_name": "Belgium - Pro League"
                        }, {
                            "league_id": 211,
                            "league_name": "Belgium - First Division B"
                        }, {
                            "league_id": 214,
                            "league_name": "Belgium - Belgian Cup"
                        }]
                    }, {
                        "country_id": 7598,
                        "country_name": "Bolivia",
                        "leagues": [{
                            "league_id": 1098,
                            "league_name": "Bolivia - Liga De Futbol Prof"
                        }]
                    }, {
                        "country_id": 507,
                        "country_name": "Bosnia and Herzegovina",
                        "leagues": [{
                            "league_id": 220,
                            "league_name": "Bosnia and Herzegovina - Premier Liga"
                        }, {
                            "league_id": 223,
                            "league_name": "Bosnia and Herzegovina - Bosnia Cup"
                        }, {
                            "league_id": 226,
                            "league_name": "Bosnia and Herzegovina - First League: FBiH"
                        }]
                    }, {
                        "country_id": 5,
                        "country_name": "Brazil",
                        "leagues": [{
                            "league_id": 648,
                            "league_name": "Brazil - Serie A"
                        }, {
                            "league_id": 651,
                            "league_name": "Brazil - Serie B"
                        }, {
                            "league_id": 654,
                            "league_name": "Brazil - Copa do Brasil"
                        }]
                    }, {
                        "country_id": 224,
                        "country_name": "Bulgaria",
                        "leagues": [{
                            "league_id": 229,
                            "league_name": "Bulgaria - Parva Liga"
                        }, {
                            "league_id": 235,
                            "league_name": "Bulgaria - Vtora Liga"
                        }, {
                            "league_id": 241,
                            "league_name": "Bulgaria - Bulgarian Cup"
                        }]
                    }, {
                        "country_id": 1004,
                        "country_name": "Canada",
                        "leagues": [{
                            "league_id": 983,
                            "league_name": "Canada - Canadian Soccer League"
                        }]
                    }, {
                        "country_id": 80,
                        "country_name": "Chile",
                        "leagues": [{
                            "league_id": 663,
                            "league_name": "Chile - Primera Division"
                        }]
                    }, {
                        "country_id": 5618,
                        "country_name": "China PR",
                        "leagues": [{
                            "league_id": 989,
                            "league_name": "China PR - Super League"
                        }, {
                            "league_id": 992,
                            "league_name": "China PR - League One"
                        }]
                    }, {
                        "country_id": 353,
                        "country_name": "Colombia",
                        "leagues": [{
                            "league_id": 672,
                            "league_name": "Colombia - Liga BetPlay"
                        }]
                    }, {
                        "country_id": 1739,
                        "country_name": "Costa Rica",
                        "leagues": [{
                            "league_id": 687,
                            "league_name": "Costa Rica - Primera Division"
                        }]
                    }, {
                        "country_id": 266,
                        "country_name": "Croatia",
                        "leagues": [{
                            "league_id": 244,
                            "league_name": "Croatia - 1. HNL"
                        }, {
                            "league_id": 247,
                            "league_name": "Croatia - 2. HNL"
                        }, {
                            "league_id": 250,
                            "league_name": "Croatia - Croatia Cup"
                        }]
                    }, {
                        "country_id": 245,
                        "country_name": "Czech Republic",
                        "leagues": [{
                            "league_id": 262,
                            "league_name": "Czech Republic - Fortuna Liga"
                        }, {
                            "league_id": 265,
                            "league_name": "Czech Republic - 2. Liga FNL"
                        }, {
                            "league_id": 268,
                            "league_name": "Czech Republic - Czech Cup"
                        }]
                    }, {
                        "country_id": 320,
                        "country_name": "Denmark",
                        "leagues": [{
                            "league_id": 271,
                            "league_name": "Denmark - Superliga"
                        }, {
                            "league_id": 274,
                            "league_name": "Denmark - First Division"
                        }, {
                            "league_id": 277,
                            "league_name": "Denmark - Landspokal Cup"
                        }]
                    }, {
                        "country_id": 459,
                        "country_name": "Ecuador",
                        "leagues": [{
                            "league_id": 696,
                            "league_name": "Ecuador - Liga Pro"
                        }]
                    }, {
                        "country_id": 886,
                        "country_name": "Egypt",
                        "leagues": [{
                            "league_id": 830,
                            "league_name": "Egypt - Premier League"
                        }]
                    }, {
                        "country_id": 35008,
                        "country_name": "El Salvador",
                        "leagues": [{
                            "league_id": 702,
                            "league_name": "El Salvador - Primera Division"
                        }]
                    }, {
                        "country_id": 462,
                        "country_name": "England",
                        "leagues": [{
                            "league_id": 8,
                            "league_name": "England - Premier League"
                        }, {
                            "league_id": 9,
                            "league_name": "England - Championship"
                        }, {
                            "league_id": 12,
                            "league_name": "England - League One"
                        }, {
                            "league_id": 14,
                            "league_name": "England - League Two"
                        }, {
                            "league_id": 17,
                            "league_name": "England - National League"
                        }, {
                            "league_id": 20,
                            "league_name": "England - Vanarama National League North"
                        }, {
                            "league_id": 23,
                            "league_name": "England - Community Shield"
                        }, {
                            "league_id": 24,
                            "league_name": "England - FA Cup"
                        }, {
                            "league_id": 27,
                            "league_name": "England - Carabao Cup"
                        }, {
                            "league_id": 30,
                            "league_name": "England - Fa Trophy"
                        }]
                    }, {
                        "country_id": 2405,
                        "country_name": "Estonia",
                        "leagues": [{
                            "league_id": 286,
                            "league_name": "Estonia - Meistriliiga"
                        }, {
                            "league_id": 289,
                            "league_name": "Estonia - Esiliiga A"
                        }]
                    }, {
                        "country_id": 41,
                        "country_name": "Europe",
                        "leagues": [{
                            "league_id": 2,
                            "league_name": "Europe - Champions League"
                        }, {
                            "league_id": 5,
                            "league_name": "Europe - Europa League"
                        }, {
                            "league_id": 1328,
                            "league_name": "Europe - Uefa Super Cup"
                        }]
                    }, {
                        "country_id": 1233,
                        "country_name": "Finland",
                        "leagues": [{
                            "league_id": 292,
                            "league_name": "Finland - Veikkausliiga"
                        }, {
                            "league_id": 295,
                            "league_name": "Finland - Ykkonen"
                        }, {
                            "league_id": 298,
                            "league_name": "Finland - Finland Cup"
                        }, {
                            "league_id": 1172,
                            "league_name": "Finland - Kakkonen"
                        }]
                    }, {
                        "country_id": 17,
                        "country_name": "France",
                        "leagues": [{
                            "league_id": 301,
                            "league_name": "France - Ligue 1"
                        }, {
                            "league_id": 304,
                            "league_name": "France - Ligue 2"
                        }, {
                            "league_id": 307,
                            "league_name": "France - Coupe de France"
                        }, {
                            "league_id": 310,
                            "league_name": "France - Coupe de la Ligue"
                        }, {
                            "league_id": 313,
                            "league_name": "France - National"
                        }, {
                            "league_id": 1176,
                            "league_name": "France - Super Cup"
                        }, {
                            "league_id": 1673,
                            "league_name": "France - Ligue 1 Play-offs"
                        }, {
                            "league_id": 1674,
                            "league_name": "France - Ligue 2 Play-offs"
                        }]
                    }, {
                        "country_id": 11,
                        "country_name": "Germany",
                        "leagues": [{
                            "league_id": 82,
                            "league_name": "Germany - Bundesliga"
                        }, {
                            "league_id": 85,
                            "league_name": "Germany - 2. Bundesliga"
                        }, {
                            "league_id": 88,
                            "league_name": "Germany - 3. Liga"
                        }, {
                            "league_id": 109,
                            "league_name": "Germany - DFB Pokal"
                        }, {
                            "league_id": 163,
                            "league_name": "Germany - Bundesliga Play-offs"
                        }, {
                            "league_id": 166,
                            "league_name": "Germany - 2. Bundesliga Play-offs"
                        }, {
                            "league_id": 169,
                            "league_name": "Germany - Super Cup"
                        }]
                    }, {
                        "country_id": 125,
                        "country_name": "Greece",
                        "leagues": [{
                            "league_id": 325,
                            "league_name": "Greece - Super League"
                        }, {
                            "league_id": 328,
                            "league_name": "Greece - Football League"
                        }, {
                            "league_id": 331,
                            "league_name": "Greece - Greek Cup"
                        }]
                    }, {
                        "country_id": 53128,
                        "country_name": "Guatemala",
                        "leagues": [{
                            "league_id": 705,
                            "league_name": "Guatemala - Liga Nacional"
                        }]
                    }, {
                        "country_id": 1176,
                        "country_name": "Honduras",
                        "leagues": [{
                            "league_id": 734,
                            "league_name": "Honduras - Liga Nacional"
                        }]
                    }, {
                        "country_id": 674,
                        "country_name": "Hungary",
                        "leagues": [{
                            "league_id": 334,
                            "league_name": "Hungary - OTP Bank Liga"
                        }, {
                            "league_id": 337,
                            "league_name": "Hungary - Hungarian Cup"
                        }]
                    }, {
                        "country_id": 1796,
                        "country_name": "Iceland",
                        "leagues": [{
                            "league_id": 345,
                            "league_name": "Iceland - Pepsideild"
                        }, {
                            "league_id": 348,
                            "league_name": "Iceland - Inkasso-Deildin"
                        }, {
                            "league_id": 351,
                            "league_name": "Iceland - 2. Deild"
                        }, {
                            "league_id": 354,
                            "league_name": "Iceland - Iceland Cup"
                        }, {
                            "league_id": 357,
                            "league_name": "Iceland - League Cup"
                        }]
                    }, {
                        "country_id": 153732,
                        "country_name": "India",
                        "leagues": [{
                            "league_id": 1007,
                            "league_name": "India - Indian Super League"
                        }]
                    }, {
                        "country_id": 88407,
                        "country_name": "Indonesia",
                        "leagues": [{
                            "league_id": 1019,
                            "league_name": "Indonesia - Liga 1"
                        }]
                    }, {
                        "country_id": 802,
                        "country_name": "Israel",
                        "leagues": [{
                            "league_id": 372,
                            "league_name": "Israel - Ligat ha'Al"
                        }, {
                            "league_id": 375,
                            "league_name": "Israel - Liga Leumit"
                        }]
                    }, {
                        "country_id": 251,
                        "country_name": "Italy",
                        "leagues": [{
                            "league_id": 384,
                            "league_name": "Italy - Serie A"
                        }, {
                            "league_id": 387,
                            "league_name": "Italy - Serie B"
                        }, {
                            "league_id": 390,
                            "league_name": "Italy - Coppa Italia"
                        }, {
                            "league_id": 1202,
                            "league_name": "Italy - Super Cup"
                        }, {
                            "league_id": 1203,
                            "league_name": "Italy - Serie C: Girone A"
                        }, {
                            "league_id": 1204,
                            "league_name": "Italy - Serie C: Girone B"
                        }, {
                            "league_id": 1205,
                            "league_name": "Italy - Serie C: Girone C"
                        }, {
                            "league_id": 1664,
                            "league_name": "Italy - Serie C Play-offs"
                        }]
                    }, {
                        "country_id": 1640,
                        "country_name": "Jamaica",
                        "leagues": [{
                            "league_id": 737,
                            "league_name": "Jamaica - Premier League"
                        }]
                    }, {
                        "country_id": 479,
                        "country_name": "Japan",
                        "leagues": [{
                            "league_id": 968,
                            "league_name": "Japan - J-League"
                        }, {
                            "league_id": 1022,
                            "league_name": "Japan - J2-League"
                        }]
                    }, {
                        "country_id": 2427,
                        "country_name": "Kazakhstan",
                        "leagues": [{
                            "league_id": 393,
                            "league_name": "Kazakhstan - Premier League"
                        }]
                    }, {
                        "country_id": 712,
                        "country_name": "Korea Republic",
                        "leagues": [{
                            "league_id": 1034,
                            "league_name": "Korea Republic - K-League 1"
                        }]
                    }, {
                        "country_id": 748,
                        "country_name": "Latvia",
                        "leagues": [{
                            "league_id": 399,
                            "league_name": "Latvia - Virsliga"
                        }]
                    }, {
                        "country_id": 2079,
                        "country_name": "Lithuania",
                        "leagues": [{
                            "league_id": 405,
                            "league_name": "Lithuania - A Lyga"
                        }]
                    }, {
                        "country_id": 2756,
                        "country_name": "Malta",
                        "leagues": [{
                            "league_id": 423,
                            "league_name": "Malta - First Division"
                        }]
                    }, {
                        "country_id": 458,
                        "country_name": "Mexico",
                        "leagues": [{
                            "league_id": 743,
                            "league_name": "Mexico - Liga MX"
                        }]
                    }, {
                        "country_id": 1424,
                        "country_name": "Morocco",
                        "leagues": [{
                            "league_id": 860,
                            "league_name": "Morocco - Botola Pro"
                        }]
                    }, {
                        "country_id": 38,
                        "country_name": "Netherlands",
                        "leagues": [{
                            "league_id": 72,
                            "league_name": "Netherlands - Eredivisie"
                        }, {
                            "league_id": 74,
                            "league_name": "Netherlands - Eerste Divisie"
                        }, {
                            "league_id": 77,
                            "league_name": "Netherlands - Tweede Divisie"
                        }, {
                            "league_id": 78,
                            "league_name": "Netherlands - KNVB Beker"
                        }, {
                            "league_id": 81,
                            "league_name": "Netherlands - Super Cup"
                        }]
                    }, {
                        "country_id": 491,
                        "country_name": "Northern Ireland",
                        "leagues": [{
                            "league_id": 438,
                            "league_name": "Northern Ireland - Premiership"
                        }, {
                            "league_id": 441,
                            "league_name": "Northern Ireland - Championship"
                        }]
                    }, {
                        "country_id": 1578,
                        "country_name": "Norway",
                        "leagues": [{
                            "league_id": 444,
                            "league_name": "Norway - Eliteserien"
                        }, {
                            "league_id": 447,
                            "league_name": "Norway - Obos-Ligaen"
                        }, {
                            "league_id": 450,
                            "league_name": "Norway - NM Cup"
                        }, {
                            "league_id": 1760,
                            "league_name": "Norway - Eliteserien Play-offs"
                        }, {
                            "league_id": 1761,
                            "league_name": "Norway - Obos-Ligaen Play-offs"
                        }]
                    }, {
                        "country_id": 1190,
                        "country_name": "Paraguay",
                        "leagues": [{
                            "league_id": 755,
                            "league_name": "Paraguay - Division 1"
                        }]
                    }, {
                        "country_id": 338,
                        "country_name": "Peru",
                        "leagues": [{
                            "league_id": 764,
                            "league_name": "Peru - Primera Division"
                        }]
                    }, {
                        "country_id": 2,
                        "country_name": "Poland",
                        "leagues": [{
                            "league_id": 453,
                            "league_name": "Poland - Ekstraklasa"
                        }, {
                            "league_id": 456,
                            "league_name": "Poland - 1. Liga"
                        }, {
                            "league_id": 459,
                            "league_name": "Poland - Polish Cup"
                        }]
                    }, {
                        "country_id": 20,
                        "country_name": "Portugal",
                        "leagues": [{
                            "league_id": 462,
                            "league_name": "Portugal - Primeira Liga"
                        }, {
                            "league_id": 465,
                            "league_name": "Portugal - Segunda Liga"
                        }, {
                            "league_id": 468,
                            "league_name": "Portugal - Taça De Portugal"
                        }, {
                            "league_id": 471,
                            "league_name": "Portugal - League Cup"
                        }, {
                            "league_id": 1224,
                            "league_name": "Portugal - Super Cup"
                        }]
                    }, {
                        "country_id": 455,
                        "country_name": "Republic of Ireland",
                        "leagues": [{
                            "league_id": 360,
                            "league_name": "Republic of Ireland - Premier Division"
                        }, {
                            "league_id": 363,
                            "league_name": "Republic of Ireland - First Division"
                        }, {
                            "league_id": 366,
                            "league_name": "Republic of Ireland - FAI Cup"
                        }, {
                            "league_id": 369,
                            "league_name": "Republic of Ireland - League Cup"
                        }]
                    }, {
                        "country_id": 155,
                        "country_name": "Romania",
                        "leagues": [{
                            "league_id": 474,
                            "league_name": "Romania - Liga 1"
                        }, {
                            "league_id": 483,
                            "league_name": "Romania - Romania Cup"
                        }, {
                            "league_id": 1236,
                            "league_name": "Romania - Super Cup"
                        }]
                    }, {
                        "country_id": 227,
                        "country_name": "Russia",
                        "leagues": [{
                            "league_id": 486,
                            "league_name": "Russia - Premier League"
                        }, {
                            "league_id": 489,
                            "league_name": "Russia - FNL"
                        }, {
                            "league_id": 492,
                            "league_name": "Russia - Russian Cup"
                        }, {
                            "league_id": 495,
                            "league_name": "Russia - Premier League Play-offs"
                        }]
                    }, {
                        "country_id": 1161,
                        "country_name": "Scotland",
                        "leagues": [{
                            "league_id": 501,
                            "league_name": "Scotland - Premiership"
                        }, {
                            "league_id": 504,
                            "league_name": "Scotland - Championship"
                        }, {
                            "league_id": 507,
                            "league_name": "Scotland - Scottish Cup"
                        }, {
                            "league_id": 510,
                            "league_name": "Scotland - League Cup"
                        }, {
                            "league_id": 513,
                            "league_name": "Scotland - Premiership Play-Offs"
                        }, {
                            "league_id": 516,
                            "league_name": "Scotland - League One"
                        }, {
                            "league_id": 522,
                            "league_name": "Scotland - Challenge Cup"
                        }, {
                            "league_id": 525,
                            "league_name": "Scotland - Championship Play-Offs"
                        }, {
                            "league_id": 528,
                            "league_name": "Scotland - League One Play-Offs"
                        }]
                    }, {
                        "country_id": 296,
                        "country_name": "Serbia",
                        "leagues": [{
                            "league_id": 531,
                            "league_name": "Serbia - Super Liga"
                        }, {
                            "league_id": 534,
                            "league_name": "Serbia - Prva Liga"
                        }]
                    }, {
                        "country_id": 401,
                        "country_name": "Slovakia",
                        "leagues": [{
                            "league_id": 540,
                            "league_name": "Slovakia - Fortuna Liga"
                        }, {
                            "league_id": 552,
                            "league_name": "Slovakia - Slovakia Cup"
                        }]
                    }, {
                        "country_id": 1638,
                        "country_name": "Slovenia",
                        "leagues": [{
                            "league_id": 555,
                            "league_name": "Slovenia - 1. SNL"
                        }]
                    }, {
                        "country_id": 146,
                        "country_name": "South Africa",
                        "leagues": [{
                            "league_id": 806,
                            "league_name": "South Africa - Premier League"
                        }]
                    }, {
                        "country_id": 32,
                        "country_name": "Spain",
                        "leagues": [{
                            "league_id": 564,
                            "league_name": "Spain - La Liga"
                        }, {
                            "league_id": 567,
                            "league_name": "Spain - La Liga 2"
                        }, {
                            "league_id": 570,
                            "league_name": "Spain - Copa Del Rey"
                        }, {
                            "league_id": 1251,
                            "league_name": "Spain - Super Cup"
                        }]
                    }, {
                        "country_id": 47,
                        "country_name": "Sweden",
                        "leagues": [{
                            "league_id": 573,
                            "league_name": "Sweden - Allsvenskan"
                        }, {
                            "league_id": 576,
                            "league_name": "Sweden - Allsvenskan Women"
                        }, {
                            "league_id": 579,
                            "league_name": "Sweden - Superettan"
                        }, {
                            "league_id": 582,
                            "league_name": "Sweden - Svenska Cupen"
                        }, {
                            "league_id": 1753,
                            "league_name": "Sweden - Allsvenskan Play-offs"
                        }, {
                            "league_id": 1754,
                            "league_name": "Sweden - Superettan Play-offs 3/4"
                        }, {
                            "league_id": 1755,
                            "league_name": "Sweden - Superettan Play-offs 2/3"
                        }]
                    }, {
                        "country_id": 62,
                        "country_name": "Switzerland",
                        "leagues": [{
                            "league_id": 591,
                            "league_name": "Switzerland - Super League"
                        }, {
                            "league_id": 594,
                            "league_name": "Switzerland - Challenge League"
                        }, {
                            "league_id": 597,
                            "league_name": "Switzerland - Swiss Cup"
                        }]
                    }, {
                        "country_id": 49477,
                        "country_name": "Thailand",
                        "leagues": [{
                            "league_id": 1064,
                            "league_name": "Thailand - Thai Premier League"
                        }]
                    }, {
                        "country_id": 404,
                        "country_name": "Turkey",
                        "leagues": [{
                            "league_id": 600,
                            "league_name": "Turkey - Super Lig"
                        }, {
                            "league_id": 603,
                            "league_name": "Turkey - 1. Lig"
                        }, {
                            "league_id": 606,
                            "league_name": "Turkey - Turkish Cup"
                        }, {
                            "league_id": 1403,
                            "league_name": "Turkey - Super Cup"
                        }]
                    }, {
                        "country_id": 3483,
                        "country_name": "USA",
                        "leagues": [{
                            "league_id": 779,
                            "league_name": "USA - Major League Soccer"
                        }]
                    }, {
                        "country_id": 86,
                        "country_name": "Ukraine",
                        "leagues": [{
                            "league_id": 609,
                            "league_name": "Ukraine - Premier League"
                        }, {
                            "league_id": 612,
                            "league_name": "Ukraine - Persha Liga"
                        }, {
                            "league_id": 615,
                            "league_name": "Ukraine - Ukrainian Cup"
                        }]
                    }, {
                        "country_id": 2802,
                        "country_name": "United Arab Emirates",
                        "leagues": [{
                            "league_id": 959,
                            "league_name": "United Arab Emirates - Uae League"
                        }]
                    }, {
                        "country_id": 158,
                        "country_name": "Uruguay",
                        "leagues": [{
                            "league_id": 770,
                            "league_name": "Uruguay - Primera Division"
                        }]
                    }, {
                        "country_id": 275,
                        "country_name": "Venezuela",
                        "leagues": [{
                            "league_id": 800,
                            "league_name": "Venezuela - Primera Division"
                        }]
                    }, {
                        "country_id": 69697,
                        "country_name": "Vietnam",
                        "leagues": [{
                            "league_id": 1073,
                            "league_name": "Vietnam - V-League"
                        }]
                    }, {
                        "country_id": 515,
                        "country_name": "Wales",
                        "leagues": [{
                            "league_id": 624,
                            "league_name": "Wales - Premier League"
                        }]
                    }, {
                        "country_id": 99474,
                        "country_name": "World",
                        "leagues": [{
                            "league_id": 1101,
                            "league_name": "World - Club Friendlies"
                        }]
                    }
                ]
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),
            // dateOptions(){
            //     let arr = [];
            //     let day = ['Today'];
            //     if(this.loggedInUser) {
            //         for(let i = 0; i < 4 ; i++){
            //             let date = moment.utc().add(i, 'days').add(this.loggedInUser.mytimezone, 'hours').format('YYYY-MM-DD');
            //             if (i == 0) {
            //                 arr.push({
            //                     'label': `${date} (${day[i % 2]})`, 
            //                     'value': date
            //                 });
            //             }
            //             else {
            //                 arr.push({
            //                     'label': `${date}`, 
            //                     'value': date
            //                 });
            //             }
            //         }                    
            //     }
            //     return arr;
            // },
            stakeOptions() {
                let result = [{label: "None", value: ""}];
                for(let i = 0; i < 8; i++) {
                    result.push({
                        label: `${0.25*(i + 1).toFixed(2)}`,
                        value: 0.25 * (i + 1)
                    });
                }
                return result;
            },
            visibilityOptions() {
                let arr = [{
                        label: 'Public', 
                        value: 'public'
                    }, {
                        label: 'Private',
                        value: 'private'
                    }, {
                        label: 'None',
                        value: ''
                    }];
                return arr;
            },
            canPost() {                
                let result = true;
                if (this.main_model.routine_name) {
                    
                    result = false;
                    for(const prop in this.model) {
                        if (prop == 'note' || prop == 'cover_predictionType' || prop == 'cover_stake' || prop == 'strategy' || prop == 'date' || prop == 'overUnder' || prop == 'cover_overUnder' || prop == 'exclude_teams')
                            continue

                        let flag = this.model[prop];
                        if (((prop == 'country' || prop == 'league') && this.model[prop].length == 0) && this.model['teams'] == "")
                            flag = false
                        else if (((prop == 'country' || prop == 'league') && this.model[prop].length == 0) && this.model['teams'] != "")
                            flag = true
                        if (prop == 'teams' && this.model[prop] == "" && (this.model['country'].length == 0 || this.model['league'].length == 0)) 
                            flag = false;
                        else if (prop == 'teams' && this.model[prop] == "" && (this.model['country'].length > 0 && this.model['league'].length > 0)) 
                            flag = true;
                        
                        result = result || !flag;
                    }
                }
                console.log('canpost', result);
                return result;

            },
            cover_canPost() {
                let result = true;
                    
                if (this.model.cover_predictionType && this.model.cover_stake)
                    result = false;
                else if (!this.model.cover_predictionType && !this.model.cover_stake)
                    result = false;
                console.log('cover_canPost', result);
                return result;
            },

            leagueOptions() {
                var leagues = [];
                for (var i=0; i<this.model.country.length; i++) {
                    leagues = [
                        ...leagues,
                        ...this.model.country[i].leagues
                    ]
                }

                var leagueOptions = [
                    {
                      all: 'All leagues',
                      leagues: leagues
                    }
                ];
                console.log(leagueOptions)
                return leagueOptions;

            },
            overUnderOptions1() {
                var options = [];
                var predictionType = this.model.predictionType;
                if ( predictionType.includes('Over') ) {
                    options = [
                        { value: '0', label: '+0.5 Over'},
                        { value: '1', label: '+1.5 Over'},
                        { value: '2', label: '+2.5 Over'},
                        { value: '3', label: '+3.5 Over'},
                        { value: '', label: 'None'}
                    ]
                }
                else if ( predictionType.includes('Under') ) {
                    options = [
                        { value: '0', label: '+0.5 Under'},
                        { value: '1', label: '+1.5 Under'},
                        { value: '2', label: '+2.5 Under'},
                        { value: '3', label: '+3.5 Under'},
                        { value: '', label: 'None'}
                    ]
                }
                return options;

            },
            overUnderOptions2() {
                var options = [];
                var predictionType = this.model.cover_predictionType;
                if ( predictionType.includes('Over') ) {
                    options = [
                        { value: '0', label: '+0.5 Over'},
                        { value: '1', label: '+1.5 Over'},
                        { value: '2', label: '+2.5 Over'},
                        { value: '3', label: '+3.5 Over'},
                        { value: '', label: 'None'}
                    ]
                }
                else if ( predictionType.includes('Under') ) {
                    options = [
                        { value: '0', label: '+0.5 Under'},
                        { value: '1', label: '+1.5 Under'},
                        { value: '2', label: '+2.5 Under'},
                        { value: '3', label: '+3.5 Under'},
                        { value: '', label: 'None'}
                    ]
                }
                return options;

            },
            overUnderOptions1_2() {
                var options = [];
                var predictionType = this.model2.predictionType;
                if ( predictionType.includes('Over') ) {
                    options = [
                        { value: '0', label: '+0.5 Over'},
                        { value: '1', label: '+1.5 Over'},
                        { value: '2', label: '+2.5 Over'},
                        { value: '3', label: '+3.5 Over'},
                        { value: '', label: 'None'}
                    ]
                }
                else if ( predictionType.includes('Under') ) {
                    options = [
                        { value: '0', label: '+0.5 Under'},
                        { value: '1', label: '+1.5 Under'},
                        { value: '2', label: '+2.5 Under'},
                        { value: '3', label: '+3.5 Under'},
                        { value: '', label: 'None'}
                    ]
                }
                return options;

            },
            overUnderOptions2_2() {
                var options = [];
                var predictionType = this.model2.cover_predictionType;
                if ( predictionType.includes('Over') ) {
                    options = [
                        { value: '0', label: '+0.5 Over'},
                        { value: '1', label: '+1.5 Over'},
                        { value: '2', label: '+2.5 Over'},
                        { value: '3', label: '+3.5 Over'},
                        { value: '', label: 'None'}
                    ]
                }
                else if ( predictionType.includes('Under') ) {
                    options = [
                        { value: '0', label: '+0.5 Under'},
                        { value: '1', label: '+1.5 Under'},
                        { value: '2', label: '+2.5 Under'},
                        { value: '3', label: '+3.5 Under'},
                        { value: '', label: 'None'}
                    ]
                }
                return options;

            },
            overUnderOptions1_3() {
                var options = [];
                var predictionType = this.model3.predictionType;
                if ( predictionType.includes('Over') ) {
                    options = [
                        { value: '0', label: '+0.5 Over'},
                        { value: '1', label: '+1.5 Over'},
                        { value: '2', label: '+2.5 Over'},
                        { value: '3', label: '+3.5 Over'},
                        { value: '', label: 'None'}
                    ]
                }
                else if ( predictionType.includes('Under') ) {
                    options = [
                        { value: '0', label: '+0.5 Under'},
                        { value: '1', label: '+1.5 Under'},
                        { value: '2', label: '+2.5 Under'},
                        { value: '3', label: '+3.5 Under'},
                        { value: '', label: 'None'}
                    ]
                }
                return options;

            },
            overUnderOptions2_3() {
                var options = [];
                var predictionType = this.model3.cover_predictionType;
                if ( predictionType.includes('Over') ) {
                    options = [
                        { value: '0', label: '+0.5 Over'},
                        { value: '1', label: '+1.5 Over'},
                        { value: '2', label: '+2.5 Over'},
                        { value: '3', label: '+3.5 Over'},
                        { value: '', label: 'None'}
                    ]
                }
                else if ( predictionType.includes('Under') ) {
                    options = [
                        { value: '0', label: '+0.5 Under'},
                        { value: '1', label: '+1.5 Under'},
                        { value: '2', label: '+2.5 Under'},
                        { value: '3', label: '+3.5 Under'},
                        { value: '', label: 'None'}
                    ]
                }
                return options;

            }

        },
        methods: {
            ...mapActions([
                'getFixturesByDate',
                'autoPostTip',
                'getAutoPostTips',
                'getUserStrategies_mini',
                'postCashoutRef',
                'routineCloneAction',
                'routineStopAction',
                'routineStartAction',
                'routineDeleteAction',
                'routineEditAction',
                'getUsers'
            ]),
            update_strategy(evt) {
                if ( evt === "" )
                    return;

                this.getUserStrategies_mini({ id: evt }).then(({data}) => {
                    this.strategyOptions[0].items = [
                        
                    ];
                    data.forEach((dItem) => {
                        this.strategyOptions[0].items.push({
                            label: dItem.name,
                            value: dItem._id
                        })
                    });
                });
            },
            handleReset() {
                this.timeBeforeEvent = '';
                this.timeAfterEvent = '';
                this.timeBeforeEvent2 = '';
                this.timeAfterEvent2 = '';
                this.timeBeforeEvent3 = '';
                this.timeAfterEvent3 = '';
                this.timeBeforeEvent4 = '';
                this.timeAfterEvent4 = '';
                this.timeBeforeEvent5 = '';
                this.timeAfterEvent5 = '';
                this.routineId = null;
                this.status = 1;
                this.repeatDays = [
                    { value: "1", label: "Monday"},
                    { value: "2", label: "Tuesday"},
                    { value: "3", label: "Wednesday"},
                    { value: "4", label: "Thursday"},
                    { value: "5", label: "Friday"},
                    { value: "6", label: "Saturday"},
                    { value: "0", label: "Sunday"}
                ];
                this.main_model = {
                    routine_name: '',
                    repeat: '1 day',
                    desc: '',
                    user: ''
                };
                this.model = {
                    date: 0,
                    country: [],
                    league: [],
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: '',
                    teams: '',
                    team_side: 'Both',
                    exclude_team_side: 'Both',
                    exclude_teams: '',
                };
                this.model2 = {
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: ''
                };
                this.model3 = {
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: ''
                };
                this.model4 = {
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: ''
                };
                this.model5 = {
                    predictionType: '',
                    overUnder: '',
                    stake: '',
                    visibility: '',
                    strategy: [],
                    cover_predictionType: '',
                    cover_overUnder: '',
                    cover_stake: '',
                    note: ''
                };
                this.coldStat_model = {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },                    
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                };
                this.coldStat_model2 = {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                };
                this.coldStat_model3 = {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                };
                this.coldStat_model4 = {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                };
                this.coldStat_model5 = {
                    home: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    home4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away2: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away3: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    away4: {
                        check: false,
                        p: {
                            min: '',
                            max: ''
                        },
                        z_z: {
                            min: '',
                            max: ''
                        },
                        over15: {
                            min: '',
                            max: ''
                        },
                        over25:{
                            min: '',
                            max: ''
                        },
                        over35:{
                            min: '',
                            max: ''
                        },
                        scored:{
                            min: '',
                            max: ''
                        },
                        conc:{
                            min: '',
                            max: ''
                        },
                        bts:{
                            min: '',
                            max: ''
                        },
                        first1:{
                            min: '',
                            max: ''
                        },
                        first2:{
                            min: '',
                            max: ''
                        },
                        second1:{
                            min: '',
                            max: ''
                        },
                        second2:{
                            min: '',
                            max: ''
                        },
                        fh_percentage: {
                            min: '',
                            max: ''
                        },
                        sh_percentage: {
                            min: '',
                            max: ''
                        },
                        fh_probability: {
                            min: '',
                            max: ''
                        },
                        sh_probability: {
                            min: '',
                            max: ''
                        },
                    },
                    league: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league2: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league3: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    league4: {
                        check: false,
                        pos: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        h_a: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        FH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing2:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        SH:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        swing3:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        attack: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        defense: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        form:{
                            option: '',
                            min: '',
                            max: ''
                        },
                        form_H_A:{
                            option: '',
                            min: '',
                            max: ''
                        },
                    },
                    matches_percentage: {
                        min: '',
                        max: ''
                    },
                    timeBands: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands2: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands3: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },
                    timeBands4: {
                        check: false,
                        special_gPlus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gMinus: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time15_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time30_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time45_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time60_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time75_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_S: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        time90_C: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gs1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        special_gc1: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over40: {
                            option: '',
                            min: '',
                            max: ''
                        },
                        over85: {
                            option: '',
                            min: '',
                            max: ''
                        }
                    },

                };
                this.historicallivestats_model = {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                };
                this.historicallivestats_model2 = {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                };
                this.historicallivestats_model3 = {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                };
                this.historicallivestats_model4 = {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                };
                this.historicallivestats_model5 = {
                    goals: {
                        option: '',
                        value: ''
                    },
                    on: {
                        option: '',
                        value: ''
                    },
                    off: {
                        option: '',
                        value: ''
                    },
                    in: {
                        option: '',
                        value: ''
                    },
                    out: {
                        option: '',
                        value: ''
                    },
                    cnr: {
                        option: '',
                        value: ''
                    },                   
                    da: {
                        option: '',
                        value: ''
                    },
                    pos: {
                        option: '',
                        value: ''
                    },
                    sbst: {
                        option: '',
                        value: ''
                    },
                    rtg: {
                        option: '',
                        value: ''
                    },
                };
                this.valueStat_model = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                };
                this.valueStat_model2 = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                };
                this.valueStat_model3 = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                };
                this.valueStat_model4 = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                };
                this.valueStat_model5 = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    lastmatches: {
                        home: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        },
                        away: {
                            win: '',
                            draw: '',
                            lose: '',
                            option: ''
                        }
                    },
                    years: '',
                    stat_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    stat_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_1_10: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                    value_10_3: {
                        home: {
                            option: '',
                            offset: ''
                        },
                        draw: {
                            option: '',
                            offset: ''
                        },
                        away: {
                            option: '',
                            offset: ''
                        },
                        bts: {
                            option: '',
                            offset: ''
                        },
                        O_15: {
                            option: '',
                            offset: ''
                        },
                        O_25: {
                            option: '',
                            offset: ''
                        },
                        O_35: {
                            option: '',
                            offset: ''
                        }
                    },
                };
                this.leagueStat_model = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                };
                this.leagueStat_model2 = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                };
                this.leagueStat_model3 = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                };
                this.leagueStat_model4 = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                };
                this.leagueStat_model5 = {
                    stat: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    value: {
                        minOption: '',
                        minValue: '',
                        maxOption: '',
                        maxValue: '',
                    },
                    minMatches: '',
                    maxMatches: ''
                };
                this.teamAnalysis_model = {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                };
                this.teamAnalysis_model2 = {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                };
                this.teamAnalysis_model3 = {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                };
                this.teamAnalysis_model4 = {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                };
                this.teamAnalysis_model5 = {
                    home: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    away: {
                        minGK: '',
                        minDEF: '',
                        minMID: '',
                        minFWD: '',
                        maxGK: '',
                        maxDEF: '',
                        maxMID: '',
                        maxFWD: ''
                    },
                    pre: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    live: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    diff: {
                        df: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        mm: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        },
                        fd: {
                            option: '',
                            minValue: '',
                            maxValue: ''
                        }
                    },
                    home_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    away_upcoming: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: ''
                    },
                    home_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    away_latest: {
                        rank: {
                            min: '',
                            max: ''
                        },
                        day_left: {
                            min: '',
                            max: ''
                        },
                        league_type: '',
                        leg: '',
                        outcome: ''
                    },
                    keyPlayers: [
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        },
                        {
                            pre: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            live: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            home: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            away: {
                                option: '',
                                min: '',
                                max: ''
                            },
                            keyPlayers: {
                                option: '',
                                min: '',
                                max: ''
                            }
                        }
                    ]
                };
                this.cashout_teamAnalysis_model =  [
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    },
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    },
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    },
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    },
                    {
                        home: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        away: {
                            minGK: '',
                            minDEF: '',
                            minMID: '',
                            minFWD: '',
                            maxGK: '',
                            maxDEF: '',
                            maxMID: '',
                            maxFWD: ''
                        },
                        pre: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        live: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        diff: {
                            df: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            mm: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            },
                            fd: {
                                option: '',
                                minValue: '',
                                maxValue: ''
                            }
                        },
                        keyPlayers: [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ]
                    }
                ];
                this.livestats_model = {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                };
                this.livestats_model2 = {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                };
                this.livestats_model3 = {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                };
                this.livestats_model4 = {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                };
                this.livestats_model5 = {
                    status: '',
                    min_random: false,
                    minMinute: '',
                    maxMinute: '',
                    oddpre: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    oddlive: [
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                        {
                            check: false,
                            minOption: '',
                            minValue: '',
                            maxOption: '',
                            maxValue: ''
                        },
                    ],
                    minStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    maxStats: [
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                        {
                            check: false,
                            home: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            away: {
                                score: '',
                                on: '',
                                off: '',
                                corner: '',
                                rank: '',
                                red: '',
                                yel: '',
                                sbst: '',
                                ini: '',
                                pfm: '',
                                rtg: ''
                            },
                            score: {
                                fromtime: '',
                                totime: ''
                            },
                            on: {
                                fromtime: '',
                                totime: ''
                            },
                            off: {
                                fromtime: '',
                                totime: ''
                            },
                            corner: {
                                fromtime: '',
                                totime: ''
                            },
                            red: {
                                fromtime: '',
                                totime: ''
                            },
                            yel: {
                                fromtime: '',
                                totime: ''
                            },
                            sbst: {
                                fromtime: '',
                                totime: ''
                            },
                            rtg: {
                                fromtime: '',
                                totime: ''
                            }
                        },
                    ],
                    comparison: [
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                        {
                            check: false,
                            score: {
                                option: '',
                                value: ''
                            },
                            on: {
                                option: '',
                                value: ''
                            },
                            off: {
                                option: '',
                                value: ''
                            },
                            corner: {
                                option: '',
                                value: ''
                            },
                            rank: {
                                option: '',
                                value: ''
                            },
                            red: {
                                option: '',
                                value: ''
                            },
                            yel: {
                                option: '',
                                value: ''
                            },
                            sbst: {
                                option: '',
                                value: ''
                            },
                            ini: {
                                option: '',
                                value: ''
                            },
                            pfm: {
                                option: '',
                                value: ''
                            },
                            rtg: {
                                option: '',
                                value: ''
                            },
                        },
                    ],
                    time_from_to: [
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                        {
                            check: false,
                            over05: {
                                from: '',
                                to: ''
                            },
                            over15: {
                                from: '',
                                to: ''
                            },
                            over25: {
                                from: '',
                                to: ''
                            },
                            over35: {
                                from: '',
                                to: ''
                            },
                            under05: {
                                from: '',
                                to: ''
                            },
                            under15: {
                                from: '',
                                to: ''
                            },
                            under25: {
                                from: '',
                                to: ''
                            },
                            under35: {
                                from: '',
                                to: ''
                            },
                            home: {
                                from: '',
                                to: ''
                            },
                            draw: {
                                from: '',
                                to: ''
                            },
                            away: {
                                from: '',
                                to: ''
                            },
                            btsyes: {
                                from: '',
                                to: ''
                            },
                            btsno: {
                                from: '',
                                to: ''
                            },
                            over05ht: {
                                from: '',
                                to: ''
                            },
                            under05ht: {
                                from: '',
                                to: ''
                            },

                        },
                    ],
                };
                this.cashout_livestats_model = [
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    },
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    },
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    },
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    },
                    {
                        status: '',
                        min_random: false,
                        minMinute: '',
                        maxMinute: '',
                        oddpre: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        oddlive: [
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                            {
                                check: false,
                                minOption: '',
                                minValue: '',
                                maxOption: '',
                                maxValue: ''
                            },
                        ],
                        minStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        maxStats: [
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                            {
                                check: false,
                                home: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                away: {
                                    score: '',
                                    on: '',
                                    off: '',
                                    corner: '',
                                    rank: '',
                                    red: '',
                                    yel: '',
                                    sbst: '',
                                    ini: '',
                                    pfm: '',
                                    rtg: ''
                                },
                                score: {
                                    fromtime: '',
                                    totime: ''
                                },
                                on: {
                                    fromtime: '',
                                    totime: ''
                                },
                                off: {
                                    fromtime: '',
                                    totime: ''
                                },
                                corner: {
                                    fromtime: '',
                                    totime: ''
                                },
                                red: {
                                    fromtime: '',
                                    totime: ''
                                },
                                yel: {
                                    fromtime: '',
                                    totime: ''
                                },
                                sbst: {
                                    fromtime: '',
                                    totime: ''
                                },
                                rtg: {
                                    fromtime: '',
                                    totime: ''
                                }
                            },
                        ],
                        comparison: [
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                            {
                                check: false,
                                score: {
                                    option: '',
                                    value: ''
                                },
                                on: {
                                    option: '',
                                    value: ''
                                },
                                off: {
                                    option: '',
                                    value: ''
                                },
                                corner: {
                                    option: '',
                                    value: ''
                                },
                                rank: {
                                    option: '',
                                    value: ''
                                },
                                red: {
                                    option: '',
                                    value: ''
                                },
                                yel: {
                                    option: '',
                                    value: ''
                                },
                                sbst: {
                                    option: '',
                                    value: ''
                                },
                                ini: {
                                    option: '',
                                    value: ''
                                },
                                pfm: {
                                    option: '',
                                    value: ''
                                },
                                rtg: {
                                    option: '',
                                    value: ''
                                },
                            },
                        ],
                        time_from_to: [
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                            {
                                check: false,
                                over05: {
                                    from: '',
                                    to: ''
                                },
                                over15: {
                                    from: '',
                                    to: ''
                                },
                                over25: {
                                    from: '',
                                    to: ''
                                },
                                over35: {
                                    from: '',
                                    to: ''
                                },
                                under05: {
                                    from: '',
                                    to: ''
                                },
                                under15: {
                                    from: '',
                                    to: ''
                                },
                                under25: {
                                    from: '',
                                    to: ''
                                },
                                under35: {
                                    from: '',
                                    to: ''
                                },
                                home: {
                                    from: '',
                                    to: ''
                                },
                                draw: {
                                    from: '',
                                    to: ''
                                },
                                away: {
                                    from: '',
                                    to: ''
                                },
                                btsyes: {
                                    from: '',
                                    to: ''
                                },
                                btsno: {
                                    from: '',
                                    to: ''
                                },
                                over05ht: {
                                    from: '',
                                    to: ''
                                },
                                under05ht: {
                                    from: '',
                                    to: ''
                                },

                            },
                        ],
                    }
                ];
                this.cashout_model = [
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        }
                    },
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        }
                    },
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        }
                    },
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        }
                    },
                    {
                        tip: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        },
                        cover: {
                            status: 'no',
                            profitPts: '',
                            profitPercent: '',
                            stopLossPts: '',
                            stopLossPercent: '',
                            attemptToCashout: '',
                            timeFromPost: 0,
                            timeBeforeEvent: ''
                        }
                    }
                ];
                
                this.cashout_historicallivestats_model = [
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    },
                    {
                        goals: {
                            option: '',
                            value: ''
                        },
                        on: {
                            option: '',
                            value: ''
                        },
                        off: {
                            option: '',
                            value: ''
                        },
                        in: {
                            option: '',
                            value: ''
                        },
                        out: {
                            option: '',
                            value: ''
                        },
                        cnr: {
                            option: '',
                            value: ''
                        },                   
                        da: {
                            option: '',
                            value: ''
                        },
                        pos: {
                            option: '',
                            value: ''
                        },
                        sbst: {
                            option: '',
                            value: ''
                        },
                        rtg: {
                            option: '',
                            value: ''
                        },
                    }
                ];
                this.strategyStats_model = [
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                ];
                this.strategyFinancial_model = [
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                ];
                this.cashout_strategyFinancial_model = [
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},
                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},

                            },
                        ],
                        league: [
                           {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                            {
                                check: false,
                                last_bet: "",
                                sample: {min: "", max: ""},
                                win_rate: {min: "", max: ""},
                                profit_factor: {min: "", max: ""},
                                avg_entry_odds: {min: "", max: ""},

                                avg_cashout_odds: {min: "", max: ""},
                                avg_entry_back_odds: {min: "", max: ""},
                                avg_entry_lay_odds: {min: "", max: ""},

                                recent_max_win_repeat: {min: "", max: ""},
                                max_win_repeat: {min: "", max: ""},
                                recent_max_loss_repeat: {min: "", max: ""},
                                max_loss_repeat: {min: "", max: ""},

                                current_best: {min: "", max: ""},
                                current_worst: {min: "", max: ""},

                                win_current_avg: {min: "", max: ""},
                                win_current_trend1: {min: "", max: ""},
                                win_current_trend2: {min: "", max: ""},
                                win_avg_current: {min: "", max: ""},
                                win_trend1_current: {min: "", max: ""},
                                win_trend2_current: {min: "", max: ""},
                                win_avg_trend1: {min: "", max: ""},
                                win_avg_trend2: {min: "", max: ""},
                                win_trend1_avg: {min: "", max: ""},
                                win_trend2_avg: {min: "", max: ""},
                                win_trend1_best: {min: "", max: ""},
                                win_trend2_best: {min: "", max: ""},

                                loss_current_avg: {min: "", max: ""},
                                loss_current_trend1: {min: "", max: ""},
                                loss_current_trend2: {min: "", max: ""},
                                loss_avg_current: {min: "", max: ""},
                                loss_trend1_current: {min: "", max: ""},
                                loss_trend2_current: {min: "", max: ""},
                                loss_avg_trend1: {min: "", max: ""},
                                loss_avg_trend2: {min: "", max: ""},
                                loss_trend1_avg: {min: "", max: ""},
                                loss_trend2_avg: {min: "", max: ""},
                                loss_trend1_worst: {min: "", max: ""},
                                loss_trend2_worst: {min: "", max: ""},

                                win_avg: {min: "", max: ""},
                                win_trend1: {min: "", max: ""},
                                win_trend2: {min: "", max: ""},
                                loss_avg: {min: "", max: ""},
                                loss_trend1: {min: "", max: ""},
                                loss_trend2: {min: "", max: ""},
                            },
                        ]
                    },
                ];
                this.cashout_strategyStats_model = [
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                    {
                        strategy: "",
                        all: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        league: [
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                            {
                                check: false,
                                total_matches: {min: "", max: ""},
                                home_win_percent: {min: "", max: ""},
                                draw_win_percent: {min: "", max: ""},
                                away_win_percent: {min: "", max: ""},

                                avg_firsthalf_goals_percent: {min: "", max: ""},
                                avg_secondhalf_goals_percent: {min: "", max: ""},
                                avg_total_goals_percent: {min: "", max: ""},

                                first_05_percent: {min: "", max: ""},
                                first_15_percent: {min: "", max: ""},
                                first_25_percent: {min: "", max: ""},

                                full_05_percent: {min: "", max: ""},
                                full_15_percent: {min: "", max: ""},
                                full_25_percent: {min: "", max: ""},
                                full_35_percent: {min: "", max: ""},
                                full_45_percent: {min: "", max: ""},

                                bts_percent: {min: "", max: ""},

                                goal_bands_15_percent: {min: "", max: ""},
                                goal_bands_30_percent: {min: "", max: ""},
                                goal_bands_45_percent: {min: "", max: ""},
                                goal_bands_60_percent: {min: "", max: ""},
                                goal_bands_75_percent: {min: "", max: ""},
                                goal_bands_90_percent: {min: "", max: ""},

                                fts_h_percent: {min: "", max: ""},
                                fts_hw_percent: {min: "", max: ""},
                                fts_a_percent: {min: "", max: ""},
                                fts_aw_percent: {min: "", max: ""},

                                home_pt_percent:  {min: "", max: ""},
                                away_pt_percent:  {min: "", max: ""},
                                draw_pt_percent:  {min: "", max: ""},

                                sh_05_percent: {min: "", max: ""},
                                sh_15_percent: {min: "", max: ""},
                                sh_25_percent: {min: "", max: ""},

                                ht_firstGoal_min_avg:  {min: "", max: ""},
                                sh_firstGoal_min_avg:  {min: "", max: ""}
                            },
                        ],
                        special_strategyOptions_all: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ],
                        special_strategyOptions_league: [
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            },
                            {
                                check: false,
                                option: "",
                                min: "",
                                max: ""
                            }
                        ]
                    },
                ];

                this.sospesoPrediction_model = [
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    },
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    },
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    },
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    },
                    {
                        predictionType: '',
                        predictionFilter: '',
                        odds_min: '',
                        odds_max: '',
                        matches_min: '',
                        matches_max: ''
                    }                    
                ];

                this.allLeagues = [];
                this.leagueOptions = [];
                this.fixturesByDate = [];
                this.strategy = '';

            },
             handleTest() {
                console.log('repeat', this.main_model.repeat)
            },
            handlePostTip() {
                let postData = {
                    routineId: this.routineId,
                    eventOptions: this.eventOptions,
                    main_model: this.main_model,
                    repeatDays: this.repeatDays,

                    model: this.model,
                    model2: this.model2,
                    model3: this.model3,
                    model4: this.model4,
                    model5: this.model5,

                    valueStat_model: this.valueStat_model,
                    valueStat_model2: this.valueStat_model2,
                    valueStat_model3: this.valueStat_model3,
                    valueStat_model4: this.valueStat_model4,
                    valueStat_model5: this.valueStat_model5,
                    leagueStat_model: this.leagueStat_model,
                    leagueStat_model2: this.leagueStat_model2,
                    leagueStat_model3: this.leagueStat_model3,
                    leagueStat_model4: this.leagueStat_model4,
                    leagueStat_model5: this.leagueStat_model5,
                    teamAnalysis_model: this.teamAnalysis_model,
                    teamAnalysis_model2: this.teamAnalysis_model2,
                    teamAnalysis_model3: this.teamAnalysis_model3,
                    teamAnalysis_model4: this.teamAnalysis_model4,
                    teamAnalysis_model5: this.teamAnalysis_model5,

                    livestats_model: this.livestats_model,
                    livestats_model2: this.livestats_model2,
                    livestats_model3: this.livestats_model3,
                    livestats_model4: this.livestats_model4,
                    livestats_model5: this.livestats_model5,
                    
                    historicallivestats_model: this.historicallivestats_model,


                    cashout_model: this.cashout_model,
                    cashout_teamAnalysis_model: this.cashout_teamAnalysis_model,
                    cashout_historicallivestats_model: this.cashout_historicallivestats_model,
                    cashout_livestats_model: this.cashout_livestats_model,
                    status: this.status,

                    timeBeforeEvent: this.timeBeforeEvent,
                    timeAfterEvent: this.timeAfterEvent,

                    timeBeforeEvent2: this.timeBeforeEvent2,
                    timeAfterEvent2: this.timeAfterEvent2,
                    timeBeforeEvent3: this.timeBeforeEvent3,
                    timeAfterEvent3: this.timeAfterEven3,
                    timeBeforeEvent4: this.timeBeforeEvent4,
                    timeAfterEvent4: this.timeAfterEven4,
                    timeBeforeEvent5: this.timeBeforeEvent5,
                    timeAfterEvent5: this.timeAfterEven5,

                    coldStat_model: this.coldStat_model,
                    coldStat_model2: this.coldStat_model2,
                    coldStat_model3: this.coldStat_model3,
                    coldStat_model4: this.coldStat_model4,
                    coldStat_model5: this.coldStat_model5,

                    historicallivestats_model2: this.historicallivestats_model2,
                    historicallivestats_model3: this.historicallivestats_model3,
                    historicallivestats_model4: this.historicallivestats_model4,
                    historicallivestats_model5: this.historicallivestats_model5,

                    strategyStats_model: this.strategyStats_model,
                    cashout_strategyStats_model: this.cashout_strategyStats_model,
                    sospesoPrediction_model: this.sospesoPrediction_model,
                    strategyFinancial_model: this.strategyFinancial_model,
                    cashout_strategyFinancial_model: this.cashout_strategyFinancial_model
                }
                
                this.loading = true;
                try {
                    this.autoPostTip(postData).then((res) => {
                        var repeat = this.main_model.repeat;
                        if (repeat == 10000)
                            repeat = 'No limit';
                        let routine = {
                            _id: res._id,
                            name: this.main_model.routine_name,
                            repeat: repeat,
                            desc: this.main_model.desc,
                            status: this.status
                        };
                        console.log('===routine', routine)
                        if (this.routineId) {
                            let rIndex = this.routines.findIndex(item => item._id === this.routineId);
                            this.routines[rIndex] = routine;
                            console.log('==========rIndex', rIndex)

                        }
                        else
                            this.routines.push(routine);

                        this.handleReset();                        
                        displaySuccess(res);
                    });
                } catch(err) {
                    displayError(err);
                } finally {
                    
                    this.loading = false;
                }
                
            },           

            runTimer(activate = true) {
                this.current_counter = 0;
                //clear old timer
                if(this.loadingTimer)
                    clearInterval(this.loadingTimer);
                if(activate) {
                    this.loadingTimer = setInterval(() => {
                        this.current_counter ++;
                    }, 300);
                }
            }, 
                     
            
            sortJSON(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            },
            routineClone(_id){                
                let postData = {
                    _id: _id
                };
                this.routineCloneAction(postData).then((data) => {
                    console.log('data', data)

                    let rIndex = this.routines.findIndex(item => item._id === _id);

                    let routine = {
                        _id: data._id,
                        name: this.routines[rIndex].name,
                        repeat: this.routines[rIndex].repeat,
                        desc: this.routines[rIndex].desc,
                        status: 0
                    };
                    this.routines.push(routine);
                    this.routineKeys += 1;
                });
            },
            routineStop(_id){

                this.stop_loading = true;
                let postData = {
                    _id: _id
                };
                this.routineStopAction(postData).then(({data}) => {
                    let index = this.routines.findIndex(item => item._id === _id);
                    this.routines[index].status = 0;
                    this.stop_loading = false;
                    this.routineKeys += 1;
                });
            },
            routineStart(_id){
                this.start_loading = true;
                let postData = {
                    _id: _id
                };
                this.routineStartAction(postData).then(({data}) => {
                    let index = this.routines.findIndex(item => item._id === _id);
                    console.log('=========== index', index)
                    this.routines[index].status = 1;
                    this.start_loading = false;
                    this.routineKeys += 1;
                });
            },
            routineDelete(_id) {
                swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                            this.delete_loading = true;
                            let postData = {
                                _id: _id
                            };
                            this.routineDeleteAction(postData).then(({data}) => {
                                let index = this.routines.findIndex(item => item._id === _id);
                                this.routines.splice(index, 1);
                                this.delete_loading = false;
                                displaySuccess({message: 'Deleted routine successfully'})
                            })
                        }
                    });
                
            },
            initLiveModels() {
                var labels = [
                    'score',
                    'on',
                    'off',
                    'corner',
                    'red',
                    'yel',
                    'sbst',
                    'rtg',
                ];
                for (var i=0; i<labels.length; i++){
                    var label = labels[i];
                    this.livestats_model.minStats[label] = {
                        fromtime: '',
                        totime: ''
                    };
                    this.livestats_model.maxStats[label] = {
                        fromtime: '',
                        totime: ''
                    };
                    this.cashout_livestats_model.minStats[label] = {
                        fromtime: '',
                        totime: ''
                    };
                    this.cashout_livestats_model.maxStats[label] = {
                        fromtime: '',
                        totime: ''
                    };
                }
                
            },
            routineEdit(_id) {
                this.edit_loading = true;
                console.log('edit id', _id)
                let postData = {
                    _id: _id
                };
                this.routineEditAction(postData).then(({data}) => {
                    this.handleReset();
                    window.scrollTo(0,0);
                    // this.handleDateChange(data.model.date);
                    // this.eventOptions = data.eventOptions;
                    if (data.timeBeforeEvent === null)
                        this.timeBeforeEvent = '';
                    else
                        this.timeBeforeEvent = data.timeBeforeEvent;
                    
                    if (data.timeAfterEvent === null)
                        this.timeAfterEvent = '';
                    else
                        this.timeAfterEvent = data.timeAfterEvent;

                    if (data.timeBeforeEvent2)
                        this.timeBeforeEvent2 = data.timeBeforeEvent2;
                    if (data.timeAfterEven2)
                        this.timeAfterEven2 = data.timeAfterEven2;
                    if (data.timeBeforeEvent3)
                        this.timeBeforeEvent3 = data.timeBeforeEvent3;
                    if (data.timeAfterEven3)
                        this.timeAfterEven3 = data.timeAfterEven3;
                    if (data.timeBeforeEvent4)
                        this.timeBeforeEvent4 = data.timeBeforeEvent4;
                    if (data.timeAfterEven4)
                        this.timeAfterEven4 = data.timeAfterEven4;
                    if (data.timeBeforeEvent5)
                        this.timeBeforeEvent5 = data.timeBeforeEvent5;
                    if (data.timeAfterEven5)
                        this.timeAfterEven5 = data.timeAfterEven5;

                    this.main_model = data.main_model;
                    if (data.repeatDays)
                        this.repeatDays = data.repeatDays;
                    if (!data.main_model.user)
                        this.main_model.user = ""; 
                    
                    this.model = {
                        ...this.model,
                        ...data.model
                    };
                    if (data.model2)
                        this.model2 = data.model2;
                    if (data.model3)
                        this.model3 = data.model3;
                    if (data.model4)
                        this.model4 = data.model4;
                    if (data.model5)
                        this.model5 = data.model5;

                    if (data.coldStat_model) {
                        this.coldStat_model = data.coldStat_model;                       
                    }
                    if (data.coldStat_model2)
                        this.coldStat_model2 = data.coldStat_model2;
                    if (data.coldStat_model3)
                        this.coldStat_model3 = data.coldStat_model3;
                    if (data.coldStat_model4)
                        this.coldStat_model4 = data.coldStat_model4;
                    if (data.coldStat_model5)
                        this.coldStat_model5 = data.coldStat_model5;

                    if (data.historicallivestats_model)
                        this.historicallivestats_model = data.historicallivestats_model;
                    if (data.historicallivestats_model2)
                        this.historicallivestats_model2 = data.historicallivestats_model2;
                    if (data.historicallivestats_model3)
                        this.historicallivestats_model3 = data.historicallivestats_model3;
                    if (data.historicallivestats_model4)
                        this.historicallivestats_model4 = data.historicallivestats_model4;
                    if (data.historicallivestats_model5)
                        this.historicallivestats_model5 = data.historicallivestats_model5;

                    this.valueStat_model = data.valueStat_model;

                    if ( !this.valueStat_model.stat_1_3){
                        this.valueStat_model.stat_1_3 = {
                            home: {
                                option: '',
                                offset: ''
                            },
                            draw: {
                                option: '',
                                offset: ''
                            },
                            away: {
                                option: '',
                                offset: ''
                            },
                            bts: {
                                option: '',
                                offset: ''
                            },
                            O_15: {
                                option: '',
                                offset: ''
                            },
                            O_25: {
                                option: '',
                                offset: ''
                            },
                            O_35: {
                                option: '',
                                offset: ''
                            }
                        };
                        this.valueStat_model.stat_1_10 = {
                            home: {
                                option: '',
                                offset: ''
                            },
                            draw: {
                                option: '',
                                offset: ''
                            },
                            away: {
                                option: '',
                                offset: ''
                            },
                            bts: {
                                option: '',
                                offset: ''
                            },
                            O_15: {
                                option: '',
                                offset: ''
                            },
                            O_25: {
                                option: '',
                                offset: ''
                            },
                            O_35: {
                                option: '',
                                offset: ''
                            }
                        };
                        this.valueStat_model.stat_10_3 = {
                            home: {
                                option: '',
                                offset: ''
                            },
                            draw: {
                                option: '',
                                offset: ''
                            },
                            away: {
                                option: '',
                                offset: ''
                            },
                            bts: {
                                option: '',
                                offset: ''
                            },
                            O_15: {
                                option: '',
                                offset: ''
                            },
                            O_25: {
                                option: '',
                                offset: ''
                            },
                            O_35: {
                                option: '',
                                offset: ''
                            }
                        };
                        this.valueStat_model.value_1_3 = {
                            home: {
                                option: '',
                                offset: ''
                            },
                            draw: {
                                option: '',
                                offset: ''
                            },
                            away: {
                                option: '',
                                offset: ''
                            },
                            bts: {
                                option: '',
                                offset: ''
                            },
                            O_15: {
                                option: '',
                                offset: ''
                            },
                            O_25: {
                                option: '',
                                offset: ''
                            },
                            O_35: {
                                option: '',
                                offset: ''
                            }
                        };
                        this.valueStat_model.value_1_10 = {
                            home: {
                                option: '',
                                offset: ''
                            },
                            draw: {
                                option: '',
                                offset: ''
                            },
                            away: {
                                option: '',
                                offset: ''
                            },
                            bts: {
                                option: '',
                                offset: ''
                            },
                            O_15: {
                                option: '',
                                offset: ''
                            },
                            O_25: {
                                option: '',
                                offset: ''
                            },
                            O_35: {
                                option: '',
                                offset: ''
                            }
                        };
                        this.valueStat_model.value_10_3 = {
                            home: {
                                option: '',
                                offset: ''
                            },
                            draw: {
                                option: '',
                                offset: ''
                            },
                            away: {
                                option: '',
                                offset: ''
                            },
                            bts: {
                                option: '',
                                offset: ''
                            },
                            O_15: {
                                option: '',
                                offset: ''
                            },
                            O_25: {
                                option: '',
                                offset: ''
                            },
                            O_35: {
                                option: '',
                                offset: ''
                            }
                        };
                    }

                    if (data.valueStat_model2)
                        this.valueStat_model2 = data.valueStat_model2;
                    if (data.valueStat_model3)
                        this.valueStat_model3 = data.valueStat_model3;
                    if (data.valueStat_model4)
                        this.valueStat_model4 = data.valueStat_model4;
                    if (data.valueStat_model5)
                        this.valueStat_model5 = data.valueStat_model5;
                   
                    this.leagueStat_model = data.leagueStat_model;
                    if (data.leagueStat_model.minMatches === null) {
                        this.leagueStat_model.minMatches = '';
                        this.leagueStat_model.maxMatches = '';
                    }
                    if (data.leagueStat_model2)
                        this.leagueStat_model2 = data.leagueStat_model2;
                    if (data.leagueStat_model3)
                        this.leagueStat_model3 = data.leagueStat_model3;
                    if (data.leagueStat_model4)
                        this.leagueStat_model4 = data.leagueStat_model4;
                    if (data.leagueStat_model5)
                        this.leagueStat_model5 = data.leagueStat_model5;

                    this.teamAnalysis_model = data.teamAnalysis_model;
                    if (!data.teamAnalysis_model.home_upcoming) {
                        this.teamAnalysis_model.home_upcoming =  {
                            rank: {
                                min: '',
                                max: ''
                            },
                            day_left: {
                                min: '',
                                max: ''
                            },
                            league_type: '',
                            leg: ''
                        };
                        this.teamAnalysis_model.away_upcoming = {
                            rank: {
                                min: '',
                                max: ''
                            },
                            day_left: {
                                min: '',
                                max: ''
                            },
                            league_type: '',
                            leg: ''
                        };
                        this.teamAnalysis_model.home_latest = {
                            rank: {
                                min: '',
                                max: ''
                            },
                            day_left: {
                                min: '',
                                max: ''
                            },
                            league_type: '',
                            leg: '',
                            outcome: ''
                        };
                        this.teamAnalysis_model.away_latest = {
                            rank: {
                                min: '',
                                max: ''
                            },
                            day_left: {
                                min: '',
                                max: ''
                            },
                            league_type: '',
                            leg: '',
                            outcome: ''
                        };
                    }
                    if (data.teamAnalysis_model2){
                        this.teamAnalysis_model2 = data.teamAnalysis_model2;
                        if (data.teamAnalysis_model2.keyPlayers && !data.teamAnalysis_model2.keyPlayers[0].keyPlayers) {
                            data.teamAnalysis_model2.keyPlayers[0].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                            data.teamAnalysis_model2.keyPlayers[1].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                        }
                    }
                    if (data.teamAnalysis_model3){
                        this.teamAnalysis_model3 = data.teamAnalysis_model3;
                        if (data.teamAnalysis_model3.keyPlayers && !data.teamAnalysis_model3.keyPlayers[0].keyPlayers) {
                            data.teamAnalysis_model3.keyPlayers[0].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                            data.teamAnalysis_model3.keyPlayers[1].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                        }
                    }
                    if (data.teamAnalysis_model4){
                        this.teamAnalysis_model4 = data.teamAnalysis_model4;
                        if (data.teamAnalysis_model4.keyPlayers && !data.teamAnalysis_model4.keyPlayers[0].keyPlayers) {
                            data.teamAnalysis_model4.keyPlayers[0].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                            data.teamAnalysis_model4.keyPlayers[1].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                        }
                    }
                    if (data.teamAnalysis_model5){
                        this.teamAnalysis_model5 = data.teamAnalysis_model5;
                        if (data.teamAnalysis_model5.keyPlayers && !data.teamAnalysis_model5.keyPlayers[0].keyPlayers) {
                            data.teamAnalysis_model5.keyPlayers[0].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                            data.teamAnalysis_model5.keyPlayers[1].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                        }
                    }

                    if (!data.teamAnalysis_model.keyPlayers) {
                        this.teamAnalysis_model.keyPlayers = [
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            },
                            {
                                pre: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                live: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                home: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                away: {
                                    option: '',
                                    min: '',
                                    max: ''
                                },
                                keyPlayers: {
                                    option: '',
                                    min: '',
                                    max: ''
                                }
                            }
                        ];                        
                    }
                    else if (data.teamAnalysis_model.keyPlayers && !data.teamAnalysis_model.keyPlayers[0].keyPlayers) {
                        this.teamAnalysis_model.keyPlayers[0].keyPlayers = {
                            option: '',
                            min: '',
                            max: ''
                        };
                        this.teamAnalysis_model.keyPlayers[1].keyPlayers = {
                            option: '',
                            min: '',
                            max: ''
                        };
                    }

                    console.log('  teamAnalysis_model', this.teamAnalysis_model)
                    
                   

                    this.livestats_model = {
                        ...this.livestats_model,
                        ...data.livestats_model
                    };
                    if (data.livestats_model2) {
                        this.livestats_model2 = {
                            ...this.livestats_model2,
                            ...data.livestats_model2
                        };
                    }
                    if (data.livestats_model3){
                        this.livestats_model3 = {
                            ...this.livestats_model3,
                            ...data.livestats_model3
                        };
                    }
                    if (data.livestats_model4){
                        this.livestats_model4 = {
                            ...this.livestats_model4,
                            ...data.livestats_model4
                        };                        
                    }
                    if (data.livestats_model5){
                        this.livestats_model5 = {
                            ...this.livestats_model5,
                            ...data.livestats_model5
                        };                       
                    }

                    this.cashout_model = data.cashout_model;
                    if (data.cashout_teamAnalysis_model)
                        this.cashout_teamAnalysis_model = data.cashout_teamAnalysis_model;

                    for ( var c_index=0; c_index < this.cashout_teamAnalysis_model.length; c_index++) {
                        if (this.cashout_teamAnalysis_model[c_index].keyPlayers && !this.cashout_teamAnalysis_model[c_index].keyPlayers[0].keyPlayers) {
                            this.cashout_teamAnalysis_model[c_index].keyPlayers[0].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                            this.cashout_teamAnalysis_model[c_index].keyPlayers[1].keyPlayers = {
                                option: '',
                                min: '',
                                max: ''
                            };
                        }
                    }
                    console.log('  cashout_teamAnalysis_model', this.cashout_teamAnalysis_model)
                    //this.cashout_livestats_model = data.cashout_livestats_model;
                    this.cashout_livestats_model[0] = {
                        ...this.cashout_livestats_model[0],
                        ...data.cashout_livestats_model[0]
                    }
                    this.cashout_livestats_model[1] = {
                        ...this.cashout_livestats_model[1],
                        ...data.cashout_livestats_model[1]
                    }
                    this.cashout_livestats_model[2] = {
                        ...this.cashout_livestats_model[2],
                        ...data.cashout_livestats_model[2]
                    }
                    this.cashout_livestats_model[3] = {
                        ...this.cashout_livestats_model[3],
                        ...data.cashout_livestats_model[3]
                    }
                    this.cashout_livestats_model[4] = {
                        ...this.cashout_livestats_model[4],
                        ...data.cashout_livestats_model[4]
                    }

                    if (data.cashout_historicallivestats_model)
                        this.cashout_historicallivestats_model = data.cashout_historicallivestats_model;

                    if (data.strategyStats_model)
                        this.strategyStats_model = data.strategyStats_model;
                    if (data.cashout_strategyStats_model)
                        this.cashout_strategyStats_model = data.cashout_strategyStats_model;
                    if (data.strategyFinancial_model)
                        this.strategyFinancial_model = data.strategyFinancial_model;
                    if (data.cashout_strategyFinancial_model)
                        this.cashout_strategyFinancial_model = data.cashout_strategyFinancial_model;

                    if (data.sospesoPrediction_model)
                        this.sospesoPrediction_model = data.sospesoPrediction_model;

                    

                    this.routineId = _id;
                    this.status = data.status;
                    
                    this.edit_loading = false;
                })
            }
        },
       
        mounted() {
        },
        created() {
            //this.timer = setInterval(() => this.model.date && this.getCountriesByDate(this.model.date, false), 13000);
            this.getUserStrategies_mini({ id: 0 }).then(({data}) => {
                console.log("data===========..........", data)
                this.strategyOptions[0].items = [
                   
                ];
                data.forEach((dItem) => {
                    this.strategyOptions[0].items.push({
                        label: dItem.name,
                        value: dItem._id
                    })
                });
            });
            this.getUsers().then(({data}) => {
                this.userOptions = [
                    {label: 'None', value: ''}
                ];
                data.forEach((dItem) => {
                    this.userOptions.push({
                        label: dItem.display_name,
                        value: dItem._id
                    })
                });
            });
            this.getAutoPostTips().then(({data}) => {
                this.routines = data.result;
                console.log('routines', this.routines)
            });

            this.countryOptions[0].countries = this.country_league;


        },
        beforeDestroy() {
            if(this.timer)
                clearInterval(this.timer);
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
    .card_background{
        padding: 10px;
        padding-top: 26px;
    }

    .card_background > .card-body{
        background-color: #f5f5f5;
        border-radius: 10px;
        border: 1px solid lightgray;
    }
    .post-tip-container {
        .action-btns {
            button {
                min-width: 80px;
            }
        }
    }
    .best_top_select{
        width: 31.7%;
    }
    @media (max-width: 576px) {
      .best_top_select{
          width: 100%;
      }
    }
    .table_pre_row {
        background: rgba(193, 176, 215, 0.75);
        border-left: 1px solid white;
        height: 30px;
        padding: 0px;
        min-width: 100px;
    }
</style>